/*
* @license
* Broadcast Theme (c) Invisible Themes
*
* The contents of this file should not be modified.
* add any minor changes to assets/custom.js
*
*/
(function(themeCurrency, themeImages, themeAddresses, Sqrl, Flickity, Rellax, FlickityFade, AOS) {
    "use strict";
    function floatLabels(e) {
        e.querySelectorAll(".form-field").forEach((e=>{
            const t = e.querySelector("label")
              , s = e.querySelector("input, textarea");
            t && s && (s.addEventListener("keyup", (e=>{
                "" !== e.target.value ? t.classList.add("label--float") : t.classList.remove("label--float")
            }
            )),
            s.value && s.value.length && t.classList.add("label--float"))
        }
        ))
    }
    function readHeights() {
        const e = {};
        return e.windowHeight = window.innerHeight,
        e.announcementHeight = getHeight('[data-section-type*="announcement"]'),
        e.footerHeight = getHeight('[data-section-type*="footer"]'),
        e.menuHeight = getHeight("[data-header-height]"),
        e.headerHeight = e.menuHeight + e.announcementHeight,
        e.logoHeight = getFooterLogoWithPadding(),
        e
    }
    function setVarsOnResize() {
        document.addEventListener("theme:resize", resizeVars),
        setVars()
    }
    function setVars() {
        const {windowHeight: e, announcementHeight: t, headerHeight: s, logoHeight: i, menuHeight: o, footerHeight: r} = readHeights();
        document.documentElement.style.setProperty("--full-screen", `${e}px`),
        document.documentElement.style.setProperty("--three-quarters", e * (3 / 4) + "px"),
        document.documentElement.style.setProperty("--two-thirds", e * (2 / 3) + "px"),
        document.documentElement.style.setProperty("--one-half", e / 2 + "px"),
        document.documentElement.style.setProperty("--one-third", e / 3 + "px"),
        document.documentElement.style.setProperty("--menu-height", `${o}px`),
        document.documentElement.style.setProperty("--announcement-height", `${t}px`),
        document.documentElement.style.setProperty("--header-height", `${s}px`),
        document.documentElement.style.setProperty("--footer-height", `${r}px`),
        document.documentElement.style.setProperty("--content-full", e - s - i / 2 + "px"),
        document.documentElement.style.setProperty("--content-min", e - s - r + "px")
    }
    function resizeVars() {
        const {windowHeight: e, announcementHeight: t, headerHeight: s, logoHeight: i, menuHeight: o, footerHeight: r} = readHeights();
        document.documentElement.style.setProperty("--menu-height", `${o}px`),
        document.documentElement.style.setProperty("--announcement-height", `${t}px`),
        document.documentElement.style.setProperty("--header-height", `${s}px`),
        document.documentElement.style.setProperty("--footer-height", `${r}px`),
        document.documentElement.style.setProperty("--content-full", e - s - i / 2 + "px"),
        document.documentElement.style.setProperty("--content-min", e - s - r + "px")
    }
    function getHeight(e) {
        const t = document.querySelector(e);
        return t ? t.clientHeight : 0
    }
    function getFooterLogoWithPadding() {
        const e = getHeight("[data-footer-logo]");
        return e > 0 ? e + 20 : 0
    }
    function singles(e, t) {
        let s = 0;
        t.forEach((e=>{
            e.offsetHeight > s && (s = e.offsetHeight)
        }
        ));
        const i = e.querySelectorAll("[data-overflow-background]");
        [e, ...i].forEach((e=>{
            e.style.setProperty("min-height", `calc(${s + 64}px + var(--header-padding)`)
        }
        ))
    }
    function doubles(e) {
        if (window.innerWidth <= window.theme.sizes.small) {
            return void e.querySelectorAll("[data-overflow-frame]").forEach((e=>{
                const t = e.querySelectorAll("[data-overflow-content]");
                singles(e, t)
            }
            ))
        }
        let t = 0;
        const s = e.querySelectorAll("[data-overflow-frame]");
        e.querySelectorAll("[data-overflow-content]").forEach((e=>{
            e.offsetHeight > t && (t = e.offsetHeight)
        }
        ));
        const i = e.querySelectorAll("[data-overflow-background]");
        [e, ...s, ...i].forEach((e=>{
            e.style.setProperty("min-height", `${t + 64}px`)
        }
        ))
    }
    function preventOverflow(e) {
        const t = e.querySelectorAll(".js-overflow-container");
        t && t.forEach((e=>{
            const t = e.querySelectorAll(".js-overflow-content");
            singles(e, t),
            document.addEventListener("theme:resize", (()=>{
                singles(e, t)
            }
            ))
        }
        ));
        const s = e.querySelectorAll("[data-overflow-wrapper]");
        s && s.forEach((e=>{
            doubles(e),
            document.addEventListener("theme:resize", (()=>{
                doubles(e)
            }
            ))
        }
        ))
    }
    function debounce(e, t) {
        let s;
        return function() {
            if (e) {
                const i = ()=>e.apply(this, arguments);
                clearTimeout(s),
                s = setTimeout(i, t)
            }
        }
    }
    function dispatch() {
        document.dispatchEvent(new CustomEvent("theme:resize",{
            bubbles: !0
        }))
    }
    function resizeListener() {
        window.addEventListener("resize", debounce((function() {
            dispatch()
        }
        ), 50))
    }
    window.theme = window.theme || {},
    window.theme.sizes = {
        mobile: 480,
        small: 750,
        large: 990,
        widescreen: 1400
    },
    window.theme.keyboardKeys = {
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        LEFTARROW: 37,
        RIGHTARROW: 39
    },
    window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    let prev = window.pageYOffset
      , up = null
      , down = null
      , wasUp = null
      , wasDown = null
      , position = 0;
    function dispatch$1() {
        const e = window.pageYOffset;
        e > prev ? (down = !0,
        up = !1) : e < prev ? (down = !1,
        up = !0) : (up = null,
        down = null),
        prev = e,
        document.dispatchEvent(new CustomEvent("theme:scroll",{
            detail: {
                up: up,
                down: down,
                position: e
            },
            bubbles: !1
        })),
        up && !wasUp && document.dispatchEvent(new CustomEvent("theme:scroll:up",{
            detail: {
                position: e
            },
            bubbles: !1
        })),
        down && !wasDown && document.dispatchEvent(new CustomEvent("theme:scroll:down",{
            detail: {
                position: e
            },
            bubbles: !1
        })),
        wasDown = down,
        wasUp = up
    }
    function lock() {
        position = window.pageYOffset,
        document.documentElement.style.setProperty("scroll-behavior", "unset"),
        document.body.style.setProperty("position", "fixed"),
        document.body.style.setProperty("top", `-${position}px`),
        document.body.style.setProperty("left", "0"),
        document.body.style.setProperty("width", "100%"),
        document.body.style.setProperty("overflow", "hidden"),
        document.documentElement.setAttribute("data-scroll-locked", ""),
        document.documentElement.style.setProperty("position", "relative"),
        document.documentElement.style.setProperty("overflow", "hidden")
    }
    function unlock() {
        document.body.style.removeProperty("position"),
        document.body.style.removeProperty("top"),
        document.body.style.removeProperty("left"),
        document.body.style.removeProperty("width"),
        document.body.style.removeProperty("height"),
        document.body.style.removeProperty("overflow"),
        document.documentElement.removeAttribute("data-scroll-locked"),
        document.documentElement.style.removeProperty("position"),
        document.documentElement.style.removeProperty("overflow"),
        window.scroll({
            left: 0,
            top: position
        }),
        document.documentElement.style.setProperty("scroll-behavior", "smooth")
    }
    function scrollListener() {
        let e;
        window.addEventListener("scroll", (function() {
            e && window.cancelAnimationFrame(e),
            e = window.requestAnimationFrame((function() {
                dispatch$1()
            }
            ))
        }
        ), {
            passive: !0
        }),
        window.addEventListener("theme:scroll:lock", lock),
        window.addEventListener("theme:scroll:unlock", unlock)
    }
    function wasTouched() {
        window.theme.touched = !0,
        document.removeEventListener("touchstart", wasTouched, {
            passive: !0
        }),
        document.querySelector("body").classList.add("supports-touch"),
        document.dispatchEvent(new CustomEvent("theme:touch",{
            bubbles: !0
        }))
    }
    function getScript(e, t, s) {
        let i = document.getElementsByTagName("head")[0]
          , o = !1
          , r = document.createElement("script");
        r.src = e,
        r.onload = r.onreadystatechange = function() {
            o || this.readyState && "loaded" != this.readyState && "complete" != this.readyState ? s() : (o = !0,
            t())
        }
        ,
        i.appendChild(r)
    }
    document.addEventListener("touchstart", wasTouched, {
        passive: !0
    });
    const loaders = {};
    function loadScript(e={}) {
        if (e.type || (e.type = "json"),
        e.url)
            return loaders[e.url] ? loaders[e.url] : getScriptWithPromise(e.url, e.type);
        if (e.json)
            return loaders[e.json] ? Promise.resolve(loaders[e.json]) : window.fetch(e.json).then((e=>e.json())).then((t=>(loaders[e.json] = t,
            t)));
        if (e.name) {
            const t = "".concat(e.name, e.version);
            return loaders[t] ? loaders[t] : loadShopifyWithPromise(e)
        }
        return Promise.reject()
    }
    function getScriptWithPromise(e, t) {
        const s = new Promise(((s,i)=>{
            "text" === t ? fetch(e).then((e=>e.text())).then((e=>{
                s(e)
            }
            )).catch((e=>{
                i(e)
            }
            )) : getScript(e, (function() {
                s()
            }
            ), (function() {
                i()
            }
            ))
        }
        ));
        return loaders[e] = s,
        s
    }
    function loadShopifyWithPromise(e) {
        const t = "".concat(e.name, e.version)
          , s = new Promise(((t,s)=>{
            try {
                window.Shopify.loadFeatures([{
                    name: e.name,
                    version: e.version,
                    onLoad: e=>{
                        onLoadFromShopify(t, s, e)
                    }
                }])
            } catch (e) {
                s(e)
            }
        }
        ));
        return loaders[t] = s,
        s
    }
    function onLoadFromShopify(e, t, s) {
        return s ? t(s) : e()
    }
    const selectors = {
        popupContainer: ".pswp",
        popupCloseBtn: ".pswp__custom-close",
        popupIframe: "iframe",
        popupCustomIframe: ".pswp__custom-iframe",
        popupThumbs: ".pswp__thumbs",
        dataOptionClasses: "data-pswp-option-classes",
        dataVideoType: "data-video-type",
        dataDisableSound: "data-disable-sound",
        dataVideoId: "data-video-id"
    }
      , classes = {
        classCurrent: "is-current",
        classCustomLoader: "pswp--custom-loader",
        classCustomOpen: "pswp--custom-opening",
        classLoader: "pswp__loader",
        loaded: "loaded"
    }
      , loaderHTML = `<div class="${classes.classLoader}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`
      , players = []
      , loadVideoYT = (e,t,s)=>{
        const i = {
            height: "720",
            width: "1280",
            events: {
                onReady: function(e) {
                    e.target.getIframe().setAttribute("tabindex", "-1"),
                    s ? e.target.mute() : e.target.unMute(),
                    e.target.playVideo()
                },
                onStateChange: function(e) {
                    0 == e.data && e.target.playVideo(),
                    1 == e.data && e.target.getIframe().parentElement && e.target.getIframe().parentElement.classList.add(classes.loaded)
                }
            }
        }
          , o = Object.assign({}, i);
        o.videoId = t,
        t.length && (players[e] = new YT.Player(e,o))
    }
      , loadVideoVimeo = (e,t,s)=>{
        let i = "";
        const o = {
            url: "https://vimeo.com/" + e,
            background: !1,
            muted: s,
            autoplay: !0
        };
        for (let e in o)
            i += encodeURIComponent(e) + "=" + encodeURIComponent(o[e]) + "&";
        fetch(`https://vimeo.com/api/oembed.json?${i}`).then((e=>e.json())).then((function(e) {
            t.innerHTML = e.html,
            setTimeout((function() {
                t.parentElement.classList.add(classes.loaded)
            }
            ), 1e3)
        }
        )).catch((function() {
            console.log("error")
        }
        ))
    }
      , openPhotoSwipe = (e,t="")=>{
        const s = document.querySelectorAll(selectors.popupContainer)[0];
        if (s.classList.add(classes.classCustomOpen),
        s.classList.contains(classes.classCustomLoader) && "" !== t && t.mainClass) {
            s.setAttribute(selectors.dataOptionClasses, t.mainClass);
            let e = document.createElement("div");
            e.innerHTML = loaderHTML,
            e = e.firstChild,
            s.appendChild(e)
        } else
            s.setAttribute(selectors.dataOptionClasses, "");
        return loadScript({
            url: window.theme.assets.photoswipe
        }).then((()=>{
            const i = window.themePhotoswipe.PhotoSwipe.default
              , o = window.themePhotoswipe.PhotoSwipeUI.default
              , r = s.querySelector(selectors.popupThumbs);
            s.classList.contains(classes.classCustomLoader) && s.classList.remove(classes.classCustomLoader),
            s.classList.remove(classes.classCustomOpen);
            let n = {
                history: !1,
                focus: !1,
                mainClass: ""
            };
            "" !== t && (n = t);
            const a = new i(s,o,e,n);
            a.init();
            const l = s.querySelector(selectors.popupCustomIframe);
            if (l) {
                const e = l.getAttribute(selectors.dataVideoType)
                  , t = l.getAttribute(selectors.dataVideoId)
                  , s = "true" === l.getAttribute(selectors.dataDisableSound)
                  , i = l.id;
                "youtube" == e ? window.isYoutubeAPILoaded ? loadVideoYT(i, t, s) : (window.loadYoutubeAPI(),
                document.body.addEventListener("youtubeAPIReady", (()=>loadVideoYT(i, t, s)))) : "vimeo" == e && loadVideoVimeo(t, l, s)
            }
            const c = s.querySelector(selectors.popupCloseBtn);
            if (c && c.addEventListener("click", (function() {
                a.close()
            }
            )),
            a.listen("close", (function() {
                const e = s.querySelector(selectors.popupIframe);
                if (e && (e.setAttribute("src", ""),
                e.parentNode.removeChild(e)),
                r && r.firstChild)
                    for (; r.firstChild; )
                        r.removeChild(r.firstChild);
                s.setAttribute(selectors.dataOptionClasses, "");
                const t = s.querySelector(`.${classes.classLoader}`);
                t && s.removeChild(t)
            }
            )),
            r && r.firstChild) {
                const e = e=>{
                    e.stopPropagation()
                }
                ;
                r.addEventListener("wheel", e),
                r.addEventListener("mousewheel", e),
                r.addEventListener("DOMMouseScroll", e);
                const t = s.querySelectorAll(`${selectors.popupThumbs} > *`);
                t.forEach(((e,t)=>{
                    e.addEventListener("click", (function(e) {
                        e.preventDefault(),
                        this.parentElement.querySelector(`.${classes.classCurrent}`).classList.remove(classes.classCurrent),
                        this.classList.add(classes.classCurrent),
                        a.goTo(t)
                    }
                    ))
                }
                ));
                const i = ()=>{
                    const e = s.querySelector(`${selectors.popupThumbs} > .${classes.classCurrent}`);
                    e && e.classList.remove(classes.classCurrent);
                    const i = t[a.getCurrentIndex()]
                      , o = r.scrollLeft + r.offsetWidth
                      , n = i.offsetLeft
                      , l = n + i.offsetWidth;
                    if (i.classList.add(classes.classCurrent),
                    o <= l || o > n) {
                        const e = parseInt(window.getComputedStyle(i).marginLeft);
                        r.scrollTo({
                            top: 0,
                            left: n - e,
                            behavior: "smooth"
                        })
                    }
                }
                ;
                a.listen("imageLoadComplete", i),
                a.listen("beforeChange", i)
            }
        }
        )).catch((e=>console.error(e)))
    }
    ;
    function ariaToggle(e) {
        const t = e.querySelectorAll("[data-aria-toggle]");
        t.length && t.forEach((e=>{
            e.addEventListener("click", (function(e) {
                e.preventDefault();
                const t = e.currentTarget;
                t.setAttribute("aria-expanded", "false" == t.getAttribute("aria-expanded") ? "true" : "false");
                const s = t.getAttribute("aria-controls");
                document.querySelector(`#${s}`).classList.toggle("expanding"),
                setTimeout((function() {
                    document.querySelector(`#${s}`).classList.toggle("expanded")
                }
                ), 40)
            }
            ))
        }
        ))
    }
    function videoPopups(e) {
        const t = e.querySelectorAll("[data-video-popup]");
        t.length && t.forEach((e=>{
            e.addEventListener("click", (function(t) {
                const s = e.getAttribute("data-video-popup");
                if ("" !== s.trim()) {
                    t.preventDefault();
                    openPhotoSwipe([{
                        html: s
                    }])
                }
            }
            ))
        }
        ))
    }
    function lazyImageBackgrounds() {
        document.addEventListener("lazyloaded", (function(e) {
            const t = e.target.parentNode;
            t.classList.contains("lazy-image") && (t.style.backgroundImage = "none")
        }
        ))
    }
    resizeListener(),
    scrollListener(),
    lazyImageBackgrounds(),
    window.addEventListener("load", (()=>{
        setVarsOnResize(),
        floatLabels(document),
        preventOverflow(document),
        videoPopups(document),
        ariaToggle(document)
    }
    )),
    document.addEventListener("shopify:section:load", (e=>{
        const t = e.target;
        floatLabels(t),
        preventOverflow(t),
        videoPopups(t),
        ariaToggle(document)
    }
    )),
    function() {
        function e(e) {
            var t = window.innerWidth || document.documentElement.clientWidth
              , s = window.innerHeight || document.documentElement.clientHeight
              , i = e.getBoundingClientRect();
            return i.top >= 0 && i.bottom <= s && i.left >= 0 && i.right <= t
        }
        function t(e) {
            var t = window.innerWidth || document.documentElement.clientWidth
              , s = window.innerHeight || document.documentElement.clientHeight
              , i = e.getBoundingClientRect()
              , o = i.left >= 0 && i.left <= t || i.right >= 0 && i.right <= t
              , r = i.top >= 0 && i.top <= s || i.bottom >= 0 && i.bottom <= s;
            return o && r
        }
        window.visibilityHelper = {
            isElementTotallyVisible: e,
            isElementPartiallyVisible: t,
            inViewportPartially: function(e, s) {
                function i() {
                    var i = t(e);
                    i != o && (o = i,
                    "function" == typeof s && s(i, e))
                }
                var o = t(e);
                window.addEventListener("load", i),
                window.addEventListener("resize", i),
                window.addEventListener("scroll", i)
            },
            inViewportTotally: function(t, s) {
                function i() {
                    var i = e(t);
                    i != o && (o = i,
                    "function" == typeof s && s(i, t))
                }
                var o = e(t);
                window.addEventListener("load", i),
                window.addEventListener("resize", i),
                window.addEventListener("scroll", i)
            }
        }
    }();
    const showElement = (e,t=!1,s="block")=>{
        e && (t ? e.style.removeProperty("display") : e.style.display = s)
    }
    ;
    Shopify.Products = function() {
        const e = {
            howManyToShow: 4,
            howManyToStoreInMemory: 10,
            wrapperId: "recently-viewed-products",
            templateId: "recently-viewed-product-template",
            onComplete: null
        };
        let t = []
          , s = null
          , i = null;
        const o = {
            configuration: {
                expires: 90,
                path: "/",
                domain: window.location.hostname
            },
            name: "shopify_recently_viewed",
            write: function(e) {
                const t = e.join(" ");
                document.cookie = `${this.name}=${t}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`
            },
            read: function() {
                let e = []
                  , t = null;
                const s = document.querySelector("#template-product");
                if (s) {
                    const i = s.getAttribute("data-product-handle");
                    if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((e=>e.startsWith(this.name))) && (t = document.cookie.split("; ").find((e=>e.startsWith(this.name))).split("=")[1]),
                    null !== t && (e = t.split(" ")),
                    -1 != e.indexOf(i)) {
                        const t = e.indexOf(i);
                        e.splice(t, 1)
                    }
                }
                return e
            },
            destroy: function() {
                document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`
            },
            remove: function(e) {
                const t = this.read()
                  , s = t.indexOf(e);
                -1 !== s && (t.splice(s, 1),
                this.write(t))
            }
        }
          , r = n=>{
            t.length && n < e.howManyToShow ? fetch("/products/" + t[0] + ".js").then((e=>e.json())).then((e=>{
                e.priceFormatted = themeCurrency.formatMoney(e.price, theme.moneyFormat),
                e.compareFormatted = themeCurrency.formatMoney(e.compare_at_price, theme.moneyFormat),
                e.topImage = e.media[0] ? themeImages.getSizedImageUrl(e.media[0].preview_image.src, "900x900") : "",
                e.bottomImage = e.media[1] ? themeImages.getSizedImageUrl(e.media[1].preview_image.src, "900x900") : "";
                let o = ""
                  , a = ""
                  , l = "is-hidden hidden"
                  , c = "";
                e.media.length > 1 ? o = "double__image" : a = "is-hidden hidden",
                e.compare_at_price > e.price && (c = "sale",
                l = "");
                let d = i.innerHTML;
                d = d.replace(/\|\|itemUrl\|\|/g, e.url),
                d = d.replace(/\|\|itemDoubleImageClass\|\|/g, o),
                d = d.replace(/\|\|itemTopImage\|\|/g, e.topImage),
                d = d.replace(/\|\|itemBottomImage\|\|/g, e.bottomImage),
                d = d.replace(/\|\|itemBottomImageClass\|\|/g, a),
                d = d.replace(/\|\|itemSaleClass\|\|/g, l),
                d = d.replace(/\|\|itemPriceClass\|\|/g, c),
                d = d.replace(/\|\|itemTitle\|\|/g, e.title),
                d = d.replace(/\|\|itemComparedPrice\|\|/g, e.compareFormatted),
                d = d.replace(/\|\|itemPrice\|\|/g, e.priceFormatted),
                d = d.replace(/\|\|itemHandle\|\|/g, e.handle),
                s.innerHTML += d,
                t.shift(),
                n++,
                r(n)
            }
            )).catch((e=>{
                o.remove(t[0]),
                t.shift(),
                r(n)
            }
            )) : (()=>{
                if (showElement(s, !0),
                e.onComplete)
                    try {
                        e.onComplete()
                    } catch (e) {}
            }
            )()
        }
        ;
        return {
            showRecentlyViewed: function(n) {
                const a = n || {};
                Object.assign(e, a),
                t = o.read(),
                i = document.querySelector(`#${e.templateId}`),
                s = document.querySelector(`#${e.wrapperId}`),
                e.howManyToShow = Math.min(t.length, e.howManyToShow),
                e.howManyToShow && i && s && r(0)
            },
            getConfig: function() {
                return e
            },
            clearList: function() {
                o.destroy()
            },
            recordRecentlyViewed: function(t) {
                const s = t || {};
                Object.assign(e, s);
                let i = o.read();
                if (-1 !== window.location.pathname.indexOf("/products/")) {
                    const t = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1]
                      , s = i.indexOf(t);
                    -1 === s ? (i.unshift(t),
                    i = i.splice(0, e.howManyToStoreInMemory)) : (i.splice(s, 1),
                    i.unshift(t)),
                    o.write(i)
                }
            },
            hasProducts: o.read().length > 0
        }
    }();
    const getUrlString = (e,t=[],s=!1)=>{
        const i = Object.keys(e).map((i=>{
            let o = e[i];
            if ("[object Object]" === Object.prototype.toString.call(o) || Array.isArray(o))
                return Array.isArray(e) ? t.push("") : t.push(i),
                getUrlString(o, t, Array.isArray(o));
            {
                let e = i;
                if (t.length > 0) {
                    e = (s ? t : [...t, i]).reduce(((e,t)=>"" === e ? t : `${e}[${t}]`), "")
                }
                return s ? `${e}[]=${o}` : `${e}=${o}`
            }
        }
        )).join("&");
        return t.pop(),
        i
    }
      , hideElement = e=>{
        e && (e.style.display = "none")
    }
      , fadeIn = (e,t,s=null)=>{
        e.style.opacity = 0,
        e.style.display = t || "block",
        function t() {
            let i = parseFloat(e.style.opacity);
            (i += .1) > 1 || (e.style.opacity = i,
            requestAnimationFrame(t)),
            1 === i && "function" == typeof s && s()
        }()
    }
    ;
    function forceFocus(e, t) {
        t = t || {};
        var s = e.tabIndex;
        e.tabIndex = -1,
        e.dataset.tabIndex = s,
        e.focus(),
        void 0 !== t.className && e.classList.add(t.className),
        e.addEventListener("blur", (function i(o) {
            o.target.removeEventListener(o.type, i),
            e.tabIndex = s,
            delete e.dataset.tabIndex,
            void 0 !== t.className && e.classList.remove(t.className)
        }
        ))
    }
    function focusHash(e) {
        e = e || {};
        var t = window.location.hash
          , s = document.getElementById(t.slice(1));
        if (s && e.ignore && s.matches(e.ignore))
            return !1;
        t && s && forceFocus(s, e)
    }
    function bindInPageLinks(e) {
        return e = e || {},
        Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((function(t) {
            if ("#" === t.hash || "" === t.hash)
                return !1;
            if (e.ignore && t.matches(e.ignore))
                return !1;
            if (s = t.hash.substr(1),
            null === document.getElementById(s))
                return !1;
            var s, i = document.querySelector(t.hash);
            return !!i && (t.addEventListener("click", (function() {
                forceFocus(i, e)
            }
            )),
            !0)
        }
        ))
    }
    function focusable(e) {
        return Array.prototype.slice.call(e.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled")).filter((function(e) {
            return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
        }
        ))
    }
    void 0 === Shopify.Cart && (Shopify.Cart = {}),
    Shopify.Cart.ShippingCalculator = function() {
        const _config = {
            submitButton: theme.strings.shippingCalcSubmitButton,
            submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
            templateId: "shipping-calculator-response-template",
            wrapperId: "wrapper-response",
            customerIsLoggedIn: !1
        }
          , _render = function(e) {
            const t = document.querySelector(`#${_config.templateId}`)
              , s = document.querySelector(`#${_config.wrapperId}`);
            if (t && s) {
                s.innerHTML = "";
                let i = ""
                  , o = ""
                  , r = "error center"
                  , n = t.innerHTML;
                const a = /[^[\]]+(?=])/g;
                if (e.rates && e.rates.length) {
                    let t = a.exec(n)[0];
                    e.rates.forEach((e=>{
                        let s = t;
                        s = s.replace(/\|\|rateName\|\|/, e.name),
                        s = s.replace(/\|\|ratePrice\|\|/, Shopify.Cart.ShippingCalculator.formatRate(e.price)),
                        i += s
                    }
                    ))
                }
                if (e.success) {
                    r = "success center";
                    const s = document.createElement("div");
                    s.innerHTML = t.innerHTML;
                    const i = s.querySelector("[data-template-no-shipping]");
                    e.rates.length < 1 && i && (o = i.getAttribute("data-template-no-shipping"))
                } else
                    o = e.errorFeedback;
                n = n.replace(a, "").replace("[]", ""),
                n = n.replace(/\|\|ratesList\|\|/g, i),
                n = n.replace(/\|\|successClass\|\|/g, r),
                n = n.replace(/\|\|ratesText\|\|/g, o),
                s.innerHTML += n
            }
        }
          , _enableButtons = function() {
            const e = document.querySelector(".get-rates");
            e.removeAttribute("disabled"),
            e.classList.remove("disabled"),
            e.value = _config.submitButton
        }
          , _disableButtons = function() {
            const e = document.querySelector(".get-rates");
            e.setAttribute("disabled", "disabled"),
            e.classList.add("disabled"),
            e.value = _config.submitButtonDisabled
        }
          , _getCartShippingRatesForDestination = function(e) {
            const t = encodeURI(getUrlString({
                shipping_address: e
            }))
              , s = `${window.theme.routes.cart}/shipping_rates.json?${t}`
              , i = new XMLHttpRequest;
            i.open("GET", s, !0),
            i.onload = function() {
                if (this.status >= 200 && this.status < 400) {
                    const t = JSON.parse(this.response).shipping_rates;
                    _onCartShippingRatesUpdate(t, e)
                } else
                    _onError(this)
            }
            ,
            i.onerror = function() {
                _onError(this)
            }
            ,
            i.send()
        }
          , _fullMessagesFromErrors = function(e) {
            const t = [];
            for (const s in e)
                for (const i of e[s])
                    t.push(s + " " + i);
            return t
        }
          , _onError = function(XMLHttpRequest) {
            hideElement(document.querySelector("#estimated-shipping"));
            const shippingChild = document.querySelector("#estimated-shipping em");
            if (shippingChild)
                for (; shippingChild.firstChild; )
                    shippingChild.removeChild(shippingChild.firstChild);
            _enableButtons();
            let feedback = "";
            const data = eval("(" + XMLHttpRequest.responseText + ")");
            feedback = data.message ? data.message + "(" + data.status + "): " + data.description : "Error : " + _fullMessagesFromErrors(data).join("; "),
            "Error : country is not supported." === feedback && (feedback = "We do not ship to this destination."),
            _render({
                rates: [],
                errorFeedback: feedback,
                success: !1
            }),
            showElement(document.querySelector(`#${_config.wrapperId}`))
        }
          , _onCartShippingRatesUpdate = function(e, t) {
            _enableButtons();
            let s = "";
            t.zip && (s += t.zip + ", "),
            t.province && (s += t.province + ", "),
            s += t.country;
            const i = document.querySelector("#estimated-shipping em");
            e.length && i && ("0.00" == e[0].price ? i.textContent = "FREE" : i.textContent = themeCurrency.formatMoney(e[0].price, theme.moneyFormat)),
            _render({
                rates: e,
                address: s,
                success: !0
            });
            const o = document.querySelectorAll(`#${_config.wrapperId}, #estimated-shipping`);
            o.length && o.forEach((e=>{
                fadeIn(e)
            }
            ))
        }
          , _init = function() {
            const e = document.querySelector(".get-rates")
              , t = document.querySelector("#address_container")
              , s = document.querySelector("#address_country")
              , i = document.querySelector("#address_province")
              , o = document.querySelector("html");
            let r = "en";
            o.hasAttribute("lang") && "" !== o.getAttribute("lang") && (r = o.getAttribute("lang")),
            t && themeAddresses.AddressForm(t, r, {
                shippingCountriesOnly: !0
            }),
            s && s.hasAttribute("data-default") && i && i.hasAttribute("data-default") && s.addEventListener("change", (function() {
                s.removeAttribute("data-default"),
                i.removeAttribute("data-default")
            }
            )),
            e && (e.addEventListener("click", (function(e) {
                _disableButtons();
                const t = document.querySelector(`#${_config.wrapperId}`);
                for (; t.firstChild; )
                    t.removeChild(t.firstChild);
                hideElement(t);
                const o = {};
                let r = s.value
                  , n = i.value;
                const a = s.getAttribute("data-default-fullname");
                "" === r && a && "" !== a && (r = a);
                const l = i.getAttribute("data-default-fullname");
                "" === n && l && "" !== l && (n = l),
                o.zip = document.querySelector("#address_zip").value || "",
                o.country = r || "",
                o.province = n || "",
                _getCartShippingRatesForDestination(o)
            }
            )),
            _config.customerIsLoggedIn && e.classList.contains("get-rates--trigger") && e.dispatchEvent(new Event("click")))
        };
        return {
            show: function(e) {
                e = e || {},
                Object.assign(_config, e),
                document.addEventListener("DOMContentLoaded", (function() {
                    _init()
                }
                ))
            },
            getConfig: function() {
                return _config
            },
            formatRate: function(e) {
                return themeCurrency.formatMoney(e, theme.moneyFormat)
            }
        }
    }();
    var trapFocusHandlers = {};
    function trapFocus(e, t) {
        t = t || {};
        var s = focusable(e)
          , i = t.elementToFocus || e
          , o = s[0]
          , r = s[s.length - 1];
        removeTrapFocus(),
        trapFocusHandlers.focusin = function(t) {
            e === t.target || e.contains(t.target) || o.focus(),
            t.target !== e && t.target !== r && t.target !== o || document.addEventListener("keydown", trapFocusHandlers.keydown)
        }
        ,
        trapFocusHandlers.focusout = function() {
            document.removeEventListener("keydown", trapFocusHandlers.keydown)
        }
        ,
        trapFocusHandlers.keydown = function(t) {
            9 === t.keyCode && (t.target !== r || t.shiftKey || (t.preventDefault(),
            o.focus()),
            t.target !== e && t.target !== o || !t.shiftKey || (t.preventDefault(),
            r.focus()))
        }
        ,
        document.addEventListener("focusout", trapFocusHandlers.focusout),
        document.addEventListener("focusin", trapFocusHandlers.focusin),
        forceFocus(i, t)
    }
    function removeTrapFocus() {
        document.removeEventListener("focusin", trapFocusHandlers.focusin),
        document.removeEventListener("focusout", trapFocusHandlers.focusout),
        document.removeEventListener("keydown", trapFocusHandlers.keydown)
    }
    function accessibleLinks(e, t) {
        if ("string" != typeof e)
            throw new TypeError(e + " is not a String.");
        if (0 !== (e = document.querySelectorAll(e)).length) {
            (t = t || {}).messages = t.messages || {};
            var s = {
                newWindow: t.messages.newWindow || "Opens in a new window.",
                external: t.messages.external || "Opens external website.",
                newWindowExternal: t.messages.newWindowExternal || "Opens external website in a new window."
            }
              , i = t.prefix || "a11y"
              , o = {
                newWindow: i + "-new-window-message",
                external: i + "-external-message",
                newWindowExternal: i + "-new-window-external-message"
            };
            e.forEach((function(e) {
                var t = e.getAttribute("target")
                  , s = e.getAttribute("rel")
                  , i = function(e) {
                    return e.hostname !== window.location.hostname
                }(e)
                  , r = "_blank" === t
                  , n = null === s || -1 === s.indexOf("noopener");
                if (r && n) {
                    var a = null === s ? "noopener" : s + " noopener";
                    e.setAttribute("rel", a)
                }
                i && r ? e.setAttribute("aria-describedby", o.newWindowExternal) : i ? e.setAttribute("aria-describedby", o.external) : r && e.setAttribute("aria-describedby", o.newWindow)
            }
            )),
            function(e) {
                var t = document.createElement("ul")
                  , s = Object.keys(e).reduce((function(t, s) {
                    return t + "<li id=" + o[s] + ">" + e[s] + "</li>"
                }
                ), "");
                t.setAttribute("hidden", !0),
                t.innerHTML = s,
                document.body.appendChild(t)
            }(s)
        }
    }
    var a11y = Object.freeze({
        __proto__: null,
        forceFocus: forceFocus,
        focusHash: focusHash,
        bindInPageLinks: bindInPageLinks,
        focusable: focusable,
        trapFocus: trapFocus,
        removeTrapFocus: removeTrapFocus,
        accessibleLinks: accessibleLinks
    });
    const slideDown = (e,t=500,s=!0)=>{
        let i = window.getComputedStyle(e).display;
        if (s && "none" !== i)
            return;
        e.style.removeProperty("display"),
        "none" === i && (i = "block"),
        e.style.display = i;
        let o = e.offsetHeight;
        e.style.overflow = "hidden",
        e.style.height = 0,
        e.style.paddingTop = 0,
        e.style.paddingBottom = 0,
        e.style.marginTop = 0,
        e.style.marginBottom = 0,
        e.offsetHeight,
        e.style.boxSizing = "border-box",
        e.style.transitionProperty = "height, margin, padding",
        e.style.transitionDuration = t + "ms",
        e.style.height = o + "px",
        e.style.removeProperty("padding-top"),
        e.style.removeProperty("padding-bottom"),
        e.style.removeProperty("margin-top"),
        e.style.removeProperty("margin-bottom"),
        window.setTimeout((()=>{
            e.style.removeProperty("height"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property")
        }
        ), t)
    }
      , slideUp = (e,t=500)=>{
        e.style.transitionProperty = "height, margin, padding",
        e.style.transitionDuration = t + "ms",
        e.style.boxSizing = "border-box",
        e.style.height = e.offsetHeight + "px",
        e.offsetHeight,
        e.style.overflow = "hidden",
        e.style.height = 0,
        e.style.paddingTop = 0,
        e.style.paddingBottom = 0,
        e.style.marginTop = 0,
        e.style.marginBottom = 0,
        window.setTimeout((()=>{
            e.style.display = "none",
            e.style.removeProperty("height"),
            e.style.removeProperty("padding-top"),
            e.style.removeProperty("padding-bottom"),
            e.style.removeProperty("margin-top"),
            e.style.removeProperty("margin-bottom"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property")
        }
        ), t)
    }
      , slideToggle = (e,t=500)=>"none" === window.getComputedStyle(e).display ? slideDown(e, t) : slideUp(e, t)
      , getSiblings = e=>Array.prototype.filter.call(e.parentNode.children, (function(t) {
        return t !== e
    }
    ));
    function FetchError(e) {
        this.status = e.status || null,
        this.headers = e.headers || null,
        this.json = e.json || null,
        this.body = e.body || null
    }
    FetchError.prototype = Error.prototype;
    const selectors$1 = {
        quantityHolder: "[data-quantity-holder]",
        quantityField: "[data-quantity-field]",
        quantityButton: "[data-quantity-button]",
        quantityMinusButton: "[data-quantity-minus]",
        quantityPlusButton: "[data-quantity-plus]",
        quantityReadOnly: "read-only",
        isDisabled: "is-disabled"
    };
    class QuantityCounter {
        constructor(e, t=!1) {
            this.holder = e,
            this.quantityUpdateCart = t
        }
        init() {
            this.settings = selectors$1,
            this.quantity = this.holder.querySelector(this.settings.quantityHolder),
            this.field = this.quantity.querySelector(this.settings.quantityField),
            this.buttons = this.quantity.querySelectorAll(this.settings.quantityButton),
            this.increaseButton = this.quantity.querySelector(this.settings.quantityPlusButton),
            this.quantityValue = Number(this.field.value || 0),
            this.cartItemID = this.field.getAttribute("data-id"),
            this.maxValue = Number(this.field.getAttribute("max")) > 0 ? Number(this.field.getAttribute("max")) : null,
            this.minValue = Number(this.field.getAttribute("min")) > 0 ? Number(this.field.getAttribute("min")) : 0,
            this.disableIncrease = this.disableIncrease.bind(this),
            this.emptyField = !1,
            this.updateQuantity = this.updateQuantity.bind(this),
            this.decrease = this.decrease.bind(this),
            this.increase = this.increase.bind(this),
            this.disableIncrease(),
            this.quantity.classList.contains(this.settings.quantityReadOnly) || (this.changeValueOnClick(),
            this.changeValueOnInput())
        }
        changeValueOnClick() {
            const e = this;
            this.buttons.forEach((t=>{
                t.addEventListener("click", (t=>{
                    t.preventDefault();
                    const s = t.target
                      , i = s.matches(e.settings.quantityMinusButton) || s.closest(e.settings.quantityMinusButton)
                      , o = s.matches(e.settings.quantityPlusButton) || s.closest(e.settings.quantityPlusButton);
                    i && e.decrease(),
                    o && e.increase(),
                    e.updateQuantity()
                }
                ))
            }
            ))
        }
        changeValueOnInput() {
            const e = this;
            this.field.addEventListener("input", (function() {
                e.quantityValue = this.value,
                "" === this.value && (e.emptyField = !0),
                e.updateQuantity()
            }
            ), this)
        }
        updateQuantity() {
            this.maxValue < this.quantityValue && null !== this.maxValue && (this.quantityValue = this.maxValue),
            this.minValue > this.quantityValue && (this.quantityValue = this.minValue),
            this.field.value = this.quantityValue,
            this.disableIncrease(),
            this.quantityUpdateCart && this.updateCart()
        }
        decrease() {
            this.quantityValue > this.minValue ? this.quantityValue-- : this.quantityValue = 0
        }
        increase() {
            this.quantityValue++
        }
        disableIncrease() {
            this.increaseButton.classList.toggle(this.settings.isDisabled, this.quantityValue >= this.maxValue && null !== this.maxValue)
        }
        updateCart() {
            const e = new CustomEvent("update-cart",{
                bubbles: !0,
                detail: {
                    id: this.cartItemID,
                    quantity: this.quantityValue,
                    valueIsEmpty: this.emptyField
                }
            });
            this.holder.dispatchEvent(e)
        }
    }
    const settings = {
        cartDropdownIsEnable: window.theme.cartDropdownIsEnable,
        times: {
            timeoutAddProduct: 1e3,
            closeDropdownAfter: 5e3
        },
        classes: {
            hidden: "is-hidden",
            htmlClasses: "has-open-cart-dropdown",
            open: "is-open",
            active: "is-active",
            visible: "is-visible",
            loading: "is-loading",
            disabled: "is-disabled"
        },
        elements: {
            html: "html",
            cartDropdown: "#cart-dropdown",
            emptyMessage: "[data-empty-message]",
            buttonHolder: "[data-foot-holder]",
            itemsHolder: "[data-items-holder]",
            item: "[data-item]",
            cartToggleElement: "[data-cart-toggle]",
            cartItemRemove: "[data-item-remove]",
            cartCount: "[data-cart-count]",
            cartCountValue: "data-cart-count",
            clickedElementForExpanding: "[data-expand-button]",
            cartWidget: "[data-cart-widget]",
            cartTotal: "[data-cart-total]",
            cartMessage: "[data-cart-message]",
            buttonAddToCart: "[data-add-to-cart]",
            formErrorsContainer: "[data-cart-errors-container]",
            cartErrors: "[data-cart-errors]",
            cartCloseError: "[data-cart-error-close]",
            formCloseError: "[data-close-error]",
            quickModal: "[data-quickview-modal-global]",
            cartProgress: "[data-cart-progress]",
            cartOriginalTotal: "[data-cart-original-total]",
            cartOriginaTotalPrice: "[data-cart-original-total-price]",
            cartDiscountsHolder: "[data-cart-discounts-holder]"
        },
        formatMoney: theme.moneyFormat,
        cartTotalDiscountsTemplate: "[data-cart-total-discount]"
    };
    class CartDrawer {
        constructor() {
            this.init()
        }
        init() {
            this.settings = settings,
            this.document = document,
            this.html = this.document.querySelector(this.settings.elements.html),
            this.cartDropdown = this.document.querySelector(this.settings.elements.cartDropdown),
            this.emptyMessage = this.document.querySelector(this.settings.elements.emptyMessage),
            this.buttonHolder = this.document.querySelector(this.settings.elements.buttonHolder),
            this.itemsHolder = this.document.querySelector(this.settings.elements.itemsHolder),
            this.items = this.document.querySelectorAll(this.settings.elements.item),
            this.counterHolders = this.document.querySelectorAll(this.settings.elements.cartCount),
            this.cartTotal = this.document.querySelector(this.settings.elements.cartTotal),
            this.cartMessage = this.document.querySelector(this.settings.elements.cartMessage),
            this.cartOriginalTotal = this.document.querySelector(this.settings.elements.cartOriginalTotal),
            this.cartOriginaTotalPrice = this.document.querySelector(this.settings.elements.cartOriginaTotalPrice),
            this.cartDiscountHolder = this.document.querySelector(this.settings.elements.cartDiscountsHolder),
            this.clickedElementForExpanding = this.document.querySelectorAll(this.settings.elements.clickedElementForExpanding),
            this.cartTotalDiscountTemplate = this.document.querySelector(this.settings.cartTotalDiscountsTemplate).innerHTML,
            this.cartErrorHolder = this.document.querySelector(this.settings.elements.cartErrors),
            this.cartCloseErrorMessage = this.document.querySelector(this.settings.elements.cartCloseError),
            this.accessibility = a11y,
            this.build = this.build.bind(this),
            this.addToCart = this.addToCart.bind(this),
            this.updateCart = this.updateCart.bind(this),
            this.openCartDropdown = this.openCartDropdown.bind(this),
            this.closeCartDropdown = this.closeCartDropdown.bind(this),
            this.toggleCartDropdown = this.toggleCartDropdown.bind(this),
            this.hasItemsInCart = this.hasItemsInCart.bind(this),
            this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this),
            this.cartDropdownIsBuilded = this.items.length > 0,
            this.totalItems = this.cartDropdownIsBuilded,
            this.cartDropdownIsOpen = !1,
            this.cartDiscounts = 0,
            this.cartDropdownIsEnable = this.settings.cartDropdownIsEnable,
            this.cartLimitErrorIsHidden = !0,
            this.html.style.setProperty("--scrollbar-width", window.innerWidth - this.html.clientWidth + "px"),
            this.eventToggleCart(),
            this.expandEvents(),
            this.cartEvents(),
            this.cartEventAdd(),
            this.initQuantity(),
            this.estimateShippingCalculator(),
            this.cartMessage && (this.cartFreeLimitShipping = 100 * Number(this.cartMessage.getAttribute("data-limit")),
            this.subtotal = 0,
            this.progress = this.document.querySelector(this.settings.elements.cartProgress),
            this.circumference = 28 * Math.PI,
            this.setProgress(this.progress.getAttribute("data-percent")))
        }
        initQuantity() {
            this.items = this.document.querySelectorAll(this.settings.elements.item),
            this.items.forEach((e=>{
                new QuantityCounter(e,!0).init(),
                this.customEventsHandle(e)
            }
            ))
        }
        expandEvents() {
            const e = this;
            this.clickedElementForExpanding.forEach((t=>{
                t.addEventListener("click", (function(s) {
                    s.preventDefault(),
                    t.classList.toggle(e.settings.classes.active),
                    slideToggle(e.document.querySelector(t.getAttribute("href")), 400);
                    const i = getSiblings(t.closest(e.settings.elements.cartWidget)).filter((t=>t.hasAttribute(e.settings.elements.cartWidget.replace("[", "").replace("]", ""))))[0];
                    if (i) {
                        const t = i.querySelector(e.settings.elements.clickedElementForExpanding);
                        t.classList.remove(e.settings.classes.active),
                        slideUp(t.nextElementSibling, 400)
                    }
                }
                ))
            }
            ))
        }
        customEventsHandle(e) {
            e.addEventListener("update-cart", debounce((t=>{
                this.updateCart({
                    id: t.detail.id,
                    quantity: t.detail.quantity
                }, e, t.detail.valueIsEmpty)
            }
            ), 500))
        }
        cartEvents() {
            const e = this;
            this.document.querySelectorAll(e.settings.elements.cartItemRemove).forEach((t=>{
                t.addEventListener("click", (function(t) {
                    t.preventDefault(),
                    e.updateCart({
                        id: this.getAttribute("data-id"),
                        quantity: 0
                    })
                }
                ))
            }
            )),
            this.cartCloseErrorMessage && this.cartCloseErrorMessage.addEventListener("click", (e=>{
                e.preventDefault(),
                slideUp(this.cartErrorHolder, 400)
            }
            ))
        }
        cartEventAdd() {
            this.cartDropdownIsEnable && this.document.addEventListener("click", (e=>{
                const t = e.target;
                if (t.matches(this.settings.elements.buttonAddToCart) || t.closest(this.settings.elements.buttonAddToCart) && t) {
                    if (e.preventDefault(),
                    t.hasAttribute("disabled") || t.parentNode.hasAttribute("disabled"))
                        return;
                    const s = t.closest("form")
                      , i = new FormData(s);
                    if (s.querySelector('[type="file"]'))
                        return;
                    const o = t.closest(this.settings.elements.quickModal);
                    this.addToCart(JSON.stringify(Object.fromEntries(i)), o),
                    this.html.dispatchEvent(new CustomEvent("cart:add-item",{
                        bubbles: !0,
                        detail: {
                            selector: null !== o ? this.document.querySelector(`[data-trigger-quickview="${o.querySelector("[data-product-handle]").getAttribute("data-product-handle")}"]`) : t
                        }
                    }))
                }
            }
            ))
        }
        estimateShippingCalculator() {
            Shopify.Cart.ShippingCalculator.show({
                submitButton: theme.strings.shippingCalcSubmitButton,
                submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
                customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
                moneyFormat: theme.strings.shippingCalcMoneyFormat
            })
        }
        getCart() {
            fetch("/cart.js").then(this.handleErrors).then((e=>e.json())).then((e=>(this.updateCounter(e.item_count),
            this.newTotalItems = e.items.length,
            this.buildTotalPrice(e),
            this.freeShippingMessageHandle(e.total_price),
            this.cartMessage && (this.subtotal = e.total_price,
            this.updateProgress()),
            fetch("/cart?view=items")))).then((e=>e.text())).then((e=>{
                this.build(e)
            }
            )).catch((e=>console.log(e)))
        }
        addToCart(e, t=null) {
            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json"
                },
                body: e
            }).then((e=>e.json())).then((e=>{  
                                             

                e.status ? this.addToCartError(e, t) : (null !== t && setTimeout((()=>{
                    t.innerHTML = ""
                }
                ), this.settings.times.timeoutAddProduct),
                this.getCart(),
                setTimeout((()=>{
                    this.openCartDropdown(),
                    this.cartDropdownIsOpen = !0
                }
                ), this.settings.times.timeoutAddProduct))
                if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
                 typeof BOLD.common.eventEmitter.emit === 'function'){
               BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
                }
            }
            )).catch((e=>console.log(e)))
        }
        updateCart(e={}, t=null, s=!1) {
            let i = null
              , o = null
              , r = null;
            null !== t && t.closest(this.settings.elements.item).classList.add(this.settings.classes.loading),
            this.items.forEach((e=>{
                e.classList.add(this.settings.classes.disabled),
                e.querySelector("input").blur()
            }
            )),
            fetch("/cart.js").then(this.handleErrors).then((e=>e.json())).then((t=>{
                const s = t.items.findIndex((t=>t.key === e.id));
                o = t.item_count,
                r = t.items[s].title;
                const i = {
                    line: `${s + 1}`,
                    quantity: e.quantity
                };
                return fetch("/cart/change.js", {
                    method: "post",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(i)
                })
            }
            )).then(this.handleErrors).then((e=>e.json())).then((e=>{
                i = e.item_count,
                this.updateCounter(i),
                this.buildTotalPrice(e),
                this.freeShippingMessageHandle(e.total_price),
                this.cartDiscounts = e.total_discount,
                this.cartMessage && (this.subtotal = e.total_price,
                this.updateProgress()),
                s && (i = 0),
                this.cartLimitErrorIsHidden = i !== o,
                this.toggleLimitError(r),
                this.getCart()
                if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
                 typeof BOLD.common.eventEmitter.emit === 'function'){
               BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
                }
            }
            )).catch((e=>console.log(e)))
        }
        toggleLimitError(e) {
            this.cartErrorHolder.querySelector("p").innerText = e,
            this.cartLimitErrorIsHidden ? slideUp(this.cartErrorHolder, 400) : slideDown(this.cartErrorHolder, 400)
        }
        handleErrors(e) {
            return e.ok ? e : e.json().then((function(t) {
                throw new FetchError({
                    status: e.statusText,
                    headers: e.headers,
                    json: t
                })
            }
            ))
        }
        addToCartError(e, t) {
            this.closeCartDropdown();
            let s = this.document.querySelector(this.settings.elements.formErrorsContainer);
            null !== t && (s = t.querySelector(this.settings.elements.formErrorsContainer)),
            s.innerHTML = `<div class="errors">${e.message}: ${e.description}<span class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close-thin" viewBox="0 0 27 27"><g stroke="#979797" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M.5.5l26 26M26.5.5l-26 26"></path></g></svg></span></div>`,
            s.classList.add(this.settings.classes.visible),
            this.document.addEventListener("click", (e=>{
                const t = e.target;
                (t.matches(this.settings.elements.formCloseError) || t.closest(this.settings.elements.formCloseError)) && (e.preventDefault(),
                s.classList.remove(this.settings.classes.visible))
            }
            ))
        }
        openCartDropdown() {
            this.html.classList.add(this.settings.classes.htmlClasses),
            document.dispatchEvent(new CustomEvent("theme:scroll:lock",{
                bubbles: !0
            })),
            this.cartDropdown.classList.add(this.settings.classes.open),
            this.accessibility.removeTrapFocus(),
            this.accessibility.trapFocus(this.cartDropdown, {
                elementToFocus: this.cartDropdown.querySelector("a:first-child, input:first-child")
            }),
            this.html.dispatchEvent(new CustomEvent("cart:open",{
                bubbles: !1
            })),
            this.cartDropdownIsBuilded || this.getCart()
        }
        closeCartDropdown() {
            if (this.accessibility.removeTrapFocus(),
            this.html.classList.contains("is-focused")) {
                const e = this.document.querySelector(`${this.settings.elements.cartToggleElement}[data-focus-element]`);
                setTimeout((()=>{
                    e.focus()
                }
                ), 200)
            }
            this.html.classList.remove(this.settings.classes.htmlClasses),
            this.cartDropdown.classList.remove(this.settings.classes.open),
            document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{
                bubbles: !0
            }))
        }
        toggleCartDropdown() {
            this.cartDropdownIsOpen = !this.cartDropdownIsOpen,
            this.cartDropdownIsOpen ? this.openCartDropdown() : this.closeCartDropdown()
        }
        eventToggleCart() {
            this.document.addEventListener("click", (e=>{
                const t = e.target
                  , s = !(t.matches(this.settings.elements.cartToggleElement) || t.closest(this.settings.elements.cartToggleElement))
                  , i = !(t.matches(this.settings.elements.cartDropdown) || t.closest(this.settings.elements.cartDropdown));
                t.matches(this.settings.elements.cartToggleElement) || t.closest(this.settings.elements.cartToggleElement) ? (e.preventDefault(),
                this.toggleCartDropdown()) : this.cartDropdownIsOpen && s && i && (this.cartDropdownIsOpen = !1,
                this.closeCartDropdown())
            }
            ))
        }
        toggleClassesOnContainers() {
            const e = this;
            this.emptyMessage.classList.toggle(e.settings.classes.hidden, e.hasItemsInCart()),
            this.buttonHolder.classList.toggle(e.settings.classes.hidden, !e.hasItemsInCart()),
            this.itemsHolder.classList.toggle(e.settings.classes.hidden, !e.hasItemsInCart())
        }
        build(e) {
            this.totalItems !== this.newTotalItems && (this.totalItems = this.newTotalItems,
            this.toggleClassesOnContainers()),
            this.itemsHolder.innerHTML = e,
            this.cartEvents(),
            this.initQuantity()
        }
        updateCounter(e) {
            this.counterHolders.length && this.counterHolders.forEach((t=>{
                t.innerHTML = e,
                t.setAttribute(settings.elements.cartCountValue, e)
            }
            ))
        }
        hasItemsInCart() {
            return this.totalItems > 0
        }
        buildTotalPrice(e) {
            if (e.original_total_price > e.total_price && e.cart_level_discount_applications.length > 0 ? (this.cartOriginalTotal.classList.remove(this.settings.classes.hidden),
            this.cartOriginaTotalPrice.innerHTML = themeCurrency.formatMoney(e.original_total_price, this.settings.formatMoney)) : this.cartOriginalTotal.classList.add(this.settings.classes.hidden),
            this.cartTotal.innerHTML = themeCurrency.formatMoney(e.total_price, this.settings.formatMoney),
            e.cart_level_discount_applications.length > 0) {
                const t = this.buildCartTotalDiscounts(e.cart_level_discount_applications);
                this.cartDiscountHolder.classList.remove(this.settings.classes.hidden),
                this.cartDiscountHolder.innerHTML = t
            } else
                this.cartDiscountHolder.classList.add(this.settings.classes.hidden)
        }
        buildCartTotalDiscounts(e) {
            let t = "";
            return e.forEach((e=>{
                t += Sqrl.render(this.cartTotalDiscountTemplate, {
                    discount_title: e.title,
                    discount_total_allocated_amount: themeCurrency.formatMoney(e.total_allocated_amount, this.settings.formatMoney)
                })
            }
            )),
            t
        }
        freeShippingMessageHandle(e) {
            this.cartMessage && this.cartMessage.classList.toggle(this.settings.classes.hidden, e >= this.cartFreeLimitShipping || 0 === e)
        }
        setProgress(e) {
            const t = this.circumference - e / 100 * this.circumference / 2;
            this.progress.style.strokeDashoffset = t
        }
        updateProgress() {
            const e = this.subtotal / this.cartFreeLimitShipping * 100;
            this.setProgress(e > 100 ? 100 : e)
        }
    }
    window.cart = new CartDrawer;
    const settings$1 = {
        elements: {
            html: "html",
            body: "body",
            inPageLink: "[data-skip-content]",
            linkesWithOnlyHash: 'a[href="#"]',
            triggerFocusElement: "[data-focus-element]",
            cartDropdown: "#cart-dropdown",
            modal: "[data-quickview-modal-global]",
            search: "#search-popdown",
            accordionContent: ".accordion-content",
            accordionIcon: ".accordion__icon",
            tabs: ".tabs"
        },
        classes: {
            focus: "is-focused",
            classRotate: "rotate-90",
            accordionToggle: "accordion-toggle",
            tabLink: "tab-link"
        },
        keysCodes: {
            escapeCode: 27,
            tabCode: 9,
            enterCode: 13,
            spaceCode: 32
        }
    };
    class Accessibility {
        constructor() {
            this.init()
        }
        init() {
            this.settings = settings$1,
            this.window = window,
            this.document = document,
            this.a11y = a11y,
            this.cart = this.window.cart,
            this.inPageLink = this.document.querySelector(this.settings.elements.inPageLink),
            this.linkesWithOnlyHash = this.document.querySelectorAll(this.settings.elements.linkesWithOnlyHash),
            this.html = this.document.querySelector(this.settings.elements.html),
            this.body = this.document.querySelector(this.settings.elements.body),
            this.modal = this.document.querySelector(this.settings.elements.modal),
            this.cartDropdown = this.document.querySelector(this.settings.elements.cartDropdown),
            this.lastFocused = null,
            this.isFocused = !1,
            this.a11y.focusHash(),
            this.a11y.bindInPageLinks(),
            this.clickEvents(),
            this.focusEvents(),
            this.focusEventsOff(),
            this.closeExpandedElements()
        }
        clickEvents() {
            this.inPageLink && this.inPageLink.addEventListener("click", (e=>{
                e.preventDefault()
            }
            )),
            this.linkesWithOnlyHash && this.linkesWithOnlyHash.forEach((e=>{
                e.addEventListener("click", (e=>{
                    e.preventDefault()
                }
                ))
            }
            ))
        }
        focusEvents() {
            this.document.addEventListener("keyup", (e=>{
                e.keyCode === this.settings.keysCodes.tabCode && (this.body.classList.add(this.settings.classes.focus),
                this.isFocused = !0)
            }
            )),
            this.document.addEventListener("keyup", (e=>{
                if (!this.isFocused)
                    return;
                const t = e.target
                  , s = e.keyCode === this.settings.keysCodes.enterCode || e.keyCode === this.settings.keysCodes.spaceCode
                  , i = t.matches(this.settings.elements.triggerFocusElement) || t.closest(this.settings.elements.triggerFocusElement)
                  , o = t.classList.contains(this.settings.classes.accordionToggle) || t.parentNode.classList.contains(this.settings.classes.accordionToggle)
                  , r = t.classList.contains(this.settings.classes.tabLink) || t.parentNode.classList.contains(this.settings.classes.tabLink)
                  , n = t.hasAttribute("data-trigger-quickview") || t.closest(this.settings.elements.triggerFocusElement) && t.closest(this.settings.elements.triggerFocusElement).hasAttribute("data-trigger-quickview")
                  , a = t.hasAttribute("data-popdown-toggle") || t.closest(this.settings.elements.triggerFocusElement) && t.closest(this.settings.elements.triggerFocusElement).hasAttribute("data-popdown-toggle");
                if (s && i) {
                    null === this.lastFocused && (this.lastFocused = t);
                    let e = this.document.querySelector(this.settings.elements.cartDropdown);
                    if (n && (e = this.document.querySelector(this.settings.elements.modal),
                    t.click()),
                    a && (e = this.document.querySelector(this.settings.elements.search)),
                    o && (e = t.nextElementSibling,
                    t.click()),
                    r) {
                        const s = `.tab-content-${t.getAttribute("data-tab")}`;
                        e = this.document.querySelector(s),
                        t.click()
                    }
                    n && e.querySelectorAll("a, input") ? this.modal.addEventListener("modal-is-loaded", (()=>{
                        this.a11y.trapFocus(e, {
                            elementToFocus: e.querySelector("a:first-child, input:first-child")
                        })
                    }
                    )) : e.querySelector("a, input") && this.a11y.trapFocus(e, {
                        elementToFocus: e.querySelector("a:first-child, input:first-child")
                    })
                }
            }
            )),
            this.html.addEventListener("cart:add-item", (e=>{
                this.lastFocused = e.detail.selector
            }
            ))
        }
        focusEventsOff() {
            this.document.addEventListener("mousedown", (()=>{
                this.body.classList.remove(this.settings.classes.focus),
                this.isFocused = !1
            }
            ))
        }
        closeExpandedElements() {
            document.addEventListener("keyup", (e=>{
                if (e.keyCode !== this.settings.keysCodes.escapeCode)
                    return;
                this.a11y.removeTrapFocus(),
                this.html.classList.contains(this.cart.settings.classes.htmlClasses) && (this.cart.toggleCartDropdown(),
                this.html.classList.remove(this.cart.settings.classes.htmlClasses),
                this.cartDropdown.classList.remove(this.cart.settings.classes.open)),
                "" !== this.modal.innerHTML && setTimeout((()=>{
                    this.modal.innerHTML = ""
                }
                ), 1e3);
                const t = document.querySelectorAll(this.settings.elements.accordionContent);
                if (t.length)
                    for (let e = 0; e < t.length; e++) {
                        if ("block" !== t[e].style.display)
                            continue;
                        t[e].previousElementSibling.querySelector(this.settings.elements.accordionIcon).classList.remove(this.settings.classes.classRotate),
                        slideUp(t[e])
                    }
                null !== this.lastFocused && setTimeout((()=>{
                    this.lastFocused.focus(),
                    this.lastFocused = null
                }
                ), 600)
            }
            ))
        }
    }
    function loadYoutubeAPI() {
        if (window.isYoutubeAPILoaded)
            ;
        else {
            var e = document.createElement("script");
            e.src = "https://www.youtube.com/iframe_api";
            var t = document.getElementsByTagName("script")[0];
            t.parentNode.insertBefore(e, t)
        }
    }
    function onYouTubeIframeAPIReady() {
        window.isYoutubeAPILoaded = !0,
        document.body.dispatchEvent(new CustomEvent("youtubeAPIReady"))
    }
    function loadPlyr() {
        if (window.isPlyrLoaded)
            ;
        else
            try {
                window.Shopify.loadFeatures([{
                    name: "video-ui",
                    version: "1.0",
                    onLoad: handleShopifyXRLoadError
                }], plyrLoaded)
            } catch (e) {
                throw console.log("An error occured while loading the Shopify Video interface"),
                e
            }
    }
    function plyrLoaded() {
        window.isPlyrLoaded = !0,
        document.body.dispatchEvent(new CustomEvent("plyrReady"))
    }
    function handleShopifyXRLoadError(e) {
        if (e)
            throw e
    }
    window.accessibility = new Accessibility,
    window.isYoutubeAPILoaded = !1,
    window.isPlyrLoaded = !1,
    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady,
    window.loadYoutubeAPI = loadYoutubeAPI,
    window.loadPlyr = loadPlyr,
    theme.ProductModel = function() {
        let e = {}
          , t = {}
          , s = {};
        const i = "[data-product-single-media-wrapper]"
          , o = "[data-product-slideshow]"
          , r = "[data-shopify-xr]"
          , n = "data-media-id"
          , a = "data-model-id"
          , l = "data-shopify-model3d-id"
          , c = "model-viewer"
          , d = "#ModelJson-"
          , h = "media--hidden";
        function u(t) {
            if (t)
                console.warn(t);
            else if (window.ShopifyXR) {
                for (const t in e)
                    if (e.hasOwnProperty(t)) {
                        const s = e[t];
                        if (s.loaded)
                            continue;
                        const i = document.querySelector(`${d}${t}`);
                        i && (window.ShopifyXR.addModels(JSON.parse(i.innerHTML)),
                        s.loaded = !0)
                    }
                window.ShopifyXR.setupXRElements()
            } else
                document.addEventListener("shopify_xr_initialized", (function() {
                    u()
                }
                ))
        }
        function p(e) {
            if (e)
                console.warn(e);
            else
                for (const e in t)
                    if (t.hasOwnProperty(e)) {
                        const s = t[e];
                        s.modelViewerUi || (s.modelViewerUi = new Shopify.ModelViewerUI(s.$element)),
                        m(s)
                    }
        }
        function m(e) {
            const t = s[e.sectionId];
            e.$container.addEventListener("mediaVisible", (function() {
                t.$element.setAttribute(l, e.modelId),
                y(e.mediaId),
                window.theme.touched || e.modelViewerUi.play()
            }
            )),
            e.$container.addEventListener("mediaHidden", (function() {
                t.$element.setAttribute(l, t.defaultId),
                e.modelViewerUi.pause()
            }
            )),
            e.$container.addEventListener("xrLaunch", (function() {
                e.modelViewerUi.pause()
            }
            )),
            e.$element.addEventListener("shopify_model_viewer_ui_toggle_play", (function() {
                y(e.mediaId)
            }
            ))
        }
        function y(e) {
            const t = `[${n}="${e}"]`
              , s = document.querySelector(`${i}${t}`)
              , o = document.querySelectorAll(`${i}:not(${t})`);
            s.classList.remove(h),
            o.length && o.forEach((e=>{
                e.dispatchEvent(new CustomEvent("mediaHidden")),
                e.classList.add(h)
            }
            ))
        }
        return {
            init: function(i, l) {
                e[l] = {
                    loaded: !1
                };
                const d = i.getAttribute(n)
                  , h = i.querySelector(c)
                  , m = h.getAttribute(a)
                  , y = i.closest(o).parentElement.querySelector(r);
                s[l] = {
                    $element: y,
                    defaultId: m
                },
                t[d] = {
                    modelId: m,
                    mediaId: d,
                    sectionId: l,
                    $container: i,
                    $element: h
                },
                window.Shopify.loadFeatures([{
                    name: "shopify-xr",
                    version: "1.0",
                    onLoad: u
                }, {
                    name: "model-viewer-ui",
                    version: "1.0",
                    onLoad: p
                }])
            },
            removeSectionModels: function(s) {
                for (const e in t)
                    if (t.hasOwnProperty(e)) {
                        t[e].sectionId === s && delete t[e]
                    }
                delete e[s],
                delete theme.mediaInstances[s]
            }
        }
    }();
    const selectors$2 = {
        templateAddresses: ".template-addresses",
        addressNewForm: "#AddressNewForm",
        btnNew: ".address-new-toggle",
        btnEdit: ".address-edit-toggle",
        btnDelete: ".address-delete",
        classHide: "hide",
        dataFormId: "data-form-id",
        dataConfirmMessage: "data-confirm-message",
        defaultConfirmMessage: "Are you sure you wish to delete this address?",
        editAddress: "#EditAddress",
        addressCountryNew: "AddressCountryNew",
        addressProvinceNew: "AddressProvinceNew",
        addressProvinceContainerNew: "AddressProvinceContainerNew",
        addressCountryOption: ".address-country-option",
        addressCountry: "AddressCountry",
        addressProvince: "AddressProvince",
        addressProvinceContainer: "AddressProvinceContainer"
    };
    class Addresses {
        constructor(e) {
            this.section = e,
            this.addressNewForm = this.section.querySelector(selectors$2.addressNewForm),
            this.init()
        }
        init() {
            if (this.addressNewForm) {
                const e = this.section
                  , t = this.addressNewForm;
                this.customerAddresses();
                const s = e.querySelectorAll(selectors$2.btnNew);
                s.length && s.forEach((e=>{
                    e.addEventListener("click", (function() {
                        t.classList.toggle(selectors$2.classHide)
                    }
                    ))
                }
                ));
                const i = e.querySelectorAll(selectors$2.btnEdit);
                i.length && i.forEach((t=>{
                    t.addEventListener("click", (function() {
                        const t = this.getAttribute(selectors$2.dataFormId);
                        e.querySelector(`${selectors$2.editAddress}_${t}`).classList.toggle(selectors$2.classHide)
                    }
                    ))
                }
                ));
                const o = e.querySelectorAll(selectors$2.btnDelete);
                o.length && o.forEach((e=>{
                    e.addEventListener("click", (function() {
                        const e = this.getAttribute(selectors$2.dataFormId)
                          , t = this.getAttribute(selectors$2.dataConfirmMessage);
                        confirm(t || selectors$2.defaultConfirmMessage) && Shopify.postLink("/account/addresses/" + e, {
                            parameters: {
                                _method: "delete"
                            }
                        })
                    }
                    ))
                }
                ))
            }
        }
        customerAddresses() {
            Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(selectors$2.addressCountryNew,selectors$2.addressProvinceNew,{
                hideElement: selectors$2.addressProvinceContainerNew
            });
            this.section.querySelectorAll(selectors$2.addressCountryOption).forEach((e=>{
                const t = e.getAttribute(selectors$2.dataFormId)
                  , s = `${selectors$2.addressCountry}_${t}`
                  , i = `${selectors$2.addressProvince}_${t}`
                  , o = `${selectors$2.addressProvinceContainer}_${t}`;
                new Shopify.CountryProvinceSelector(s,i,{
                    hideElement: o
                })
            }
            ))
        }
    }
    const template = document.querySelector(selectors$2.templateAddresses);
    template && new Addresses(template);
    const selectors$3 = {
        accountTemplateLogged: ".customer-logged-in",
        account: ".account",
        accountSidebarMobile: ".account-sidebar--mobile"
    };
    class Account {
        constructor(e) {
            this.section = e,
            this.init()
        }
        init() {
            this.section.querySelector(selectors$3.account) && this.accountMobileSidebar()
        }
        accountMobileSidebar() {
            this.section.querySelector(selectors$3.accountSidebarMobile).addEventListener("click", (function() {
                const e = this.nextElementSibling;
                e && "UL" === e.tagName && e.classList.toggle("visible")
            }
            ))
        }
    }
    const template$1 = document.querySelector(selectors$3.accountTemplateLogged);
    template$1 && new Account(template$1);
    const selectors$4 = {
        form: "[data-account-form]",
        showReset: "[data-show-reset]",
        hideReset: "[data-hide-reset]",
        recover: "[data-recover-password]",
        login: "[data-login-form]",
        recoverHash: "#recover",
        hideClass: "is-hidden"
    };
    class Login {
        constructor(e) {
            this.form = e,
            this.showButton = e.querySelector(selectors$4.showReset),
            this.hideButton = e.querySelector(selectors$4.hideReset),
            this.recover = e.querySelector(selectors$4.recover),
            this.login = e.querySelector(selectors$4.login),
            this.init()
        }
        init() {
            window.location.hash == selectors$4.recoverHash ? this.showRecoverPasswordForm() : this.hideRecoverPasswordForm(),
            this.showButton.addEventListener("click", function(e) {
                e.preventDefault(),
                this.showRecoverPasswordForm()
            }
            .bind(this), !1),
            this.hideButton.addEventListener("click", function(e) {
                e.preventDefault(),
                this.hideRecoverPasswordForm()
            }
            .bind(this), !1)
        }
        showRecoverPasswordForm() {
            return this.login.classList.add(selectors$4.hideClass),
            this.recover.classList.remove(selectors$4.hideClass),
            window.location.hash = selectors$4.recoverHash,
            !1
        }
        hideRecoverPasswordForm() {
            return this.recover.classList.add(selectors$4.hideClass),
            this.login.classList.remove(selectors$4.hideClass),
            window.location.hash = "",
            !1
        }
    }
    const loginForm = document.querySelector(selectors$4.form);
    loginForm && new Login(loginForm);
    var SECTION_ID_ATTR = "data-section-id";
    function Section(e, t) {
        this.container = validateContainerElement(e),
        this.id = e.getAttribute(SECTION_ID_ATTR),
        this.extensions = [],
        Object.assign(this, validatePropertiesObject(t));
        try {
            this.onLoad()
        } catch (e) {
            console.warn(`Error in section: ${this.id}`),
            console.warn(this),
            console.warn(e)
        }
    }
    function validateContainerElement(e) {
        if (!(e instanceof Element))
            throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
        if (null === e.getAttribute(SECTION_ID_ATTR))
            throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + SECTION_ID_ATTR + " attribute.");
        return e
    }
    function validatePropertiesObject(e) {
        if (void 0 !== e && "object" != typeof e || null === e)
            throw new TypeError("Theme Sections: The properties object provided is not a valid");
        return e
    }
    Section.prototype = {
        onLoad: Function.prototype,
        onUnload: Function.prototype,
        onSelect: Function.prototype,
        onDeselect: Function.prototype,
        onBlockSelect: Function.prototype,
        onBlockDeselect: Function.prototype,
        extend: function(e) {
            this.extensions.push(e);
            var t = Object.assign({}, e);
            delete t.init,
            Object.assign(this, t),
            "function" == typeof e.init && e.init.apply(this)
        }
    },
    "function" != typeof Object.assign && Object.defineProperty(Object, "assign", {
        value: function(e) {
            if (null == e)
                throw new TypeError("Cannot convert undefined or null to object");
            for (var t = Object(e), s = 1; s < arguments.length; s++) {
                var i = arguments[s];
                if (null != i)
                    for (var o in i)
                        Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o])
            }
            return t
        },
        writable: !0,
        configurable: !0
    });
    var SECTION_TYPE_ATTR = "data-section-type"
      , SECTION_ID_ATTR$1 = "data-section-id";
    window.Shopify = window.Shopify || {},
    window.Shopify.theme = window.Shopify.theme || {},
    window.Shopify.theme.sections = window.Shopify.theme.sections || {};
    var registered = window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}
      , instances = window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
    function register(e, t) {
        if ("string" != typeof e)
            throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== registered[e])
            throw new Error('Theme Sections: A section of type "' + e + '" has already been registered. You cannot register the same section type twice');
        function s(e) {
            for (var s = 0; s < t.length; s++)
                Section.call(this, e, t[s])
        }
        return Array.isArray(t) || (t = [t]),
        s.constructor = Section,
        s.prototype = Object.create(Section.prototype),
        s.prototype.type = e,
        registered[e] = s
    }
    function load(e, t) {
        e = normalizeType(e),
        void 0 === t && (t = document.querySelectorAll("[" + SECTION_TYPE_ATTR + "]")),
        t = normalizeContainers(t),
        e.forEach((function(e) {
            var s = registered[e];
            void 0 !== s && (t = t.filter((function(t) {
                return !isInstance(t) && (null !== t.getAttribute(SECTION_TYPE_ATTR) && (t.getAttribute(SECTION_TYPE_ATTR) !== e || (instances.push(new s(t)),
                !1)))
            }
            )))
        }
        ))
    }
    function unload(e) {
        getInstances(e).forEach((function(e) {
            var t = instances.map((function(e) {
                return e.id
            }
            )).indexOf(e.id);
            instances.splice(t, 1),
            e.onUnload()
        }
        ))
    }
    function getInstances(e) {
        var t = [];
        if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e))
            var s = e[0];
        if (e instanceof Element || s instanceof Element)
            normalizeContainers(e).forEach((function(e) {
                t = t.concat(instances.filter((function(t) {
                    return t.container === e
                }
                )))
            }
            ));
        else if ("string" == typeof e || "string" == typeof s) {
            normalizeType(e).forEach((function(e) {
                t = t.concat(instances.filter((function(t) {
                    return t.type === e
                }
                )))
            }
            ))
        }
        return t
    }
    function getInstanceById(e) {
        for (var t, s = 0; s < instances.length; s++)
            if (instances[s].id === e) {
                t = instances[s];
                break
            }
        return t
    }
    function isInstance(e) {
        return getInstances(e).length > 0
    }
    function normalizeType(e) {
        return "*" === e ? e = Object.keys(registered) : "string" == typeof e ? e = [e] : e.constructor === Section ? e = [e.prototype.type] : Array.isArray(e) && e[0].constructor === Section && (e = e.map((function(e) {
            return e.prototype.type
        }
        ))),
        e = e.map((function(e) {
            return e.toLowerCase()
        }
        ))
    }
    function normalizeContainers(e) {
        return NodeList.prototype.isPrototypeOf(e) && e.length > 0 ? e = Array.prototype.slice.call(e) : NodeList.prototype.isPrototypeOf(e) && 0 === e.length || null === e ? e = [] : !Array.isArray(e) && e instanceof Element && (e = [e]),
        e
    }
    window.Shopify.designMode && (document.addEventListener("shopify:section:load", (function(e) {
        var t = e.detail.sectionId
          , s = e.target.querySelector("[" + SECTION_ID_ATTR$1 + '="' + t + '"]');
        null !== s && load(s.getAttribute(SECTION_TYPE_ATTR), s)
    }
    )),
    document.addEventListener("shopify:section:unload", (function(e) {
        var t = e.detail.sectionId
          , s = e.target.querySelector("[" + SECTION_ID_ATTR$1 + '="' + t + '"]');
        "object" == typeof getInstances(s)[0] && unload(s)
    }
    )),
    document.addEventListener("shopify:section:select", (function(e) {
        var t = getInstanceById(e.detail.sectionId);
        "object" == typeof t && t.onSelect(e)
    }
    )),
    document.addEventListener("shopify:section:deselect", (function(e) {
        var t = getInstanceById(e.detail.sectionId);
        "object" == typeof t && t.onDeselect(e)
    }
    )),
    document.addEventListener("shopify:block:select", (function(e) {
        var t = getInstanceById(e.detail.sectionId);
        "object" == typeof t && t.onBlockSelect(e)
    }
    )),
    document.addEventListener("shopify:block:deselect", (function(e) {
        var t = getInstanceById(e.detail.sectionId);
        "object" == typeof t && t.onBlockDeselect(e)
    }
    )));
    const selectors$5 = {
        sidebar: ".sidebar",
        widgetCategories: ".widget--categories",
        widgetCategoriesLinks: ".widget--categories .widget__links",
        widgetLinksEl: ".widget__links",
        widgetLinks: ".widget__links .has-sub-nav > a",
        widgetLinksSub: ".widget__links .submenu > li > a",
        listEl: "li",
        linkEl: "a",
        sliderEnabled: "flickity-enabled",
        articleSingle: ".article--single",
        sidebarContents: ".sidebar__contents",
        hasSubNav: ".has-sub-nav",
        classOpen: "open",
        classActive: "active",
        classSubmenu: "submenu"
    }
      , sections = {};
    class Article {
        constructor(e) {
            this.container = e.container,
            this.sidebar = this.container.querySelector(selectors$5.sidebar),
            this.widgetCategories = this.container.querySelector(selectors$5.widgetCategories),
            this.flkty = null,
            this.init()
        }
        init() {
            this.sidebar && this.sidebarNav()
        }
        sidebarNav() {
            const e = this;
            this.navStates(),
            document.addEventListener("click", (function(t) {
                const s = t.target.tagName.toLowerCase() === selectors$5.linkEl
                  , i = t.target.closest(`${selectors$5.listEl}${selectors$5.hasSubNav}`)
                  , o = t.target.closest(selectors$5.widgetLinksEl)
                  , r = s && i && o;
                if (!((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 750) && r) {
                    const s = t.target.nextElementSibling;
                    s.parentElement.classList.toggle(selectors$5.classActive),
                    s.classList.toggle(selectors$5.classOpen),
                    slideToggle(s),
                    e.checkAriaStatus(s),
                    t.preventDefault()
                }
            }
            )),
            this.widgetCategories && (this.categories(),
            window.addEventListener("resize", debounce(this.categories, 250)))
        }
        checkAriaStatus(e) {
            e.classList.contains(selectors$5.classOpen) ? e.setAttribute("aria-expanded", !0) : e.setAttribute("aria-expanded", !1)
        }
        navStates() {
            const e = this.container.querySelectorAll(selectors$5.widgetLinks)
              , t = this.container.querySelectorAll(selectors$5.widgetLinksSub);
            e.forEach((e=>{
                if (e.getAttribute("href") === window.location.pathname) {
                    const t = e.closest(selectors$5.hasSubNav);
                    t.classList.add(selectors$5.classActive),
                    t.querySelector(`.${selectors$5.classSubmenu}`).style.display = "block"
                }
            }
            )),
            t.forEach((e=>{
                if (e.getAttribute("href") === window.location.pathname) {
                    const t = e.closest(selectors$5.hasSubNav);
                    e.closest("li").classList.add(selectors$5.classActive),
                    t.classList.add(selectors$5.classActive),
                    t.querySelector(`.${selectors$5.classSubmenu}`).style.display = "block"
                }
            }
            ))
        }
        categories() {
            const e = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 750
              , t = document.querySelector(selectors$5.widgetCategoriesLinks)
              , s = t.querySelector(`${selectors$5.listEl}.${selectors$5.classActive}`);
            let i = null;
            s && (i = Array.from(s.parentElement.children).indexOf(s));
            const o = document.querySelector(selectors$5.widgetCategories);
            this.navStates,
            this.flkty = new Flickity(t,{
                initialIndex: i,
                autoPlay: !1,
                prevNextButtons: !0,
                contain: !0,
                pageDots: !1,
                wrapAround: !0,
                watchCSS: !0,
                arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 60,
                    y2: 40,
                    x3: 20
                }
            }),
            e ? document.querySelector(selectors$5.articleSingle).prepend(o) : document.querySelector(selectors$5.sidebarContents).prepend(o)
        }
    }
    const articleSection = {
        onLoad() {
            sections[this.id] = new Article(this)
        }
    };
    register("article", articleSection);
    const selectors$6 = {
        slider: ".editorial__slider",
        slide: ".editorial__slide",
        prevArrow: "[data-prev-arrow]",
        nextArrow: "[data-next-arrow]",
        classIsHidden: "is-hidden",
        dataSlideIndex: "data-slide-index"
    }
      , sections$1 = {};
    class Editorial {
        constructor(e) {
            this.container = e.container,
            this.slideshow = this.container.querySelector(`${selectors$6.slider}--${e.id}`),
            this.sliderPrev = this.container.querySelector(selectors$6.prevArrow),
            this.sliderNext = this.container.querySelector(selectors$6.nextArrow),
            this.flkty = null,
            this.init()
        }
        init() {
            const e = this;
            this.slideshow && (this.flkty = new Flickity(this.slideshow,{
                autoPlay: !1,
                prevNextButtons: !1,
                contain: !0,
                pageDots: !1,
                adaptiveHeight: !0,
                wrapAround: !0,
                on: {
                    ready: function() {
                        this.slides.length > 1 ? (e.sliderPrev.classList.remove(selectors$6.classIsHidden),
                        e.sliderNext.classList.remove(selectors$6.classIsHidden)) : (e.sliderPrev.classList.add(selectors$6.classIsHidden),
                        e.sliderNext.classList.add(selectors$6.classIsHidden))
                    }
                }
            }),
            this.sliderPrev.addEventListener("click", (function(t) {
                t.preventDefault(),
                e.flkty.previous(!0)
            }
            )),
            this.sliderNext.addEventListener("click", (function(t) {
                t.preventDefault(),
                e.flkty.next(!0)
            }
            )))
        }
        onBlockSelect(e) {
            const t = this.slideshow.querySelector(`${selectors$6.slide}--${e.detail.blockId}`)
              , s = parseInt(t.getAttribute(selectors$6.dataSlideIndex));
            this.flkty.select(s),
            this.flkty.stopPlayer()
        }
    }
    const editorialSection = {
        onLoad() {
            sections$1[this.id] = new Editorial(this)
        },
        onBlockSelect(e) {
            sections$1[this.id].onBlockSelect(e)
        }
    }
      , selectors$7 = {
        dataSectionId: "data-section-id",
        blogListing: ".blog-listing",
        flickityEnabled: "flickity-enabled"
    }
      , sections$2 = {};
    class Blog {
        constructor(e) {
            this.container = e.container,
            this.id = this.container.getAttribute(selectors$7.dataSectionId),
            this.slideshow = this.container.querySelector(selectors$7.blogListing),
            this.flkty = null,
            this.init()
        }
        init() {
            this.flkty = new Flickity(this.slideshow,{
                autoPlay: !1,
                prevNextButtons: !0,
                contain: !0,
                pageDots: !1,
                wrapAround: !0,
                watchCSS: !0,
                arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 60,
                    y2: 40,
                    x3: 20
                }
            })
        }
        setHeights(e) {
            const t = e.querySelectorAll(".featured-blog__content");
            let s = !1;
            if (t.length > 0) {
                for (const e of t)
                    if (e.classList.contains("onboarding-blog-content")) {
                        s = !0;
                        break
                    }
                if (s) {
                    let e = 0;
                    for (const s of t) {
                        const t = s.querySelector(".h5")
                          , i = parseInt(getComputedStyle(t, null).height.replace("px", ""))
                          , o = s.querySelectorAll(".featured-blog__date")
                          , r = parseInt(getComputedStyle(o, null).height.replace("px", ""))
                          , n = s.querySelector(".excerpt")
                          , a = i + r + parseInt(getComputedStyle(n, null).height.replace("px", ""));
                        a > e && (e = a)
                    }
                    e += 75;
                    for (const s of t)
                        s.style.height = `${e}px`
                }
            }
        }
        onBlockSelect(e) {}
        onUnload(e) {
            this.slideshow.classList.contains(selectors$7.flickityEnabled) && this.flkty.destroy()
        }
    }
    const blogSection = {
        onLoad() {
            sections$2[this.id] = new Blog(this)
        },
        onUnload(e) {
            sections$2[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            sections$2[this.id].onBlockSelect(e)
        }
    };
    register("blog-template", [blogSection, editorialSection]),
    register("blog", blogSection);
    var sections$3 = {};
    const parallaxHero = {
        onLoad() {
            sections$3[this.id] = [];
            this.container.querySelectorAll("[data-parallax-wrapper]").forEach((e=>{
                const t = e.querySelector("[data-parallax-img]");
                sections$3[this.id].push(new Rellax(t,{
                    center: !0,
                    round: !0,
                    frame: e
                }))
            }
            ))
        },
        onUnload: function() {
            sections$3[this.id].forEach((e=>{
                "function" == typeof e.destroy && e.destroy()
            }
            ))
        }
    };
    register("hero", parallaxHero);
    const selectors$8 = {
        popoutWrappper: "[data-popout]",
        popoutList: "[data-popout-list]",
        popoutToggle: "[data-popout-toggle]",
        popoutInput: "[data-popout-input]",
        popoutOptions: "[data-popout-option]",
        dataValue: "data-value",
        ariaExpanded: "aria-expanded"
    }
      , classes$1 = {
        listVisible: "popout-list--visible"
    };
    let sections$4 = {};
    const popupToggleClick = function(e) {
        const t = "true" === e.currentTarget.getAttribute(selectors$8.ariaExpanded);
        e.currentTarget.setAttribute(selectors$8.ariaExpanded, !t),
        this.popoutList.classList.toggle(classes$1.listVisible)
    }
      , popupToggleFocusout = function(e) {
        this.container.contains(e.relatedTarget) || this._hideList()
    }
      , popupListFocusout = function(e) {
        const t = e.currentTarget.contains(e.relatedTarget);
        this.popoutList.classList.contains(classes$1.listVisible) && !t && this._hideList()
    }
      , popupOptionsClick = function(e) {
        if ("#" === e.target.closest(selectors$8.popoutOptions).attributes.href.value) {
            e.preventDefault();
            let t = "";
            e.currentTarget.getAttribute(selectors$8.dataValue) && (t = e.currentTarget.getAttribute(selectors$8.dataValue)),
            this._submitForm(t)
        }
    }
      , containerKeyup = function(e) {
        e.which === window.theme.keyboardKeys.ESCAPE && (this._hideList(),
        this.popoutToggle.focus())
    }
      , bodyClick = function(e) {
        const t = this.container.contains(e.target);
        this.popoutList.classList.contains(classes$1.listVisible) && !t && this._hideList()
    };
    class Popout {
        constructor(e) {
            this.container = e,
            this.popoutList = this.container.querySelector(selectors$8.popoutList),
            this.popoutToggle = this.container.querySelector(selectors$8.popoutToggle),
            this.popoutInput = this.container.querySelector(selectors$8.popoutInput),
            this.popoutOptions = this.container.querySelectorAll(selectors$8.popoutOptions),
            this._connectOptions(),
            this._connectToggle(),
            this._onFocusOut()
        }
        unload() {
            this.popoutOptions.length && this.popoutOptions.forEach((e=>{
                e.removeEventListener("click", popupOptionsClick)
            }
            )),
            this.popoutToggle.removeEventListener("click", popupToggleClick),
            this.popoutToggle.removeEventListener("focusout", popupToggleFocusout),
            this.popoutList.removeEventListener("focusout", popupListFocusout),
            this.container.removeEventListener("keyup", containerKeyup)
        }
        _connectToggle() {
            this.popoutToggle.addEventListener("click", popupToggleClick.bind(this))
        }
        _connectOptions() {
            this.popoutOptions.length && this.popoutOptions.forEach((e=>{
                e.addEventListener("click", popupOptionsClick.bind(this))
            }
            ))
        }
        _onFocusOut() {
            this.popoutToggle.addEventListener("focusout", popupToggleFocusout.bind(this)),
            this.popoutList.addEventListener("focusout", popupListFocusout.bind(this)),
            this.container.addEventListener("keyup", containerKeyup.bind(this)),
            document.body.addEventListener("click", bodyClick.bind(this))
        }
        _submitForm(e) {
            const t = this.container.closest("form");
            this.popoutInput.value = e,
            t && t.submit()
        }
        _hideList() {
            this.popoutList.classList.remove(classes$1.listVisible),
            this.popoutToggle.setAttribute(selectors$8.ariaExpanded, !1)
        }
    }
    const popoutSection = {
        onLoad() {
            sections$4[this.id] = [];
            this.container.querySelectorAll(selectors$8.popoutWrappper).forEach((e=>{
                sections$4[this.id].push(new Popout(e))
            }
            ))
        },
        onUnload: function() {
            sections$4[this.id].forEach((e=>{
                "function" == typeof e.unload && e.unload()
            }
            ))
        }
    }
      , footerSection = {
        onLoad() {
            var e = document.querySelector("[data-powered-link] a");
            e && e.setAttribute("rel", "noopener")
        }
    };
    register("footer", [popoutSection, footerSection, parallaxHero]);
    const selectors$9 = {
        reviews: "data-reviews"
    };
    class ProductGridReviews {
        constructor(e) {
            this.container = e.container,
            this.showReviews = "false" !== this.container.getAttribute(selectors$9.reviews),
            this.reviewsAppInstalled = "function" == typeof window.SPR,
            this.init()
        }
        init() {
            this.showReviews && "undefined" != typeof yotpo ? yotpo.initialized ? yotpo.refreshWidgets() : yotpo.initWidgets() : this.showReviews && this.reviewsAppInstalled && (window.SPR.initDomEls(),
            window.SPR.loadBadges())
        }
    }
    const productGridReviews = {
        onLoad() {
            new ProductGridReviews(this)
        }
    }
      , selectors$a = {
        productSlideshow: "[data-product-slideshow]",
        productThumbs: "[data-product-thumbs]",
        dataTallLayout: "data-tall-layout",
        dataType: "data-type",
        dataMediaId: "data-media-id",
        dataThumb: "data-thumb",
        dataThumbIndex: "data-thumb-index",
        ariaLabel: "aria-label",
        dataThumbnail: "[data-thumbnail]",
        productSlideThumb: ".js-product-slide-thumb",
        classSelected: "is-selected",
        classMediaHidden: "media--hidden",
        sliderEnabled: "flickity-enabled",
        focusEnabled: "focus-enabled"
    }
      , thumbIcons = {
        model: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-model" viewBox="0 0 26 26"><path d="M1 25h24V1H1z"/><path class="icon-media-model-outline" d="M.5 25v.5h25V.5H.5z" fill="none"/><path class="icon-media-model-element" d="M19.13 8.28L14 5.32a2 2 0 0 0-2 0l-5.12 3a2 2 0 0 0-1 1.76V16a2 2 0 0 0 1 1.76l5.12 3a2 2 0 0 0 2 0l5.12-3a2 2 0 0 0 1-1.76v-6a2 2 0 0 0-.99-1.72zm-6.4 11.1l-5.12-3a.53.53 0 0 1-.26-.38v-6a.53.53 0 0 1 .27-.46l5.12-3a.53.53 0 0 1 .53 0l5.12 3-4.72 2.68a1.33 1.33 0 0 0-.67 1.2v6a.53.53 0 0 1-.26 0z" opacity=".6" style="isolation:isolate"/></svg>',
        video: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>'
    };
    class InitSlider {
        constructor(e) {
            this.container = e.container,
            this.tallLayout = "true" === this.container.getAttribute(selectors$a.dataTallLayout),
            this.slideshow = this.container.querySelector(selectors$a.productSlideshow),
            this.thumbs = this.container.querySelector(selectors$a.productThumbs),
            this.flkty = null,
            this.init()
        }
        init() {
            const e = this;
            this.tallLayout ? (e.initSliderMobile(),
            document.addEventListener("theme:resize", (()=>{
                e.initSliderMobile()
            }
            ))) : this.createSlider()
        }
        initSliderMobile() {
            (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < theme.variables.mediaQuerySmall ? this.createSlider() : this.destroySlider()
        }
        destroySlider() {
            const e = this;
            e.slideshow.classList.contains(selectors$a.sliderEnabled) && e.flkty.destroy(),
            this.thumbs && (this.thumbs.innerHTML = "")
        }
        createSlider() {
            if (!this.slideshow)
                return;
            const e = this
              , t = this.slideshow.querySelectorAll(`[${selectors$a.dataType}]`)[0];
            let s = {
                autoPlay: !1,
                prevNextButtons: !1,
                contain: !0,
                pageDots: !1,
                adaptiveHeight: !0,
                wrapAround: !0,
                fade: !0,
                on: {
                    ready: function() {
                        e.sliderThumbs(this)
                    }
                }
            };
            if (this.flkty = new FlickityFade(this.slideshow,s),
            this.flkty.resize(),
            t) {
                const e = t.getAttribute(selectors$a.dataType);
                "model" !== e && "video" !== e && "external_video" !== e || (this.flkty.options.draggable = !1,
                this.flkty.updateDraggable())
            }
            this.flkty.on("change", (function(t) {
                let s = t;
                if (e.thumbs) {
                    const i = e.thumbs.querySelector(`.${selectors$a.classSelected}`)
                      , o = e.thumbs.querySelector(`li [${selectors$a.dataThumbIndex}="${t}"]`);
                    i && (s = Array.from(i.parentElement.children).indexOf(i),
                    i.classList.remove(selectors$a.classSelected)),
                    o && o.parentElement.classList.add(selectors$a.classSelected)
                }
                const i = this.cells[s].element
                  , o = this.selectedElement;
                i.dispatchEvent(new CustomEvent("mediaHidden")),
                o.classList.remove(selectors$a.classMediaHidden)
            }
            )),
            this.flkty.on("settle", (function(t) {
                const s = this.selectedElement
                  , i = Array.prototype.filter.call(s.parentNode.children, (function(e) {
                    return e !== s
                }
                ))
                  , o = s.getAttribute(selectors$a.dataType)
                  , r = document.body.classList.contains(selectors$a.focusEnabled);
                "model" === o || "video" === o || "external_video" === o ? (e.flkty.options.draggable = !1,
                e.flkty.updateDraggable()) : (e.flkty.options.draggable = !0,
                e.flkty.updateDraggable()),
                r && s.dispatchEvent(new Event("focus")),
                i.length && i.forEach((e=>{
                    e.classList.add(selectors$a.classMediaHidden)
                }
                )),
                s.dispatchEvent(new CustomEvent("mediaVisible"))
            }
            )),
            e.container.addEventListener("click", (function(t) {
                const s = t.target;
                if (s.matches(selectors$a.productSlideThumb) || s.closest(selectors$a.productSlideThumb)) {
                    t.preventDefault();
                    let i, o = 0;
                    i = s.matches(selectors$a.productSlideThumb) ? s : s.closest(selectors$a.productSlideThumb),
                    o = parseInt(i.getAttribute(selectors$a.dataThumbIndex)),
                    e.flkty.select(o)
                }
            }
            ))
        }
        sliderThumbs(e) {
            const t = e.slides;
            if (this.thumbs && t.length) {
                let e = "";
                t.forEach(((t,s)=>{
                    const i = t.cells[0].element
                      , o = i.getAttribute(selectors$a.dataType)
                      , r = i.getAttribute(selectors$a.dataMediaId)
                      , n = i.getAttribute(selectors$a.dataThumb);
                    let a = "";
                    const l = thumbIcons[o] ? thumbIcons[o] : "";
                    let c = "";
                    i.querySelector(`[${selectors$a.ariaLabel}]`) && (a = i.querySelector(`[${selectors$a.ariaLabel}]`).getAttribute(selectors$a.ariaLabel)),
                    "" === a && i.hasAttribute(selectors$a.ariaLabel) && (a = i.getAttribute(selectors$a.ariaLabel)),
                    i.setAttribute("tabindex", "-1"),
                    i.classList.contains(selectors$a.classSelected) && (c = selectors$a.classSelected),
                    e += `<li class="${c}"><a href="${n}" class="thumb--${o} js-product-slide-thumb" data-thumb-index="${s}" data-thumbnail data-media-id="${r}"><img alt="${a}" src="${n}">${l}</a></li>`
                }
                )),
                "" !== e && (e = `<ul>${e}</ul>`,
                this.thumbs.innerHTML = e)
            }
            const s = this.container.querySelectorAll(selectors$a.dataThumbnail);
            s.length && s.forEach((t=>{
                t.addEventListener("click", (function(e) {
                    e.preventDefault()
                }
                )),
                t.addEventListener("keyup", (function(t) {
                    if (13 === t.keyCode) {
                        const t = this.getAttribute(selectors$a.dataMediaId)
                          , s = e.element.querySelector(`[${selectors$a.dataMediaId}="${t}"]`).querySelectorAll('model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])')[0];
                        s && (s.dispatchEvent(new Event("focus")),
                        s.dispatchEvent(new Event("select")))
                    }
                }
                ))
            }
            ))
        }
    }
    const selectors$b = {
        zoomWrapper: "[data-zoom-wrapper]",
        dataImageSrc: "data-image-src",
        dataImageWidth: "data-image-width",
        dataImageHeight: "data-image-height",
        dataImageZoomEnable: "data-image-zoom-enable",
        thumbs: ".pswp__thumbs",
        caption: "[data-zoom-caption]"
    }
      , classes$2 = {
        variantSoldOut: "variant--soldout",
        variantUnavailable: "variant--unavailabe",
        popupThumb: "pswp__thumb",
        popupClass: "pswp-zoom-gallery",
        popupClassNoThumbs: "pswp-zoom-gallery--single"
    };
    class Zoom {
        constructor(e) {
            this.container = e.container,
            this.zoomWrappers = this.container.querySelectorAll(selectors$b.zoomWrapper),
            this.thumbsContainer = document.querySelector(selectors$b.thumbs),
            this.zoomCaptionElem = this.container.querySelector(selectors$b.caption),
            this.zoomEnable = "true" === this.container.getAttribute(selectors$b.dataImageZoomEnable),
            this.zoomEnable && this.init()
        }
        init() {
            const e = this;
            this.zoomWrappers.length && this.zoomWrappers.forEach(((t,s)=>{
                t.addEventListener("click", (function(t) {
                    t.preventDefault(),
                    e.createZoom(s)
                }
                )),
                t.addEventListener("keyup", (function(t) {
                    13 === t.keyCode && (t.preventDefault(),
                    e.createZoom(s))
                }
                ))
            }
            ))
        }
        createZoom(e) {
            const t = this;
            let s = []
              , i = 0
              , o = "";
            this.zoomWrappers.forEach((r=>{
                const n = r.getAttribute(selectors$b.dataImageSrc)
                  , a = parseInt(r.getAttribute(selectors$b.dataImageWidth))
                  , l = parseInt(r.getAttribute(selectors$b.dataImageHeight));
                if (s.push({
                    src: n,
                    w: a,
                    h: l,
                    msrc: n
                }),
                o += `<a href="#" class="${classes$2.popupThumb}" style="background-image: url('${n}')"></a>`,
                i += 1,
                t.zoomWrappers.length === i) {
                    let r = `${classes$2.popupClass}`;
                    1 === i && (r = `${classes$2.popupClass} ${classes$2.popupClassNoThumbs}`);
                    openPhotoSwipe(s, {
                        history: !1,
                        focus: !1,
                        index: e,
                        mainClass: r,
                        showHideOpacity: !0,
                        howAnimationDuration: 150,
                        hideAnimationDuration: 250,
                        closeOnScroll: !1,
                        closeOnVerticalDrag: !1,
                        captionEl: !0,
                        closeEl: !0,
                        closeElClasses: ["caption-close"],
                        tapToClose: !1,
                        clickToCloseNonZoomable: !1,
                        maxSpreadZoom: 2,
                        loop: !0,
                        spacing: 0,
                        allowPanToNext: !0,
                        pinchToClose: !1,
                        addCaptionHTMLFn: function(e, s, i) {
                            t.zoomCaption(e, s, i)
                        },
                        getThumbBoundsFn: function() {
                            const s = t.zoomWrappers[e]
                              , i = window.pageYOffset || document.documentElement.scrollTop
                              , o = s.getBoundingClientRect();
                            return {
                                x: o.left,
                                y: o.top + i,
                                w: o.width
                            }
                        }
                    }),
                    t.thumbsContainer && "" !== o && (t.thumbsContainer.innerHTML = o)
                }
            }
            ))
        }
        zoomCaption(e, t, s) {
            let i = "";
            const o = t.children[0];
            return this.zoomCaptionElem && (i = this.zoomCaptionElem.innerHTML,
            this.zoomCaptionElem.closest(`.${classes$2.variantSoldOut}`) ? o.classList.add(classes$2.variantSoldOut) : o.classList.remove(classes$2.variantSoldOut),
            this.zoomCaptionElem.closest(`.${classes$2.variantUnavailable}`) ? o.classList.add(classes$2.variantUnavailable) : o.classList.remove(classes$2.variantUnavailable)),
            o.innerHTML = i,
            !1
        }
    }
    const selectors$c = {
        videoPlayer: "[data-video]",
        modelViewer: "[data-model]",
        dataType: "data-type",
        dataMediaId: "data-media-id",
        dataVideoLooping: "data-video-looping",
        dataYoutubeId: "data-youtube-id",
        productMediaWrapper: "[data-product-single-media-wrapper]",
        productMediaContainer: "[data-product-single-media-group]",
        classMediaHidden: "media--hidden"
    };
    theme.mediaInstances = {};
    class Video {
        constructor(e) {
            this.section = e,
            this.container = e.container,
            this.id = e.id,
            this.players = {},
            this.init()
        }
        init() {
            const e = this.container.querySelectorAll(selectors$c.videoPlayer);
            let t = !1
              , s = !1;
            for (let i = 0; i < e.length; i++) {
                const o = e[i].getAttribute("id")
                  , r = e[i].getAttribute(selectors$c.dataType)
                  , n = e[i].getAttribute(selectors$c.dataMediaId);
                if (this.players[o] = {},
                this.players[o].id = o,
                this.players[o].type = r,
                this.players[o].mediaId = n,
                this.players[o].container = e[i],
                this.players[o].element = e[i].querySelector("iframe, video"),
                !this.players[o].element)
                    return;
                if ("external_video" === r) {
                    const s = e[i].getAttribute(selectors$c.dataYoutubeId);
                    this.players[o].externalID = s,
                    t = !0
                } else
                    "video" === r && (s = !0)
            }
            if (s)
                if (window.isPlyrLoaded)
                    this.nativeInitCallback();
                else {
                    loadScript({
                        name: "video-ui",
                        version: "1.0"
                    }).then((()=>{
                        this.nativeInitCallback()
                    }
                    ))
                }
            t && (window.isYoutubeAPILoaded ? this.youTubeInitCallback() : (window.loadYoutubeAPI(),
            document.body.addEventListener("youtubeAPIReady", this.youTubeInitCallback.bind(this))))
        }
        youTubeInitCallback() {
            const e = this;
            for (const t in this.players)
                if ("external_video" === this.players[t].type) {
                    const s = this.players[t]
                      , i = "true" === this.players[t].container.closest(`[${selectors$c.dataVideoLooping}]`).getAttribute(selectors$c.dataVideoLooping);
                    this.players[t].player = new YT.Player(s.element,{
                        videoId: s.externalID,
                        playerVars: {
                            cc_load_policy: 0,
                            iv_load_policy: 3,
                            modestbranding: 1,
                            playsinline: 1,
                            autohide: 0,
                            controls: 1,
                            branding: 0,
                            showinfo: 0,
                            rel: 0,
                            fs: 0,
                            wmode: "opaque"
                        },
                        events: {
                            onStateChange: function(t) {
                                0 === t.data && i && t.target.seekTo(0);
                                const s = t.target.getIframe().closest(`[${selectors$c.dataMediaId}]`);
                                let o = "";
                                s && (o = s.getAttribute(selectors$c.dataMediaId)),
                                1 === t.data && e.pauseOtherMedia(o)
                            }
                        }
                    }),
                    this.players[t].container.addEventListener("mediaHidden", (function(t) {
                        e.onHidden(t, !0)
                    }
                    )),
                    this.players[t].container.addEventListener("xrLaunch", (function(t) {
                        e.onHidden(t, !0)
                    }
                    )),
                    this.players[t].container.addEventListener("mediaVisible", (function(t) {
                        e.onVisible(t, !0)
                    }
                    ))
                }
        }
        nativeInitCallback() {
            const e = this;
            for (const t in this.players)
                if ("video" === this.players[t].type) {
                    const s = this.players[t]
                      , i = {
                        loop: {
                            active: "true" === this.players[t].container.closest(`[${selectors$c.dataVideoLooping}]`).getAttribute(selectors$c.dataVideoLooping)
                        },
                        focusOnPlay: !0
                    };
                    this.players[t].player = new Shopify.Plyr(s.element,i),
                    s.element.addEventListener("play", (t=>{
                        const s = t.target.closest(`[${selectors$c.dataMediaId}]`);
                        let i = "";
                        s && (i = s.getAttribute(selectors$c.dataMediaId)),
                        e.pauseOtherMedia(i)
                    }
                    )),
                    this.players[t].container.addEventListener("mediaHidden", (function(t) {
                        e.onHidden(t, !1)
                    }
                    )),
                    this.players[t].container.addEventListener("xrLaunch", (function(t) {
                        e.onHidden(t, !1)
                    }
                    )),
                    this.players[t].container.addEventListener("mediaVisible", (function(t) {
                        e.onVisible(t, !1)
                    }
                    ))
                }
        }
        onHidden(e, t=!1) {
            if (void 0 !== e.target.dataset.playerId) {
                const s = e.target.dataset.playerId
                  , i = this.players[s];
                !0 === t && i.player && i.player.pauseVideo ? i.player.pauseVideo() : i.player && i.player.pause && i.player.pause()
            }
        }
        onVisible(e, t=!1) {
            if (!window.theme.touched && void 0 !== e.target.dataset.playerId) {
                const s = e.target.dataset.playerId
                  , i = this.players[s];
                !0 === t && i.player && i.player.playVideo ? i.player.playVideo() : i.player && i.player.play && i.player.play()
            }
        }
        pauseOtherMedia(e) {
            const t = `[${selectors$c.dataMediaId}="${e}"]`
              , s = document.querySelector(`${selectors$c.productMediaWrapper}${t}`)
              , i = document.querySelectorAll(`${selectors$c.productMediaWrapper}:not(${t})`);
            s.classList.remove(selectors$c.classMediaHidden),
            i.length && i.forEach((e=>{
                e.dispatchEvent(new CustomEvent("mediaHidden")),
                e.classList.add(selectors$c.classMediaHidden)
            }
            ))
        }
    }
    theme.mediaInstances = {};
    const selectors$d = {
        videoPlayer: "[data-video]",
        modelViewer: "[data-model]",
        sliderEnabled: "flickity-enabled",
        classMediaHidden: "media--hidden"
    };
    class Media {
        constructor(e) {
            this.section = e,
            this.id = e.id,
            this.container = e.container
        }
        init() {
            new Video(this.section),
            this.detect3d(),
            this.launch3d(),
            new Zoom(this.section),
            new InitSlider(this.section)
        }
        detect3d() {
            const e = this.container.querySelectorAll(selectors$d.modelViewer);
            e.length && e.forEach((e=>{
                theme.ProductModel.init(e, this.id)
            }
            ))
        }
        launch3d() {
            const e = this;
            document.addEventListener("shopify_xr_launch", (function() {
                e.container.querySelector(`${e.selectors.modelViewer}:not(.${selectors$d.classMediaHidden})`).dispatchEvent(new CustomEvent("xrLaunch"))
            }
            ))
        }
    }
    const fadeOut = (e,t=null)=>{
        e.style.opacity = 1,
        function s() {
            (e.style.opacity -= .1) < 0 ? e.style.display = "none" : requestAnimationFrame(s),
            0 === parseFloat(e.style.opacity) && "function" == typeof t && t()
        }()
    }
      , selectors$e = {
        modalWrapper: "modal__wrapper"
    };
    function showModal(e, t, s) {
        const i = e;
        "function" == typeof t ? fadeIn(i, "block", t) : fadeIn(i),
        i.addEventListener("click", (function(e) {
            const t = e.target;
            if (t.classList.contains("close") || t.classList.contains(selectors$e.modalWrapper))
                return "function" == typeof s ? fadeOut(i, s) : fadeOut(i),
                e.preventDefault(),
                removeTrapFocus(),
                !1
        }
        )),
        i.addEventListener("keyup", (e=>{
            if (e.which === window.theme.keyboardKeys.ESCAPE)
                return "function" == typeof s ? fadeOut(i, s) : fadeOut(i),
                removeTrapFocus(),
                !1
        }
        )),
        i.querySelectorAll(window.theme.focusable)[0].focus()
    }
    function Listeners() {
        this.entries = []
    }
    function getVariantFromSerializedArray(e, t) {
        return _validateProductStructure(e),
        getVariantFromOptionArray(e, _createOptionArrayFromOptionCollection(e, t))
    }
    function getVariantFromOptionArray(e, t) {
        return _validateProductStructure(e),
        _validateOptionsArray(t),
        e.variants.filter((function(e) {
            return t.every((function(t, s) {
                return e.options[s] === t
            }
            ))
        }
        ))[0] || null
    }
    function _createOptionArrayFromOptionCollection(e, t) {
        _validateProductStructure(e),
        _validateSerializedArray(t);
        var s = [];
        return t.forEach((function(t) {
            for (var i = 0; i < e.options.length; i++) {
                if ((e.options[i].name || e.options[i]).toLowerCase() === t.name.toLowerCase()) {
                    s[i] = t.value;
                    break
                }
            }
        }
        )),
        s
    }
    function _validateProductStructure(e) {
        if ("object" != typeof e)
            throw new TypeError(e + " is not an object.");
        if (0 === Object.keys(e).length && e.constructor === Object)
            throw new Error(e + " is empty.")
    }
    function _validateSerializedArray(e) {
        if (!Array.isArray(e))
            throw new TypeError(e + " is not an array.");
        if (0 === e.length)
            throw new Error(e + " is empty.");
        if (!e[0].hasOwnProperty("name"))
            throw new Error(e[0] + "does not contain name key.");
        if ("string" != typeof e[0].name)
            throw new TypeError("Invalid value type passed for name of option " + e[0].name + ". Value should be string.")
    }
    function _validateOptionsArray(e) {
        if (Array.isArray(e) && "object" == typeof e[0])
            throw new Error(e + "is not a valid array of options.")
    }
    Listeners.prototype.add = function(e, t, s) {
        this.entries.push({
            element: e,
            event: t,
            fn: s
        }),
        e.addEventListener(t, s)
    }
    ,
    Listeners.prototype.removeAll = function() {
        this.entries = this.entries.filter((function(e) {
            return e.element.removeEventListener(e.event, e.fn),
            !1
        }
        ))
    }
    ;
    var selectors$f = {
        idInput: '[name="id"]',
        optionInput: '[name^="options"]',
        quantityInput: '[name="quantity"]',
        propertyInput: '[name^="properties"]'
    };
    function ProductForm(e, t, s) {
        this.element = e,
        this.product = _validateProductObject(t),
        s = s || {},
        this._listeners = new Listeners,
        this._listeners.add(this.element, "submit", this._onSubmit.bind(this, s)),
        this.optionInputs = this._initInputs(selectors$f.optionInput, s.onOptionChange),
        this.propertyInputs = this._initInputs(selectors$f.propertyInput, s.onPropertyChange)
    }
    function _serializeInputValues(e, t) {
        return e.reduce((function(e, s) {
            return (s.checked || "radio" !== s.type && "checkbox" !== s.type) && e.push(t({
                name: s.name,
                value: s.value
            })),
            e
        }
        ), [])
    }
    function _validateProductObject(e) {
        if ("object" != typeof e)
            throw new TypeError(e + " is not an object.");
        if (void 0 === e.variants[0].options)
            throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
        return e
    }
    ProductForm.prototype.destroy = function() {
        this._listeners.removeAll()
    }
    ,
    ProductForm.prototype.options = function() {
        return _serializeInputValues(this.optionInputs, (function(e) {
            return e.name = /(?:^(options\[))(.*?)(?:\])/.exec(e.name)[2],
            e
        }
        ))
    }
    ,
    ProductForm.prototype.variant = function() {
        return getVariantFromSerializedArray(this.product, this.options())
    }
    ,
    ProductForm.prototype.properties = function() {
        return _serializeInputValues(this.propertyInputs, (function(e) {
            return e.name = /(?:^(properties\[))(.*?)(?:\])/.exec(e.name)[2],
            e
        }
        ))
    }
    ,
    ProductForm.prototype.quantity = function() {
        return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1
    }
    ,
    ProductForm.prototype._setIdInputValue = function(e) {
        var t = this.element.querySelector(selectors$f.idInput);
        t || ((t = document.createElement("input")).type = "hidden",
        t.name = "id",
        this.element.appendChild(t)),
        t.value = e.toString()
    }
    ,
    ProductForm.prototype._onSubmit = function(e, t) {
        t.dataset = this._getProductFormEventData(),
        this._setIdInputValue(t.dataset.variant.id),
        e.onFormSubmit && e.onFormSubmit(t)
    }
    ,
    ProductForm.prototype._onFormEvent = function(e) {
        return void 0 === e ? Function.prototype : function(t) {
            t.dataset = this._getProductFormEventData(),
            e(t)
        }
        .bind(this)
    }
    ,
    ProductForm.prototype._initInputs = function(e, t) {
        return Array.prototype.slice.call(this.element.querySelectorAll(e)).map(function(e) {
            return this._listeners.add(e, "change", this._onFormEvent(t)),
            e
        }
        .bind(this))
    }
    ,
    ProductForm.prototype._getProductFormEventData = function() {
        return {
            options: this.options(),
            variant: this.variant(),
            properties: this.properties()
        }
    }
    ;
    const selectors$g = {
        product: "[data-product]",
        productForm: "[data-product-form]",
        addToCart: "[data-add-to-cart]",
        addToCartText: "[data-add-to-cart-text]",
        comparePrice: "[data-compare-price]",
        comparePriceText: "[data-compare-text]",
        formWrapper: "[data-form-wrapper]",
        originalSelectorId: "[data-product-select]",
        priceWrapper: "[data-price-wrapper]",
        productSlideshow: "[data-product-slideshow]",
        productImage: "[data-product-image]",
        productJson: "[data-product-json]",
        productPrice: "[data-product-price]",
        unitPrice: "[data-product-unit-price]",
        unitBase: "[data-product-base]",
        unitWrapper: "[data-product-unit]",
        singleOptionSelector: "[data-single-option-selector]",
        preOrderTag: "_preorder",
        sliderEnabled: "flickity-enabled",
        productSlide: ".product__slide",
        dataTallLayout: "data-tall-layout",
        dataEnableHistoryState: "data-enable-history-state",
        dataImageId: "data-image-id"
    }
      , classes$3 = {
        hide: "hide",
        variantSoldOut: "variant--soldout",
        variantUnavailable: "variant--unavailabe",
        productPriceSale: "product__price--sale"
    };
    class ProductAddForm {
        constructor(e) {
            if (this.section = e,
            this.container = e.container,
            this.tallLayout = "true" === this.container.getAttribute(selectors$g.dataTallLayout),
            this.product = this.container.querySelector(selectors$g.product),
            !this.product)
                return;
            this.productForm = this.container.querySelector(selectors$g.productForm),
            this.enableHistoryState = "true" === this.container.getAttribute(selectors$g.dataEnableHistoryState);
            new QuantityCounter(this.container).init(),
            this.init(),
            this.hasUnitPricing = this.container.querySelector(selectors$g.unitWrapper)
        }
        init() {
            let e = null;
            const t = this.container.querySelector(selectors$g.productJson);
            t && (e = t.innerHTML),
            e ? (this.productJSON = JSON.parse(e),
            this.linkForm()) : console.error("Missing product JSON")
        }
        destroy() {
            this.productForm.destroy()
        }
        linkForm() {
            this.productForm = new ProductForm(this.productForm,this.productJSON,{
                onOptionChange: this.onOptionChange.bind(this)
            })
        }
        onOptionChange(e) {
            this.updateAddToCartState(e),
            this.updateProductImage(e),
            this.updateProductPrices(e),
            this.enableHistoryState && this.updateHistoryState(e)
        }
        updateAddToCartState(e) {
            const t = e.dataset.variant;
            let s = theme.strings.addToCart;
            const i = this.container.querySelectorAll(selectors$g.priceWrapper)
              , o = this.container.querySelectorAll(selectors$g.addToCart)
              , r = this.container.querySelectorAll(selectors$g.addToCartText)
              , n = this.container.querySelectorAll(selectors$g.formWrapper);
            this.productJSON.tags.includes(selectors$g.preOrderTag) && (s = theme.strings.preOrder),
            i.length && t && i.forEach((e=>{
                e.classList.remove(classes$3.hide)
            }
            )),
            o.length && o.forEach((e=>{
                t && t.available ? e.disabled = !1 : e.disabled = !0
            }
            )),
            r.length && r.forEach((e=>{
                t ? t.available ? e.innerHTML = s : e.innerHTML = theme.strings.soldOut : e.innerHTML = theme.strings.unavailable
            }
            )),
            n.length && n.forEach((e=>{
                if (t) {
                    t.available ? e.classList.remove(classes$3.variantSoldOut, classes$3.variantUnavailable) : (e.classList.add(classes$3.variantSoldOut),
                    e.classList.remove(classes$3.variantUnavailable));
                    const s = e.querySelector(selectors$g.originalSelectorId);
                    s && (s.value = t.id)
                } else
                    e.classList.add(classes$3.variantUnavailable),
                    e.classList.remove(classes$3.variantSoldOut)
            }
            ))
        }
        updateHistoryState(e) {
            const t = e.dataset.variant
              , s = window.location.href;
            if (t && s.includes("/product")) {
                const e = new window.URL(s)
                  , i = e.searchParams;
                i.set("variant", t.id),
                e.search = i.toString();
                const o = e.toString();
                window.history.replaceState({
                    path: o
                }, "", o)
            }
        }
        getBaseUnit(e) {
            return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit
        }
        updateProductPrices(e) {
            const t = e.dataset.variant;
            this.container.querySelectorAll(selectors$g.priceWrapper).forEach((e=>{
                const s = e.querySelector(selectors$g.comparePrice)
                  , i = e.querySelector(selectors$g.productPrice)
                  , o = e.querySelector(selectors$g.comparePriceText);
                t && (i.innerHTML = '<span class="money" data-product-id="'+ t.id +'">' + themeCurrency.formatMoney(t.price, theme.moneyFormat) +'</span>'),
                t && t.compare_at_price > t.price ? (s.innerHTML = themeCurrency.formatMoney(t.compare_at_price, theme.moneyFormat),
                s.classList.remove(classes$3.hide),
                o.classList.remove(classes$3.hide),
                i.classList.add(classes$3.productPriceSale)) : s && (s.innerHTML = "",
                s.classList.add(classes$3.hide),
                o.classList.add(classes$3.hide),
                i.classList.remove(classes$3.productPriceSale))
            }
            )),
            this.hasUnitPricing && this.updateProductUnits(e)
            if( window.BOLD && BOLD.pre){
BOLD.pre.events.emit("variant_changed", {variant: t});
}
        }
        updateProductUnits(e) {
            const t = e.dataset.variant;
            if (void 0 !== t.unit_price) {
                const e = themeCurrency.formatMoney(t.unit_price, theme.moneyFormat)
                  , s = this.getBaseUnit(t);
                this.container.querySelector(selectors$g.unitPrice).innerHTML = e,
                this.container.querySelector(selectors$g.unitBase).innerHTML = s,
                showElement(this.container.querySelector(selectors$g.unitWrapper))
            } else
                hideElement(this.container.querySelector(selectors$g.unitWrapper))
        }
        updateProductImage(e) {
            if (e.target.hasAttribute("data-change-image") && "true" !== e.target.getAttribute("data-change-image"))
                return !1;
            const t = e.dataset.variant;
            if (t && t.featured_media) {
                const e = this.container.querySelector(`${selectors$g.productImage}[${selectors$g.dataImageId}="${t.featured_media.id}"]`)
                  , s = e.closest(selectors$g.productSlide);
                if (s) {
                    const t = Array.from(s.parentElement.children).indexOf(s)
                      , i = this.container.querySelector(selectors$g.productSlideshow);
                    if (i && i.classList.contains(selectors$g.sliderEnabled)) {
                        FlickityFade.data(i).select(t)
                    }
                    !theme.variables.bpSmall && this.tallLayout && 0 !== t && window.scrollTo({
                        top: e.getBoundingClientRect().top + window.scrollY,
                        left: 0,
                        behavior: "smooth"
                    })
                }
            }
        }
    }
    const productFormSection = {
        onLoad() {
            this.section = new ProductAddForm(this)
        },
        onUnload: function() {
            "function" == typeof this.section.unload && this.section.unload()
        }
    }
      , selectors$h = {
        body: "body",
        globalWrapper: "[data-quickview-modal-global]",
        modal: "[data-quickview-modal]",
        outer: "[data-product-grid-item]",
        content: "[data-quickview-content]",
        handle: "data-trigger-quickview",
        productSlides: ".product__slides",
        sliderEnabled: "flickity-enabled",
        reviews: "data-reviews"
    }
      , defaultHTML = '<div class="loader loader--quickview"><div class="loader-indeterminate"></div></div>';
    class QuickviewButton {
        constructor(e, t) {
            this.button = e,
            this.outerSectionId = t,
            this.handle = this.button.getAttribute(selectors$h.handle),
            this.unique = this.handle + "_" + this.outerSectionId,
            this.outer = this.button.closest(selectors$h.outer),
            this.modal = this.outer.querySelector(selectors$h.modal),
            this.globalWrapper = document.querySelectorAll(selectors$h.globalWrapper)[0],
            this.content = this.modal.querySelector(selectors$h.content),
            this.clone = this.modal,
            this.cloneContent = this.content,
            this.body = document.querySelector(selectors$h.body),
            this.accessibility = a11y,
            this.form = {},
            this.init()
        }
        init() {
            this.initButton(),
            this.initFetch()
        }
        initFetch() {
            const e = this;
            this.modal.addEventListener("quickview", (function() {
                e.renderProduct()
            }
            ), !1)
        }
        renderProduct() {
            const e = this;
            this.clone = this.modal.cloneNode(!0),
            this.globalWrapper.append(this.clone),
            this.cloneContent = this.clone.querySelector(selectors$h.content),
            showModal(e.clone, e.onOpen.bind(e), e.onClose.bind(e));
            const t = "/" === window.theme.routes.root ? "" : window.theme.routes.root;
            fetch(t + "/products/" + e.handle + "?view=ajax_quickview").then((function(e) {
                return e.text()
            }
            )).then((function(t) {
                const s = t.replace(/CORGIPOMSKIMELONFELLOW/gi, e.unique);
                e.cloneContent.innerHTML = s,
                e.onLoaded()
            }
            )).catch((function() {
                console.log("error")
            }
            ))
        }
        initButton() {
            const e = this
              , t = this.outer.querySelectorAll(`[${selectors$h.handle}='${this.handle}']`);
            t.length && t.forEach((t=>{
                t.addEventListener("click", (function(t) {
                    t.preventDefault();
                    const s = new CustomEvent("quickview",{
                        handle: e.handle
                    });
                    e.modal.dispatchEvent(s)
                }
                ))
            }
            ))
        }
        onLoaded() {
            const e = this.cloneContent.querySelector(selectors$h.productSlides).classList.contains(selectors$h.sliderEnabled)
              , t = "false" !== this.cloneContent.getAttribute(selectors$h.reviews)
              , s = "function" == typeof window.SPR
              , i = {
                id: this.unique,
                container: this.cloneContent,
                type: "quickview"
            };
            e ? window.dispatchEvent(new Event("resize")) : void 0 === window.theme.mediaInstances[this.id] ? (window.theme.mediaInstances[this.unique] = new Media(i),
            window.theme.mediaInstances[this.unique].init()) : window.theme.mediaInstances[this.unique].initSlider(),
            this.form = new ProductAddForm(i);
            new QuantityCounter(i.container).init(),
            t && s && (window.SPR.initDomEls(),
            window.SPR.loadProducts(),
            window.SPR.loadBadges());
            const o = new CustomEvent("modal-is-loaded",{
                bubbles: !0
            });
            this.globalWrapper.dispatchEvent(o),
            this.accessibility.trapFocus(this.clone, {
                elementToFocus: this.clone.querySelector("a:first-child, input:first-child")
            }),
            void 0 !== window.Shopify && void 0 !== window.Shopify.PaymentButton && void 0 !== window.Shopify.PaymentButton.init && window.Shopify.PaymentButton.init()
        }
        onOpen() {}
        onClose() {
            if (0 !== Object.keys(this.form).length && this.form.constructor === Object && this.form.destroy(),
            this.content.innerHTML = defaultHTML,
            this.accessibility.removeTrapFocus(),
            this.body.classList.contains("is-focused")) {
                const e = document.querySelector(`[data-trigger-quickview="${this.handle}"]`);
                setTimeout((()=>{
                    e.focus()
                }
                ), 200)
            }
            for (; this.globalWrapper.firstChild; )
                this.globalWrapper.removeChild(this.globalWrapper.firstChild)
        }
    }
    var selectors$i = {
        trigger: "[data-trigger-quickview]",
        dataSectionId: "data-section-id"
    }
      , sections$5 = {};
    class Quickview {
        constructor(e) {
            this.container = e.container,
            this.id = this.container.getAttribute(selectors$i.dataSectionId),
            this.init()
        }
        init() {
            sections$5[this.id] = [];
            const e = this
              , t = this.container.querySelectorAll(selectors$i.trigger);
            t.length && t.forEach((t=>{
                const s = new QuickviewButton(t,e.id);
                sections$5[e.id].push(s)
            }
            ))
        }
        onUnload() {
            const e = sections$5[this.id];
            for (let t = 0, s = e.length; t < s; t++) {
                const s = e[t];
                "function" == typeof s.unload && s.unload()
            }
        }
    }
    const quickviewSection = {
        onLoad() {
            this.section = new Quickview(this)
        },
        onUnload() {
            "function" == typeof this.section.unload && this.section.unload()
        }
    };
    var selectors$j = {
        sort: "[data-sort-enabled]",
        sortLinks: "[data-sort-link]",
        sortValue: "data-value",
        collectionNavGrouped: ".collection-nav--grouped",
        collectionSidebarHeading: ".collection__sidebar__heading",
        linkAdd: ".link--add",
        linkRemove: ".link--remove"
    };
    class Collection {
        constructor(e) {
            this.container = e.container,
            this.sort = this.container.querySelector(selectors$j.sort),
            this.sortLinks = this.container.querySelectorAll(selectors$j.sortLinks),
            this.init()
        }
        init() {
            this.sort && this.initClick(),
            this.removeUnusableFilters()
        }
        onClick(e) {
            const t = e.currentTarget.getAttribute(selectors$j.sortValue)
              , s = new window.URL(window.location.href)
              , i = s.searchParams;
            i.set("sort_by", t),
            s.search = i.toString(),
            window.location.replace(s.toString())
        }
        initClick() {
            this.sortLinks.forEach((e=>{
                e.addEventListener("click", function(e) {
                    this.onClick(e)
                }
                .bind(this))
            }
            ))
        }
        removeUnusableFilters() {
            const e = this.container.querySelectorAll(selectors$j.collectionNavGrouped);
            e.length > 0 && e.forEach((e=>{
                const t = e.querySelector(selectors$j.linkAdd)
                  , s = e.querySelector(selectors$j.linkRemove);
                t || s || (hideElement(e),
                hideElement(e.parentElement.querySelector(selectors$j.collectionSidebarHeading)))
            }
            ))
        }
    }
    const collectionSection = {
        onLoad() {
            this.collection = new Collection(this)
        },
        onUnload: function() {
            "function" == typeof this.collection.unload && this.collection.unload()
        }
    };
    register("collection", [parallaxHero, productGridReviews, quickviewSection, collectionSection, popoutSection]);
    const selectors$k = {
        frame: "[data-ticker-frame]",
        scale: "[data-ticker-scale]",
        text: "[data-ticker-text]",
        clone: "data-clone",
        animationClass: "ticker--animated",
        unloadedClass: "ticker--unloaded",
        comparitorClass: "ticker__comparitor"
    }
      , sections$6 = {};
    class Ticker {
        constructor(e) {
            this.frame = e,
            this.scale = this.frame.querySelector(selectors$k.scale),
            this.text = this.frame.querySelector(selectors$k.text),
            this.comparitor = this.text.cloneNode(!0),
            this.comparitor.classList.add(selectors$k.comparitorClass),
            this.frame.appendChild(this.comparitor),
            this.scale.classList.remove(selectors$k.unloadedClass),
            this.listen()
        }
        unload() {
            document.removeEventListener("theme:resize", this.checkWidth)
        }
        listen() {
            document.addEventListener("theme:resize", this.checkWidth.bind(this)),
            this.checkWidth()
        }
        checkWidth() {
            if (this.frame.clientWidth < this.comparitor.clientWidth)
                this.text.classList.add(selectors$k.animationClass),
                1 === this.scale.childElementCount && (this.clone = this.text.cloneNode(!0),
                this.clone.setAttribute("aria-hidden", !0),
                this.clone.setAttribute(selectors$k.clone, ""),
                this.scale.appendChild(this.clone));
            else {
                let e = this.scale.querySelector(`[${selectors$k.clone}]`);
                e && this.scale.removeChild(e),
                this.text.classList.remove(selectors$k.animationClass)
            }
        }
    }
    const ticker = {
        onLoad() {
            sections$6[this.id] = [];
            this.container.querySelectorAll(selectors$k.frame).forEach((e=>{
                sections$6[this.id].push(new Ticker(e))
            }
            ))
        },
        onUnload: function() {
            sections$6[this.id].forEach((e=>{
                "function" == typeof e.unload && e.unload()
            }
            ))
        }
    };
    register("announcement", ticker);
    var selectors$l = {
        body: "body",
        html: "html",
        drawerWrappper: "[data-drawer]",
        underlay: "[data-drawer-underlay]",
        stagger: "[data-stagger-animation]",
        wrapper: "[data-header-transparent]",
        transparent: "data-header-transparent",
        drawerToggle: "data-drawer-toggle",
        focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])'
    }
      , classes$4 = {
        isVisible: "drawer--visible"
    }
      , sections$7 = {};
    class Drawer {
        constructor(e) {
            this.drawer = e,
            this.underlay = this.drawer.querySelector(selectors$l.underlay),
            this.wrapper = this.drawer.closest(selectors$l.wrapper),
            this.transparent = "false" !== this.wrapper.getAttribute(selectors$l.transparent),
            this.key = this.drawer.dataset.drawer;
            const t = `[${selectors$l.drawerToggle}='${this.key}']`;
            this.buttons = document.querySelectorAll(t),
            this.staggers = this.drawer.querySelectorAll(selectors$l.stagger),
            this.body = document.querySelector(selectors$l.body),
            this.html = document.querySelector(selectors$l.html),
            this.connectToggle(),
            this.connectDrawer(),
            this.closers(),
            this.staggerChildAnimations()
        }
        connectToggle() {
            this.buttons.forEach((e=>{
                e.addEventListener("click", function() {
                    this.drawer.dispatchEvent(new CustomEvent("theme:menu:toggle",{
                        bubbles: !1
                    }))
                }
                .bind(this))
            }
            ))
        }
        connectDrawer() {
            this.drawer.addEventListener("theme:menu:toggle", function() {
                this.drawer.classList.contains(classes$4.isVisible) ? this.hideDrawer() : this.showDrawer()
            }
            .bind(this)),
            this.html.addEventListener("cart:open", (()=>{
                this.hideDrawer()
            }
            ))
        }
        staggerChildAnimations() {
            this.staggers.forEach((e=>{
                e.querySelectorAll(":scope > * > [data-animates]").forEach(((e,t)=>{
                    e.style.transitionDelay = 50 * t + 10 + "ms"
                }
                ))
            }
            ))
        }
        watchFocus(e) {
            this.wrapper.contains(e.target) || this.hideDrawer()
        }
        closers() {
            this.drawer.addEventListener("keyup", function(e) {
                e.which === window.theme.keyboardKeys.ESCAPE && (this.hideDrawer(),
                this.buttons[0].focus())
            }
            .bind(this)),
            this.underlay.addEventListener("click", function() {
                this.hideDrawer()
            }
            .bind(this))
        }
        showDrawer() {
            this.transparent = "false" !== this.wrapper.getAttribute(selectors$l.transparent),
            this.buttons.forEach((e=>e.setAttribute("aria-expanded", !0))),
            this.buttons.forEach((e=>e.classList.add(classes$4.isVisible))),
            this.drawer.classList.add(classes$4.isVisible),
            this.drawer.querySelector(selectors$l.focusable).focus(),
            this.wrapper.setAttribute(selectors$l.transparent, !1),
            document.addEventListener("focusin", this.watchFocus.bind(this)),
            setTimeout((()=>{
                document.dispatchEvent(new CustomEvent("theme:scroll:lock",{
                    bubbles: !0
                }))
            }
            ), 20)
        }
        hideDrawer() {
            this.buttons.forEach((e=>e.setAttribute("aria-expanded", !0))),
            this.buttons.forEach((e=>e.classList.remove(classes$4.isVisible))),
            this.drawer.classList.remove(classes$4.isVisible),
            this.wrapper.setAttribute(selectors$l.transparent, this.transparent),
            document.removeEventListener("focusin", this.watchFocus),
            document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{
                bubbles: !0
            }))
        }
    }
    const drawer = {
        onLoad() {
            sections$7[this.id] = [];
            this.container.querySelectorAll(selectors$l.drawerWrappper).forEach((e=>{
                sections$7[this.id].push(new Drawer(e))
            }
            ))
        },
        onUnload: function() {
            sections$7[this.id].forEach((e=>{
                "function" == typeof e.unload && e.unload()
            }
            ))
        }
    }
      , selectors$m = {
        announcement: "[data-announcement-wrapper]",
        transparent: "data-header-transparent",
        header: "[data-header-wrapper] header",
        headerIsNotFixed: '[data-header-sticky="static"]'
    }
      , classes$5 = {
        stuck: "js__header__stuck",
        stuckAnimated: "js__header__stuck--animated",
        triggerAnimation: "js__header__stuck--trigger-animation",
        stuckBackdrop: "js__header__stuck__backdrop",
        headerIsNotVisible: "is-not-visible"
    };
    let sections$8 = {};
    class Sticky {
        constructor(e) {
            this.wrapper = e,
            this.type = this.wrapper.dataset.headerSticky,
            this.transparent = this.wrapper.dataset.headerTransparent,
            this.sticks = "sticky" === this.type,
            this.static = "static" === this.type,
            this.win = window,
            this.animated = "directional" === this.type,
            this.currentlyStuck = !1,
            this.cls = this.wrapper.classList;
            const t = document.querySelector(selectors$m.announcement)
              , s = t ? t.clientHeight : 0;
            this.headerHeight = document.querySelector(selectors$m.header).clientHeight,
            this.blur = this.headerHeight + s,
            this.stickDown = this.headerHeight + s,
            this.stickUp = s,
            "false" !== this.wrapper.getAttribute(selectors$m.transparent) && (this.blur = s),
            this.sticks && (this.stickDown = s,
            this.scrollDownInit()),
            this.static && this.checkIsVisible(),
            this.listen()
        }
        unload() {
            document.removeEventListener("theme:scroll", this.listen),
            document.removeEventListener("theme:scroll:up", this.scrollUpDirectional),
            document.removeEventListener("theme:scroll:down", this.scrollDownDirectional)
        }
        listen() {
            (this.sticks || this.animated) && document.addEventListener("theme:scroll", (e=>{
                e.detail.down ? (!this.currentlyStuck && e.detail.position > this.stickDown && this.stickSimple(),
                !this.currentlyBlurred && e.detail.position > this.blur && this.addBlur()) : (e.detail.position <= this.stickUp && this.unstickSimple(),
                e.detail.position <= this.blur && this.removeBlur())
            }
            )),
            this.animated && (document.addEventListener("theme:scroll:up", this.scrollUpDirectional.bind(this)),
            document.addEventListener("theme:scroll:down", this.scrollDownDirectional.bind(this)))
        }
        stickSimple() {
            this.animated && this.cls.add(classes$5.stuckAnimated),
            this.cls.add(classes$5.stuck),
            this.wrapper.setAttribute(selectors$m.transparent, !1),
            this.currentlyStuck = !0
        }
        unstickSimple() {
            document.documentElement.hasAttribute("data-scroll-locked") || (this.cls.remove(classes$5.stuck),
            this.wrapper.setAttribute(selectors$m.transparent, this.transparent),
            this.animated && this.cls.remove(classes$5.stuckAnimated),
            this.currentlyStuck = !1)
        }
        scrollDownInit() {
            window.scrollY > this.stickDown && this.stickSimple(),
            window.scrollY > this.blur && this.addBlur()
        }
        stickDirectional() {
            this.cls.add(classes$5.triggerAnimation)
        }
        unstickDirectional() {
            this.cls.remove(classes$5.triggerAnimation)
        }
        scrollDownDirectional() {
            this.unstickDirectional()
        }
        scrollUpDirectional() {
            window.scrollY <= this.stickDown ? this.unstickDirectional() : this.stickDirectional()
        }
        addBlur() {
            this.cls.add(classes$5.stuckBackdrop),
            this.currentlyBlurred = !0
        }
        removeBlur() {
            this.cls.remove(classes$5.stuckBackdrop),
            this.currentlyBlurred = !1
        }
        checkIsVisible() {
            const e = this
              , t = document.querySelector(selectors$m.headerIsNotFixed);
            document.addEventListener("theme:scroll", (()=>{
                const s = e.win.pageYOffset;
                t.classList.toggle(classes$5.headerIsNotVisible, s >= e.headerHeight)
            }
            ))
        }
    }
    const stickyHeader = {
        onLoad() {
            sections$8 = new Sticky(this.container)
        },
        onUnload: function() {
            "function" == typeof sections$8.unload && sections$8.unload()
        }
    }
      , selectors$n = {
        disclosureToggle: "data-hover-disclosure-toggle",
        disclosureWrappper: "[data-hover-disclosure]",
        link: "[data-top-link]",
        meganavVisible: "meganav--visible",
        wrapper: "[data-header-wrapper]",
        stagger: "[data-stagger]",
        staggerPair: "[data-stagger-first]",
        staggerAfter: "[data-stagger-second]",
        staggerImage: "[data-grid-item], [data-header-image]",
        focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    }
      , classes$6 = {
        isVisible: "is-visible"
    };
    let sections$9 = {}
      , disclosures = {};
    class HoverDisclosure {
        constructor(e) {
            this.disclosure = e,
            this.wrapper = e.closest(selectors$n.wrapper),
            this.key = this.disclosure.id;
            const t = `[${selectors$n.disclosureToggle}='${this.key}']`;
            this.trigger = document.querySelector(t),
            this.link = this.trigger.querySelector(selectors$n.link),
            this.grandparent = this.trigger.classList.contains("grandparent"),
            this.trigger.setAttribute("aria-haspopup", !0),
            this.trigger.setAttribute("aria-expanded", !1),
            this.trigger.setAttribute("aria-controls", this.key),
            this.connectHoverToggle(),
            this.handleTablets(),
            this.staggerChildAnimations()
        }
        onBlockSelect(e) {
            this.disclosure.contains(e.target) && this.showDisclosure()
        }
        onBlockDeselect(e) {
            this.disclosure.contains(e.target) && this.hideDisclosure()
        }
        showDisclosure() {
            this.grandparent ? this.wrapper.classList.add(selectors$n.meganavVisible) : this.wrapper.classList.remove(selectors$n.meganavVisible),
            this.trigger.setAttribute("aria-expanded", !0),
            this.trigger.classList.add(classes$6.isVisible),
            this.disclosure.classList.add(classes$6.isVisible)
        }
        hideDisclosure() {
            this.disclosure.classList.remove(classes$6.isVisible),
            this.trigger.classList.remove(classes$6.isVisible),
            this.trigger.setAttribute("aria-expanded", !1),
            this.wrapper.classList.remove(selectors$n.meganavVisible)
        }
        staggerChildAnimations() {
            this.disclosure.querySelectorAll(selectors$n.stagger).forEach(((e,t)=>{
                e.style.transitionDelay = 50 * t + 10 + "ms"
            }
            ));
            this.disclosure.querySelectorAll(selectors$n.staggerPair).forEach(((e,t)=>{
                const s = 150 * t;
                e.style.transitionDelay = `${s}ms`,
                e.parentElement.querySelectorAll(selectors$n.staggerAfter).forEach(((e,t)=>{
                    const i = 20 * (t + 1);
                    e.style.transitionDelay = `${s + i}ms`
                }
                ))
            }
            ));
            this.disclosure.querySelectorAll(selectors$n.staggerImage).forEach(((e,t)=>{
                e.style.transitionDelay = 80 * (t + 1) + "ms"
            }
            ))
        }
        handleTablets() {
            this.trigger.addEventListener("touchstart", function(e) {
                this.disclosure.classList.contains(classes$6.isVisible) || (e.preventDefault(),
                this.showDisclosure())
            }
            .bind(this), {
                passive: !0
            })
        }
        connectHoverToggle() {
            this.trigger.addEventListener("mouseenter", debounce(this.showDisclosure.bind(this), 100)),
            this.link.addEventListener("focus", debounce(this.showDisclosure.bind(this), 100)),
            this.trigger.addEventListener("mouseleave", debounce(this.hideDisclosure.bind(this), 100)),
            this.trigger.addEventListener("focusout", debounce(function(e) {
                this.trigger.contains(e.relatedTarget) || this.hideDisclosure()
            }
            .bind(this)), 100),
            this.disclosure.addEventListener("keyup", function(e) {
                e.which === window.theme.keyboardKeys.ESCAPE && this.hideDisclosure()
            }
            .bind(this))
        }
    }
    const hoverDisclosure = {
        onLoad() {
            sections$9[this.id] = [],
            disclosures = this.container.querySelectorAll(selectors$n.disclosureWrappper),
            disclosures.forEach((e=>{
                sections$9[this.id].push(new HoverDisclosure(e))
            }
            ))
        },
        onBlockSelect(e) {
            sections$9[this.id].forEach((t=>{
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e)
            }
            ))
        },
        onBlockDeselect(e) {
            sections$9[this.id].forEach((t=>{
                "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e)
            }
            ))
        },
        onUnload: function() {
            sections$9[this.id].forEach((e=>{
                "function" == typeof e.unload && e.unload()
            }
            ))
        }
    }
      , selectors$o = {
        count: "data-cart-count"
    };
    class Totals {
        constructor(e) {
            this.section = e,
            this.counts = this.section.querySelectorAll(`[${selectors$o.count}]`),
            this.cart = null,
            this.listen()
        }
        listen() {
            document.addEventListener("theme:cart:change", function(e) {
                this.cart = e.detail.cart,
                this.update()
            }
            .bind(this))
        }
        update() {
            this.cart && this.counts.forEach((e=>{
                e.setAttribute(selectors$o.count, this.cart.item_count),
                e.innerHTML = `${this.cart.item_count}`
            }
            ))
        }
    }
    const headerTotals = {
        onLoad() {
            new Totals(this.container)
        }
    };
    function fetchProduct(e) {
        let t = window.theme.routes.root_url || "";
        "/" !== t[t.length - 1] && (t = `${t}/`);
        const s = `${t}products/${e}.js`;
        return window.fetch(s).then((e=>e.json())).catch((e=>{
            console.error(e)
        }
        ))
    }
    const selectors$p = {
        saleClass: "sale",
        soldClass: "sold-out",
        doubleImage: "double__image"
    };
    function formatPrices(e) {
        const t = e.price <= e.compare_at_price_min;
        let s = t ? selectors$p.saleClass : "";
        if (s += e.available ? "" : selectors$p.soldClass,
        e.price = themeCurrency.formatMoney(e.price, theme.moneyFormat),
        e.price_with_from = e.price,
        e.prive_varies) {
            let t = themeCurrency.formatMoney(e.price_min, theme.moneyFormat);
            e.price_with_from = `<small>${window.theme.strings.from}</small> ${t}`
        }
        let i = "";
        void 0 !== e.media && e.media.length > 1 && (i += selectors$p.doubleImage);
        return {
            ...e,
            classes: s,
            on_sale: t,
            double_class: i,
            sold_out: !e.available,
            sold_out_translation: window.theme.strings.soldOut,
            compare_at_price: themeCurrency.formatMoney(e.compare_at_price, theme.moneyFormat),
            compare_at_price_max: themeCurrency.formatMoney(e.compare_at_price_max, theme.moneyFormat),
            compare_at_price_min: themeCurrency.formatMoney(e.compare_at_price_min, theme.moneyFormat),
            price_max: themeCurrency.formatMoney(e.price_max, theme.moneyFormat),
            price_min: themeCurrency.formatMoney(e.price_min, theme.moneyFormat)
        }
    }
    const selectors$q = {
        append: "[data-predictive-search-append]",
        input: "data-predictive-search-input",
        productTemplate: "[product-grid-item-template]",
        productWrapper: "[data-product-wrap]",
        productWrapperOuter: "[data-product-wrap-outer]",
        titleTemplate: "[data-predictive-search-title-template]",
        titleWrapper: "[data-search-title-wrap]",
        dirtyClass: "dirty",
        loadingClass: "is-loading",
        searchPopdown: "search-popdown"
    };
    class SearchPredictive {
        constructor(e) {
            this.input = e,
            this.key = this.input.getAttribute(selectors$q.input);
            const t = `[id='${this.key}']`;
            this.append = document.querySelector(t),
            this.productTemplate = document.querySelector(selectors$q.productTemplate).innerHTML,
            this.titleTemplate = document.querySelector(selectors$q.titleTemplate).innerHTML,
            this.titleWrapper = document.querySelector(selectors$q.titleWrapper),
            this.productWrapper = this.append.querySelector(selectors$q.productWrapper),
            this.productWrapperOuter = this.append.querySelector(selectors$q.productWrapperOuter),
            this.popdown = document.getElementById(selectors$q.searchPopdown),
            this.result = null,
            this.accessibility = a11y,
            this.initSearch()
        }
        initSearch() {
            this.input.addEventListener("input", debounce(function(e) {
                const t = e.target.value;
                t && t.length > 1 ? (this.productWrapperOuter.classList.add(selectors$q.loadingClass),
                this.render(t)) : (this.reset(),
                this.append.classList.remove(selectors$q.dirtyClass))
            }
            .bind(this), 300)),
            this.input.addEventListener("clear", this.reset.bind(this))
        }
        render(e) {
            fetch(`/search/suggest.json?q=${encodeURIComponent(e)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`).then(this.handleErrors).then((e=>e.json())).then((e=>(this.result = e.resources.results,
            this.fetchProducts(e.resources.results.products)))).then((t=>{
                this.injectTitle(e),
                setTimeout((()=>{
                    this.reset(!1),
                    this.productWrapperOuter.classList.remove(selectors$q.loadingClass),
                    this.injectProduct(t),
                    this.append.classList.add(selectors$q.dirtyClass),
                    this.accessibility.trapFocus(this.popdown),
                    this.input.focus()
                }
                ), 1e3)
            }
            )).catch((e=>{
                console.error(e)
            }
            ))
        }
        reset(e=!0) {
            this.productWrapper.innerHTML = "",
            this.append.classList.remove(selectors$q.dirtyClass),
            this.input.val = "",
            this.accessibility.removeTrapFocus(),
            e && (this.titleWrapper.innerHTML = "",
            this.popdown.classList.remove("results-visible"))
        }
        injectTitle(e) {
            let t = window.theme.strings.noResultsFor
              , s = "";
            this.result && this.result.products.length > 0 && (s = this.result.products.length,
            t = window.theme.strings.resultsFor),
            this.popdown.classList.add("results-visible"),
            this.titleWrapper.innerHTML = Sqrl.render(this.titleTemplate, {
                count: s,
                title: t,
                query: e
            })
        }
        injectProduct(e) {
            this.productWrapper.innerHTML += e
        }
        fetchProducts(e) {
            const t = [];
            return e.forEach((e=>{
                t.push(fetchProduct(e.handle).then((e=>{
                    const t = formatPrices(e);
                    return this.renderProduct(t)
                }
                )))
            }
            )),
            Promise.all(t).then((e=>{
                let t = "";
                return e.forEach((e=>{
                    t += e
                }
                )),
                t
            }
            ))
        }
        renderProduct(e) {
            let t = null
              , s = null
              , i = ""
              , o = "";
            void 0 !== e.media && (t = e.media[0],
            s = e.media[1]),
            t && (i = {
                thumb: themeImages.getSizedImageUrl(t.preview_image.src, "800x800"),
                alt: t.preview_image.src
            }),
            s && (o = {
                thumb: themeImages.getSizedImageUrl(s.preview_image.src, "800x800"),
                alt: s.preview_image.src
            });
            const r = {
                ...e,
                image: i,
                image_2: o
            };
            return Sqrl.render(this.productTemplate, {
                product: r
            })
        }
        handleErrors(e) {
            return e.ok ? e : e.json().then((function(t) {
                throw new FetchError({
                    status: e.statusText,
                    headers: e.headers,
                    json: t
                })
            }
            ))
        }
    }
    const selectors$r = {
        body: "body",
        popdownTrigger: "data-popdown-toggle",
        close: "[data-close-popdown]",
        input: "[data-predictive-search-input]"
    }
      , classes$7 = {
        isVisible: "is-visible"
    };
    let sections$a = {};
    class SearchPopdownTriggers {
        constructor(e) {
            this.trigger = e,
            this.key = this.trigger.getAttribute(selectors$r.popdownTrigger),
            this.search = null;
            const t = `[id='${this.key}']`;
            this.document = document,
            this.popdown = document.querySelector(t),
            this.input = this.popdown.querySelector(selectors$r.input),
            this.close = this.popdown.querySelector(selectors$r.close),
            this.body = document.querySelector(selectors$r.body),
            this.accessibility = a11y,
            this.initTriggerEvents(),
            this.initPopdownEvents()
        }
        initTriggerEvents() {
            this.trigger.setAttribute("aria-haspopup", !0),
            this.trigger.setAttribute("aria-expanded", !1),
            this.trigger.setAttribute("aria-controls", this.key),
            this.trigger.addEventListener("click", (e=>{
                e.preventDefault(),
                this.body.classList.contains("is-focused") || this.showPopdown()
            }
            )),
            this.trigger.addEventListener("keyup", (e=>{
                e.which !== window.theme.keyboardKeys.SPACE && e.which !== window.theme.keyboardKeys.ENTER || !this.body.classList.contains("is-focused") || this.showPopdown()
            }
            ))
        }
        initPopdownEvents() {
            this.search = new SearchPredictive(this.input),
            this.popdown.addEventListener("keyup", function(e) {
                e.which === window.theme.keyboardKeys.ESCAPE && this.hidePopdown()
            }
            .bind(this)),
            this.close.addEventListener("click", function() {
                this.hidePopdown()
            }
            .bind(this)),
            this.document.addEventListener("click", (e=>{
                const t = e.target
                  , s = !(t.matches(`[${selectors$r.popdownTrigger}]`) || t.closest(`[${selectors$r.popdownTrigger}]`))
                  , i = !(t.matches(`#${this.key}`) || t.closest(`#${this.key}`));
                s && i && this.popdown.classList.contains(classes$7.isVisible) && this.hidePopdown()
            }
            ))
        }
        hidePopdown() {
            this.popdown.classList.remove(classes$7.isVisible),
            this.input.form.reset(),
            this.input.dispatchEvent(new CustomEvent("clear",{
                bubbles: !1
            })),
            this.accessibility.removeTrapFocus(),
            document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{
                bubbles: !0
            })),
            this.body.classList.contains("is-focused") && setTimeout((()=>{
                this.trigger.focus()
            }
            ), 200)
        }
        showPopdown() {
            document.dispatchEvent(new CustomEvent("theme:scroll:lock",{
                bubbles: !0
            })),
            this.popdown.classList.add(classes$7.isVisible);
            const e = this.input.value;
            this.input.value = "",
            this.input.value = e,
            this.accessibility.trapFocus(this.popdown),
            this.input.focus()
        }
    }
    const searchPopdown = {
        onLoad() {
            sections$a[this.id] = [];
            this.container.querySelectorAll(`[${selectors$r.popdownTrigger}]`).forEach((e=>{
                sections$a[this.id].push(new SearchPopdownTriggers(e))
            }
            ))
        },
        onUnload: function() {
            sections$a[this.id].forEach((e=>{
                "function" == typeof e.unload && e.unload()
            }
            ))
        }
    }
      , selectors$s = {
        slideruleOpen: "data-sliderule-open",
        slideruleClose: "data-sliderule-close",
        sliderulePane: "data-sliderule-pane",
        slideruleWrappper: "[data-sliderule]",
        focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        children: ":scope > [data-animates], \n             :scope > * > [data-animates], \n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *"
    }
      , classes$8 = {
        isVisible: "is-visible"
    };
    let sections$b = {};
    class HeaderMobileSliderule {
        constructor(e) {
            this.sliderule = e,
            this.wrapper = e.closest(selectors$s.wrapper),
            this.key = this.sliderule.id;
            const t = `[${selectors$s.slideruleOpen}='${this.key}']`
              , s = `[${selectors$s.slideruleClose}='${this.key}']`;
            this.trigger = document.querySelector(t),
            this.exit = document.querySelector(s),
            this.pane = document.querySelector(`[${selectors$s.sliderulePane}]`),
            this.children = this.sliderule.querySelectorAll(selectors$s.children),
            this.trigger.setAttribute("aria-haspopup", !0),
            this.trigger.setAttribute("aria-expanded", !1),
            this.trigger.setAttribute("aria-controls", this.key),
            this.clickEvents(),
            this.staggerChildAnimations()
        }
        clickEvents() {
            this.trigger.addEventListener("click", function() {
                this.showSliderule()
            }
            .bind(this)),
            this.exit.addEventListener("click", function() {
                this.hideSliderule()
            }
            .bind(this))
        }
        keyboardEvents() {
            this.trigger.addEventListener("keyup", function(e) {
                e.which === window.theme.keyboardKeys.SPACE && this.showSliderule()
            }
            .bind(this)),
            this.sliderule.addEventListener("keyup", function(e) {
                e.which === window.theme.keyboardKeys.ESCAPE && (this.hideSliderule(),
                this.buttons[0].focus())
            }
            .bind(this))
        }
        staggerChildAnimations() {
            this.children.forEach(((e,t)=>{
                e.style.transitionDelay = 50 * t + 10 + "ms"
            }
            ))
        }
        hideSliderule() {
            this.sliderule.classList.remove(classes$8.isVisible),
            this.children.forEach((e=>{
                e.classList.remove(classes$8.isVisible)
            }
            ));
            const e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
            this.pane.setAttribute(selectors$s.sliderulePane, e)
        }
        showSliderule() {
            this.sliderule.classList.add(classes$8.isVisible),
            this.children.forEach((e=>{
                e.classList.add(classes$8.isVisible)
            }
            ));
            const e = parseInt(this.pane.dataset.sliderulePane, 10) + 1;
            this.pane.setAttribute(selectors$s.sliderulePane, e)
        }
    }
    const headerMobileSliderule = {
        onLoad() {
            sections$b[this.id] = [];
            this.container.querySelectorAll(selectors$s.slideruleWrappper).forEach((e=>{
                sections$b[this.id].push(new HeaderMobileSliderule(e))
            }
            ))
        },
        onUnload: function() {
            sections$b[this.id].forEach((e=>{
                "function" == typeof e.unload && e.unload()
            }
            ))
        }
    }
      , selectors$t = {
        wrapper: "[data-header-wrapper]",
        style: "data-header-style",
        widthContentWrapper: "[data-takes-space-wrapper]",
        widthContent: "[data-child-takes-space]",
        desktop: "[data-header-desktop]",
        cloneClass: "js__header__clone",
        showMobileClass: "js__show__mobile",
        backfill: "[data-header-backfill]",
        transparent: "data-header-transparent",
        overrideBorder: "header-override-border",
        firstSectionHasImage: ".main-content > .shopify-section:first-child [data-overlay-header]",
        deadLink: '.navlink[href="#"]'
    };
    let sections$c = {};
    class Header {
        constructor(e) {
            this.wrapper = e,
            this.style = this.wrapper.dataset.style,
            this.desktop = this.wrapper.querySelector(selectors$t.desktop),
            this.transparent = "false" !== this.wrapper.getAttribute(selectors$t.transparent),
            this.overlayedImages = document.querySelectorAll(selectors$t.firstSectionHasImage),
            this.deadLinks = document.querySelectorAll(selectors$t.deadLink),
            this.killDeadLinks(),
            "drawer" !== this.style && this.desktop && (this.minWidth = this.getMinWidth(),
            this.listenWidth()),
            this.checkForImage(),
            window.dispatchEvent(new Event("resize"))
        }
        unload() {
            document.removeEventListener("theme:resize", this.checkWidth)
        }
        checkForImage() {
            this.overlayedImages.length > 0 && this.transparent ? (document.querySelector(selectors$t.backfill).style.display = "none",
            this.listenOverlay()) : this.wrapper.setAttribute(selectors$t.transparent, !1),
            this.overlayedImages.length > 0 && !this.transparent && (this.wrapper.classList.add(selectors$t.overrideBorder),
            this.subtractHeaderHeight())
        }
        listenOverlay() {
            document.addEventListener("theme:resize", this.subtractAnnouncementHeight.bind(this)),
            this.subtractAnnouncementHeight()
        }
        listenWidth() {
            document.addEventListener("theme:resize", this.checkWidth.bind(this)),
            this.checkWidth()
        }
        killDeadLinks() {
            this.deadLinks.forEach((e=>{
                e.onclick = e=>{
                    e.preventDefault()
                }
            }
            ))
        }
        subtractAnnouncementHeight() {
            const {windowHeight: e, announcementHeight: t, headerHeight: s} = readHeights();
            this.overlayedImages.forEach((i=>{
                i.style.setProperty("--full-screen", e - t + "px"),
                i.style.setProperty("--header-padding", `${s}px`),
                i.classList.add("has-overlay")
            }
            ))
        }
        subtractHeaderHeight() {
            const {windowHeight: e, headerHeight: t} = readHeights();
            this.overlayedImages.forEach((s=>{
                s.style.setProperty("--full-screen", e - t + "px")
            }
            ))
        }
        checkWidth() {
            document.body.clientWidth < this.minWidth ? this.wrapper.classList.add(selectors$t.showMobileClass) : this.wrapper.classList.remove(selectors$t.showMobileClass)
        }
        getMinWidth() {
            const e = this.wrapper.cloneNode(!0);
            e.classList.add(selectors$t.cloneClass),
            document.body.appendChild(e);
            const t = e.querySelectorAll(selectors$t.widthContentWrapper);
            let s = 0
              , i = 0;
            return t.forEach((e=>{
                const t = e.querySelectorAll(selectors$t.widthContent);
                let o = 0;
                o = 3 === t.length ? _sumSplitWidths(t) : _sumWidths(t),
                o > s && (s = o,
                i = 20 * t.length)
            }
            )),
            document.body.removeChild(e),
            s + i
        }
    }
    function _sumSplitWidths(e) {
        let t = [];
        e.forEach((e=>{
            e.firstElementChild && t.push(e.firstElementChild.clientWidth)
        }
        )),
        t[0] > t[2] ? t[2] = t[0] : t[0] = t[2];
        return t.reduce(((e,t)=>e + t))
    }
    function _sumWidths(e) {
        let t = 0;
        return e.forEach((e=>{
            t += e.clientWidth
        }
        )),
        t
    }
    const header = {
        onLoad() {
            sections$c = new Header(this.container)
        },
        onUnload: function() {
            "function" == typeof sections$c.unload && sections$c.unload()
        }
    };
    register("header", [header, drawer, popoutSection, headerMobileSliderule, stickyHeader, hoverDisclosure, headerTotals, searchPopdown]);
    const selectors$u = {
        slider: ".look__slider",
        slide: ".look__slide",
        prevArrow: "[data-prev-arrow]",
        nextArrow: "[data-next-arrow]",
        classIsHidden: "is-hidden",
        dataSlideIndex: "data-slide-index"
    }
      , sections$d = {};
    class Look {
        constructor(e) {
            this.container = e.container,
            this.slideshow = this.container.querySelector(selectors$u.slider),
            this.sliderPrev = this.container.querySelector(selectors$u.prevArrow),
            this.sliderNext = this.container.querySelector(selectors$u.nextArrow),
            this.flkty = null,
            this.init()
        }
        init() {
            const e = this;
            this.flkty = new Flickity(this.slideshow,{
                autoPlay: !1,
                prevNextButtons: !1,
                contain: !0,
                pageDots: !1,
                adaptiveHeight: !0,
                wrapAround: !0,
                on: {
                    ready: function() {
                        this.slides.length > 1 ? (e.sliderPrev.classList.remove(selectors$u.classIsHidden),
                        e.sliderNext.classList.remove(selectors$u.classIsHidden)) : (e.sliderPrev.classList.add(selectors$u.classIsHidden),
                        e.sliderNext.classList.add(selectors$u.classIsHidden))
                    }
                }
            }),
            this.sliderPrev.addEventListener("click", (function(t) {
                t.preventDefault(),
                e.flkty.previous(!0)
            }
            )),
            this.sliderNext.addEventListener("click", (function(t) {
                t.preventDefault(),
                e.flkty.next(!0)
            }
            ))
        }
        onBlockSelect(e) {
            const t = this.slideshow.querySelector(`${selectors$u.slide}--${e.detail.blockId}`)
              , s = parseInt(t.getAttribute(selectors$u.dataSlideIndex));
            this.flkty.select(s),
            this.flkty.stopPlayer()
        }
    }
    const lookSection = {
        onLoad() {
            sections$d[this.id] = new Look(this)
        },
        onBlockSelect(e) {
            sections$d[this.id].onBlockSelect(e)
        }
    };
    register("look", [lookSection, productGridReviews, quickviewSection]);
    const selectors$v = {
        mobileSlider: ".product-grid--slider",
        flickityInitialized: "flickity-enabled"
    };
    class GridSlider {
        constructor(e) {
            this.container = e,
            this.mobileSlider = this.container.querySelector(selectors$v.mobileSlider),
            this.flkty = null,
            this.init()
        }
        init() {
            this.mobileCheck(),
            document.addEventListener("theme:resize", this.mobileCheck.bind(this))
        }
        initMobileSlider() {
            this.mobileSlider && !this.mobileSlider.classList.contains(selectors$v.flickityInitialized) && (this.flkty = new Flickity(this.mobileSlider,{
                contain: !0,
                pageDots: !1,
                arrowShape: "M4.068 18.649l15.466 16.105c.31.283.466.629.466 1.039 0 .41-.155.77-.466 1.08a1.412 1.412 0 0 1-1.038.424c-.41 0-.756-.141-1.038-.424L.466 19.708A1.373 1.373 0 0 1 0 18.648c0-.423.155-.776.466-1.059L17.458.424A1.412 1.412 0 0 1 18.496 0c.41 0 .755.141 1.038.424.31.282.466.636.466 1.06 0 .423-.155.776-.466 1.059L4.068 18.649z"
            }))
        }
        destroyMobileSlider() {
            this.flkty && "function" == typeof this.flkty.destroy && this.flkty.destroy()
        }
        mobileCheck() {
            window.innerWidth < window.theme.sizes.small ? this.initMobileSlider() : this.destroyMobileSlider()
        }
    }
    const gridSlider = {
        onLoad() {
            new GridSlider(this.container)
        }
    };
    register("product-grid", [productGridReviews, gridSlider, quickviewSection]);
    const selectors$w = {
        quantityAdjust: ".js-qty__adjust",
        quantityAdjustPlus: "js-qty__adjust--plus",
        quantityAdjustMinus: "js-qty__adjust--minus",
        quantityNum: ".js-qty__num"
    }
      , quantity = (e,t)=>{
        if ("keyup" === e.type && 13 !== e.keyCode)
            return;
        const s = t
          , i = s.parentElement.querySelector(selectors$w.quantityNum);
        let o = parseInt(i.value.replace(/\D/g, ""));
        (parseFloat(o) != parseInt(o) || isNaN(o)) && (o = 1),
        s.classList.contains(selectors$w.quantityAdjustPlus) ? o += 1 : (o -= 1,
        o <= 1 && (o = 1)),
        i.value = o,
        i.dispatchEvent(new Event("click"))
    }
    ;
    function quantitySelectors() {
        document.querySelectorAll(selectors$w.quantityAdjust).forEach((e=>{
            e.addEventListener("click", (function(t) {
                quantity(t, e)
            }
            )),
            e.addEventListener("keyup", (function(t) {
                quantity(t, e)
            }
            ))
        }
        ));
        document.querySelectorAll(selectors$w.quantityNum).forEach((e=>{
            e.addEventListener("keyup", (function(e) {
                38 == e.keyCode && this.parentElement.querySelector(`.${selectors$w.quantityAdjustPlus}`).dispatchEvent(new Event("click")),
                40 == e.keyCode && this.parentElement.querySelector(`.${selectors$w.quantityAdjustMinus}`).dispatchEvent(new Event("click"))
            }
            ))
        }
        ))
    }
    window.theme.variables = {
        productPageSticky: !1,
        bpSmall: !1,
        mediaQuerySmall: 750
    };
    const selectors$x = {
        addToCart: "[data-add-to-cart]",
        priceWrapper: "[data-price-wrapper]",
        slideshow: "[data-product-slideshow]",
        productImage: "[data-product-image]",
        productJson: "[data-product-json]",
        form: "[data-product-form]",
        dropdown: "[data-single-option-selector]",
        thumbs: "[data-product-thumbs]",
        dataSectionId: "data-section-id",
        dataTallLayout: "data-tall-layout",
        dataStickyEnabled: "data-sticky-enabled",
        dataCartBar: "data-cart-bar",
        dataReviews: "data-reviews",
        productPage: ".product__page",
        formWrapper: ".form__wrapper",
        accordionToggle: ".accordion-toggle",
        accordionIcon: ".accordion__icon",
        tabs: ".tabs",
        productTabsWrapper: ".productTabsWrapper",
        productAccordion: ".product-accordion",
        productTabs: ".product-tabs",
        tabsLi: "ul.tabs > li",
        tabLink: ".tab-link",
        tabContent: ".tab-content",
        dataTab: "data-tab",
        cartBar: "#cart-bar",
        selectTag: "select",
        dataPosition: "data-position",
        productSubmitAdd: ".product__submit__add",
        dataIndex: "data-index",
        templateProduct: "#template-product",
        siteFooterWrapper: ".site-footer-wrapper",
        shopifyProductReviews: "#shopify-product-reviews",
        classCurrent: "current",
        classSticky: "is-sticky",
        classStickyHeader: "with-sticky-header",
        classRotate: "rotate-90",
        classCartBarVisible: "cart-bar--is-visible",
        classSiteFooterPush: "site-footer--push",
        headerSticky: '[data-header-sticky="sticky"]'
    };
    class Product {
        constructor(e) {
            this.section = e,
            this.container = e.container,
            this.id = this.container.getAttribute(selectors$x.dataSectionId),
            this.tallLayout = "true" === this.container.getAttribute(selectors$x.dataTallLayout),
            this.stickyEnabled = "true" === this.container.getAttribute(selectors$x.dataStickyEnabled),
            this.headerSticky = null !== document.querySelector(selectors$x.headerSticky),
            this.showReviews = "true" === this.container.getAttribute(selectors$x.dataReviews),
            this.thumbs = this.container.querySelector(selectors$x.thumbs);
            const t = this.container.querySelector(selectors$x.productJson);
            if (t && !t.innerHTML || !t)
                return;
            this.form = this.container.querySelector(selectors$x.form),
            this.init(),
            this.tabs(),
            this.tabsSpaceCheck(),
            quantitySelectors(),
            this.accordion(),
            this.stickyEnabled && this.stickyScroll(),
            "true" === this.container.getAttribute(selectors$x.dataCartBar) && this.initCartBar();
            window.addEventListener("resize", this.tabsSpaceCheck);
            const s = "function" == typeof window.SPR;
            this.showReviews && s && (window.SPR.initDomEls(),
            window.SPR.loadBadges())
        }
        init() {
            theme.mediaInstances[this.id] = new Media(this.section),
            theme.mediaInstances[this.id].init()
        }
        stickyScroll() {
            this.stickyScrollCheck(),
            document.addEventListener("theme:resize", (()=>this.stickyScrollCheck()))
        }
        stickyScrollCheck() {
            const e = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) >= theme.variables.mediaQuerySmall
              , t = this.container.querySelector(selectors$x.formWrapper)
              , s = this.container.querySelector(`${selectors$x.productPage} ${selectors$x.formWrapper}`);
            let i = !0;
            if (this.showReviews && (i = !1),
            e) {
                const e = this.container.querySelector(selectors$x.slideshow);
                if (!t || !e)
                    return;
                const o = t.offsetHeight;
                o < e.offsetHeight && o < window.innerHeight && i ? (theme.variables.productPageSticky = !0,
                s.classList.add(selectors$x.classSticky),
                this.headerSticky && s.classList.add(selectors$x.classStickyHeader)) : (theme.variables.productPageSticky = !1,
                s.classList.remove(selectors$x.classSticky))
            } else
                s.classList.remove(selectors$x.classSticky)
        }
        tabs() {
            const e = this.container
              , t = e.querySelectorAll(selectors$x.tabsLi)
              , s = e.querySelector(`${selectors$x.tabLink}-0`)
              , i = e.querySelector(`${selectors$x.tabContent}-0`);
            if (i && i.classList.add(selectors$x.classCurrent),
            s && s.classList.add(selectors$x.classCurrent),
            t.length) {
                const s = t=>{
                    const s = parseInt(t.getAttribute(selectors$x.dataTab));
                    e.querySelector(`${selectors$x.tabsLi}.${selectors$x.classCurrent}`).classList.remove(selectors$x.classCurrent),
                    e.querySelector(`${selectors$x.tabContent}.${selectors$x.classCurrent}`).classList.remove(selectors$x.classCurrent),
                    t.classList.add(selectors$x.classCurrent),
                    e.querySelector(`${selectors$x.tabContent}-${s}`).classList.add(selectors$x.classCurrent)
                }
                ;
                t.forEach((e=>{
                    e.addEventListener("click", (function(t) {
                        s(e)
                    }
                    )),
                    e.addEventListener("keyup", (function(t) {
                        "keyup" === t.type && 13 !== t.keyCode || s(e)
                    }
                    ))
                }
                ))
            }
        }
        accordion() {
            const e = this.container.querySelectorAll(selectors$x.accordionToggle);
            if (e.length) {
                const t = this;
                e.forEach((e=>{
                    e.addEventListener("click", (function(e) {
                        const s = this.nextElementSibling
                          , i = s && "DIV" === s.tagName;
                        i && "none" !== window.getComputedStyle(s).display ? slideUp(s) : i && (slideDown(s),
                        t.stickyScrollCheck);
                        const o = this.querySelector(selectors$x.accordionIcon);
                        o && o.classList.toggle(selectors$x.classRotate)
                    }
                    ))
                }
                ))
            }
        }
        tabsSpaceCheck() {
            if (this.container && this.container.querySelector(selectors$x.tabs) && this.container.querySelector(selectors$x.productTabsWrapper)) {
                const e = this.container.querySelector(selectors$x.tabs).clientWidth
                  , t = this.container.querySelector(selectors$x.productTabsWrapper).clientWidth - 31
                  , s = this.container.querySelector(selectors$x.productAccordion)
                  , i = this.container.querySelector(selectors$x.productTabs);
                e >= t ? (i && (i.style.position = "absolute",
                i.style.left = "-9999px",
                i.style.display = "table"),
                s && showElement(s)) : (i && i.removeAttribute("style"),
                s && hideElement(s))
            }
        }
        initCartBar() {
            const e = this
              , t = document.querySelector(selectors$x.cartBar)
              , s = t.querySelectorAll(selectors$x.selectTag)
              , i = this.form.querySelectorAll(selectors$x.dropdown)
              , o = t.getAttribute(selectors$x.dataPosition)
              , r = this.form.querySelector(selectors$x.addToCart);
            t.addEventListener("click", (function(e) {
                const t = e.target;
                (t.matches(selectors$x.productSubmitAdd) || t.closest(selectors$x.productSubmitAdd)) && (e.preventDefault(),
                r.dispatchEvent(new Event("click")))
            }
            )),
            s.length && s.forEach((t=>{
                t.addEventListener("change", (function() {
                    const t = this.getAttribute(selectors$x.dataIndex)
                      , s = this.value
                      , i = e.form.querySelectorAll(`${selectors$x.dropdown}[${selectors$x.dataIndex}="${t}"]`);
                    if ("INPUT" === i[0].tagName)
                        for (const e of i) {
                            const i = e.getAttribute(selectors$x.dataIndex)
                              , o = e.value;
                            if (i === t && o === s) {
                                e.checked = !0,
                                e.dispatchEvent(new Event("change"));
                                break
                            }
                        }
                    else {
                        const e = i[0].parentNode;
                        e.value = s,
                        e.dispatchEvent(new Event("change"))
                    }
                }
                ))
            }
            )),
            i.length && i.forEach((e=>{
                e.addEventListener("change", (function() {
                    const e = this.getAttribute(selectors$x.dataIndex)
                      , s = this.value;
                    t.querySelector(`[${selectors$x.dataIndex}="${e}"]`).value = s
                }
                ))
            }
            )),
            this.cartBar = t,
            document.addEventListener("theme:scroll", this.scrollTop.bind(this)),
            "top" === o && (this.setCartBarPosition(),
            document.addEventListener("theme:scroll", this.setCartBarPosition.bind(this)))
        }
        scrollTop() {
            const e = window.pageYOffset
              , t = document.querySelector(selectors$x.siteFooterWrapper);
            if (this.form && this.cartBar) {
                e > this.form.offsetTop + this.form.offsetHeight ? (this.cartBar.classList.add(selectors$x.classCartBarVisible),
                t.classList.add(selectors$x.classSiteFooterPush)) : (this.cartBar.classList.remove(selectors$x.classCartBarVisible),
                t.classList.remove(selectors$x.classSiteFooterPush))
            }
        }
        setCartBarPosition() {
            this.headerSticky ? this.cartBar.style.top = "var(--menu-height)" : this.cartBar.style.top = "0"
        }
    }
    const productSection = {
        onLoad() {
            this.section = new Product(this)
        },
        onUnload: function() {
            "function" == typeof this.section.unload && this.section.unload()
        }
    };
    register("product", [productFormSection, productSection]),
    register("list-collections", gridSlider);
    const selectors$y = {
        body: "body",
        dataRelatedSectionElem: "[data-related-section]",
        dataRelatedProduct: "[data-product-grid-item]",
        dataProductId: "data-product-id",
        dataLimit: "data-limit",
        datTab: "data-tab",
        dataTabIndex: "data-tab-index",
        tabsLi: "ul.tabs > li",
        tabLink: ".tab-link",
        tabLinkRecent: ".tab-link__recent",
        tabContent: ".tab-content",
        recentlyViewed: "#RecentlyViewed",
        recentlyProduct: "#recently-viewed-products .product-item"
    }
      , classes$9 = {
        classCurrent: "current",
        classHide: "hide",
        classAlt: "alt"
    };
    class Related {
        constructor(e) {
            this.section = e,
            this.container = e.container,
            this.body = document.querySelector(selectors$y.body),
            this.accessibility = window.accessibility,
            this.init(),
            this.tabs(),
            this.recent()
        }
        init() {
            const e = this.container.querySelector(selectors$y.dataRelatedSectionElem);
            if (!e)
                return;
            const t = this
              , s = e.getAttribute(selectors$y.dataProductId)
              , i = e.getAttribute(selectors$y.dataLimit)
              , o = `${window.theme.routes.product_recommendations_url}?section_id=related&limit=${i}&product_id=${s}`
              , r = this.section;
            fetch(o).then((function(e) {
                return e.text()
            }
            )).then((function(s) {
                const i = document.createElement("div");
                i.innerHTML = s;
                const o = i.querySelector(selectors$y.dataRelatedSectionElem);
                if (o.querySelector(selectors$y.dataRelatedProduct)) {
                    const t = o.innerHTML;
                    hideElement(e),
                    e.innerHTML = t,
                    slideDown(e),
                    Shopify.Products.hasProducts && document.querySelector(selectors$y.recentlyViewed) || new Quickview(r)
                } else
                    t.hideRelatedTab()
            }
            )).catch((function() {
                t.hideRelatedTab()
            }
            ))
        }
        hideRelatedTab() {
            const e = this.container.querySelector(selectors$y.dataRelatedSectionElem);
            if (!e)
                return;
            const t = e.closest(`${selectors$y.tabContent}.${classes$9.classCurrent}`);
            if (!t)
                return;
            const s = parseInt(t.getAttribute(selectors$y.dataTabIndex))
              , i = this.container.querySelectorAll(selectors$y.tabsLi);
            if (i.length > s) {
                const e = i[s].nextSibling;
                e && (i[s].classList.add(classes$9.classHide),
                e.dispatchEvent(new Event("click")))
            }
        }
        tabs() {
            const e = this.container
              , t = e.querySelectorAll(selectors$y.tabsLi)
              , s = e.querySelector(`${selectors$y.tabLink}-0`)
              , i = e.querySelector(`${selectors$y.tabContent}-0`);
            i && i.classList.add(classes$9.classCurrent),
            s && s.classList.add(classes$9.classCurrent),
            this.checkVisibleTabLinks(),
            t.length && t.forEach((t=>{
                const s = parseInt(t.getAttribute(selectors$y.datTab))
                  , i = e.querySelector(`${selectors$y.tabContent}-${s}`);
                t.addEventListener("click", (()=>{
                    this.tabChange(t, e, i)
                }
                )),
                t.addEventListener("keyup", (s=>{
                    s.which !== window.theme.keyboardKeys.SPACE && s.which !== window.theme.keyboardKeys.ENTER || !this.body.classList.contains("is-focused") || (this.tabChange(t, e, i),
                    i.querySelector("a, input") && (this.accessibility.lastFocused = t,
                    this.accessibility.a11y.trapFocus(i, {
                        elementToFocus: i.querySelector("a:first-child, input:first-child")
                    })))
                }
                ))
            }
            ))
        }
        tabChange(e, t, s) {
            t.querySelector(`${selectors$y.tabsLi}.${classes$9.classCurrent}`).classList.remove(classes$9.classCurrent),
            t.querySelector(`${selectors$y.tabContent}.${classes$9.classCurrent}`).classList.remove(classes$9.classCurrent),
            e.classList.add(classes$9.classCurrent),
            s.classList.add(classes$9.classCurrent),
            e.classList.contains(classes$9.classHide) && s.classList.add(classes$9.classHide),
            this.checkVisibleTabLinks(),
            this.accessibility.a11y.removeTrapFocus()
        }
        checkVisibleTabLinks() {
            const e = this.container.querySelectorAll(selectors$y.tabsLi)
              , t = this.container.querySelectorAll(`${selectors$y.tabLink}.${classes$9.classHide}`);
            e.length - t.length < 2 ? this.container.classList.add(classes$9.classAlt) : this.container.classList.remove(classes$9.classAlt)
        }
        recent() {
            const e = this
              , t = this.section
              , s = document.querySelector(selectors$y.recentlyViewed);
            let i = 4;
            s && (i = parseInt(s.getAttribute(selectors$y.dataLimit)),
            Shopify.Products.recordRecentlyViewed()),
            Shopify.Products.showRecentlyViewed({
                howManyToShow: i,
                onComplete: function() {
                    if (document.querySelectorAll(selectors$y.recentlyProduct).length > 0) {
                        fadeIn(s);
                        const i = document.querySelector(selectors$y.tabLinkRecent);
                        if (i) {
                            i.classList.remove(classes$9.classHide);
                            const t = parseInt(i.getAttribute(selectors$y.datTab))
                              , s = document.querySelector(`${selectors$y.tabContent}[${selectors$y.dataTabIndex}="${t}"]`);
                            s && s.classList.remove(classes$9.classHide),
                            e.checkVisibleTabLinks()
                        }
                        new Quickview(t)
                    }
                }
            })
        }
    }
    const relatedSection = {
        onLoad() {
            this.section = new Related(this),
            new Quickview(this)
        },
        onUnload: function() {
            "function" == typeof this.section.unload && this.section.unload()
        }
    };
    register("related", [relatedSection, popoutSection]);
    const sections$e = {}
      , selectors$z = {
        logo: "[data-slider-logo]",
        text: "[data-slider-text]",
        slide: "[data-slide]",
        slideData: "data-slide",
        asNavFor: "#nav-for-",
        prevArrow: "[data-prev-arrow]",
        nextArrow: "[data-next-arrow]",
        slideIndex: "data-slide-index",
        flickityEnabled: "flickity-enabled",
        classIsSelected: "is-selected"
    };
    class LogoList {
        constructor(e) {
            this.container = e.container,
            this.slideshowText = this.container.querySelector(selectors$z.text),
            this.slideshowNav = this.container.querySelector(selectors$z.logo),
            this.slideshowPrev = this.container.querySelector(selectors$z.prevArrow),
            this.slideshowNext = this.container.querySelector(selectors$z.nextArrow),
            this.logoSlides = this.slideshowNav.querySelectorAll(selectors$z.slide),
            this.textSlides = this.slideshowText.querySelectorAll(selectors$z.slide),
            this.flkty = null,
            this.flktyNav = null,
            this.init()
        }
        init() {
            this.flkty = new Flickity(this.slideshowText,{
                autoPlay: !1,
                prevNextButtons: !1,
                contain: !0,
                pageDots: !1,
                wrapAround: !1,
                selectedAttraction: .3,
                friction: .8,
                draggable: !1
            }),
            this.logoSlides.forEach((e=>{
                e.addEventListener("click", function(e) {
                    const t = parseInt(e.currentTarget.getAttribute(selectors$z.slideIndex))
                      , s = this.slideshowNav.classList.contains(selectors$z.flickityEnabled);
                    this.flkty.select(t),
                    s ? this.flktyNav.select(t) : (this.logoSlides.forEach((e=>{
                        e.classList.remove(selectors$z.classIsSelected)
                    }
                    )),
                    e.currentTarget.classList.add(selectors$z.classIsSelected))
                }
                .bind(this))
            }
            ));
            let e = -1;
            this.textSlides && (this.textSlides.forEach((t=>{
                const s = parseFloat(getComputedStyle(t, null).height.replace("px", ""));
                s > e && (e = s)
            }
            )),
            this.textSlides.forEach((t=>{
                const s = parseFloat(getComputedStyle(t, null).height.replace("px", ""));
                if (s < e) {
                    const i = Math.ceil((e - s) / 2);
                    t.style.margin = `${i}px 0`
                }
            }
            ))),
            this.initSlideshowNav()
        }
        onUnload() {
            this.slideshowNav.classList.contains(selectors$z.flickityEnabled) && this.flktyNav.destroy(),
            this.flkty.destroy()
        }
        onBlockSelect(e) {
            const t = this.slideshowText.querySelector(`[${selectors$z.slideData}="${e.detail.blockId}"]`)
              , s = parseInt(t.getAttribute(selectors$z.slideIndex));
            this.slideshowNav.classList.contains(selectors$z.flickityEnabled) && (this.flktyNav.select(s),
            this.flktyNav.stopPlayer()),
            this.flkty.select(s),
            this.flkty.stopPlayer()
        }
        onBlockDeselect() {
            this.slideshowNav.classList.contains(selectors$z.flickityEnabled) && this.flktyNav.playPlayer()
        }
        goToPrevSlide(e) {
            e.preventDefault(),
            this.flktyNav.previous(!0),
            this.flkty.previous(!0)
        }
        goToNextSlide(e) {
            e.preventDefault(),
            this.flktyNav.next(!0),
            this.flkty.next(!0)
        }
        initSlideshowNav() {
            this.slideshowPrev.addEventListener("click", this.goToPrevSlide.bind(this)),
            this.slideshowNext.addEventListener("click", this.goToNextSlide.bind(this));
            const e = ()=>{
                const e = this.slideshowNav.querySelectorAll(selectors$z.slide).length
                  , t = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
                  , s = 200 * e
                  , i = this.slideshowNav.classList.contains(selectors$z.flickityEnabled);
                s > t ? i || (this.logoSlides.forEach((e=>{
                    e.classList.remove(selectors$z.classIsSelected)
                }
                )),
                this.flktyNav = new Flickity(this.slideshowNav,{
                    autoPlay: !1,
                    prevNextButtons: !1,
                    contain: !0,
                    pageDots: !1,
                    selectedAttraction: .05,
                    friction: .8
                })) : i && (this.flktyNav.destroy(),
                this.logoSlides[0].classList.add(selectors$z.classIsSelected))
            }
            ;
            e(),
            window.addEventListener("resize", debounce(e.bind(this), 200))
        }
    }
    const LogoListSection = {
        onLoad() {
            sections$e[this.id] = new LogoList(this)
        },
        onUnload(e) {
            sections$e[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            sections$e[this.id].onBlockSelect(e)
        }
    };
    register("logos", LogoListSection);
    const sections$f = {}
      , selectors$A = {
        reviewWithImage: "reviews-with-image",
        reviewSlider: ".reviews__slider--",
        reviewSlide: ".review__slide",
        reviewSliderArrow: ".reviews__slider-arrow",
        prevArrow: "[data-prev-arrow]",
        nextArrow: "[data-next-arrow]",
        dataSlides: "data-slides",
        dataSlideIndex: "data-slide-index",
        classIsHidden: "is-hidden",
        classIsSelected: "is-selected",
        classSliderInitialized: "reviews__slider--initialized",
        blockquote: "blockquote"
    };
    class Reviews {
        constructor(e) {
            this.container = e.container;
            const t = e.id;
            this.slideshow = this.container.querySelector(selectors$A.reviewSlider + t),
            this.hasImage = this.container.classList.contains(selectors$A.reviewWithImage),
            this.slides = this.container.querySelectorAll(selectors$A.reviewSlide),
            this.slidesNumber = this.slides.length,
            this.sliderPrev = this.container.querySelector(selectors$A.prevArrow),
            this.sliderNext = this.container.querySelector(selectors$A.nextArrow),
            this.flkty = null,
            this.init()
        }
        init() {
            const e = this;
            this.flkty = new Flickity(this.slideshow,{
                autoPlay: !1,
                prevNextButtons: !1,
                contain: !0,
                pageDots: !1,
                adaptiveHeight: !0,
                wrapAround: !0,
                percentPosition: !0,
                cellAlign: "left",
                draggable: !1,
                on: {
                    ready: function() {
                        e.showArrows()
                    }
                }
            }),
            window.addEventListener("resize", debounce((function() {
                e.showArrows(),
                e.flkty.resize(),
                e.slideshow.classList.contains(selectors$A.classSliderInitialized) || e.flkty.select(0)
            }
            ), 100)),
            this.sliderPrev.addEventListener("click", (function(t) {
                t.preventDefault(),
                e.flkty.previous(!0)
            }
            )),
            this.sliderNext.addEventListener("click", (function(t) {
                t.preventDefault(),
                e.flkty.next(!0)
            }
            ))
        }
        showArrows() {
            const e = parseInt(this.slideshow.getAttribute(selectors$A.dataSlides))
              , t = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            let s = !1;
            if (this.hasImage)
                this.hasImage && this.slidesNumber > 1 && (s = !0);
            else {
                const i = t > 1339 && this.slidesNumber > e
                  , o = t <= 1339 && t > 1023 && this.slidesNumber > 3
                  , r = t <= 1023 && t > 767 && this.slidesNumber > 2
                  , n = t <= 767 && this.slidesNumber > 1;
                (i || o || r || n) && (s = !0)
            }
            s ? (this.sliderPrev.classList.remove(selectors$A.classIsHidden),
            this.sliderNext.classList.remove(selectors$A.classIsHidden),
            this.slideshow.classList.add(selectors$A.classSliderInitialized)) : (this.sliderPrev.classList.add(selectors$A.classIsHidden),
            this.sliderNext.classList.add(selectors$A.classIsHidden),
            this.slideshow.classList.remove(selectors$A.classSliderInitialized))
        }
        onBlockSelect(e) {
            const t = this.slideshow.querySelector(`${selectors$A.reviewSlide}--${e.detail.blockId}`)
              , s = parseInt(t.getAttribute(selectors$A.dataSlideIndex));
            this.slideshow.classList.contains(selectors$A.classSliderInitialized) ? this.flkty.select(s) : this.flkty.select(0)
        }
    }
    const ReviewsSection = {
        onLoad() {
            sections$f[this.id] = new Reviews(this)
        },
        onUnload(e) {
            sections$f[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            sections$f[this.id].onBlockSelect(e)
        }
    };
    register("reviews", ReviewsSection);
    const sections$g = {}
      , selectors$B = {
        testimonialWithImage: "testimonials-with-image",
        testimonialSlider: ".testimonials__slider--",
        testimonialSlide: ".testimonial__slide",
        testimonialSliderArrow: ".testimonials__slider-arrow",
        prevArrow: "[data-prev-arrow]",
        nextArrow: "[data-next-arrow]",
        dataSlides: "data-slides",
        dataSlideIndex: "data-slide-index",
        classIsHidden: "is-hidden",
        classIsSelected: "is-selected",
        blockquote: "blockquote"
    };
    class Testimonials {
        constructor(e) {
            this.container = e.container;
            const t = e.id;
            this.slideshow = this.container.querySelector(selectors$B.testimonialSlider + t),
            this.hasImage = this.container.classList.contains(selectors$B.testimonialWithImage),
            this.slides = this.container.querySelectorAll(selectors$B.testimonialSlide),
            this.sliderPrev = this.container.querySelector(selectors$B.prevArrow),
            this.sliderNext = this.container.querySelector(selectors$B.nextArrow),
            this.flkty = null,
            this.init()
        }
        init() {
            const e = this
              , t = ()=>{
                const t = e.slides.length
                  , s = parseInt(e.slideshow.getAttribute(selectors$B.dataSlides))
                  , i = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                let o = !1;
                if (e.hasImage)
                    e.hasImage && t > 1 && (o = !0);
                else {
                    const e = i <= 1339 && i > 1023 && t > 3
                      , r = i <= 1023 && i > 767 && t > 2
                      , n = i <= 767 && t > 1;
                    (i > 1339 && t > s || e || r || n) && (o = !0)
                }
                o ? (e.sliderPrev.classList.remove(selectors$B.classIsHidden),
                e.sliderNext.classList.remove(selectors$B.classIsHidden)) : (e.sliderPrev.classList.add(selectors$B.classIsHidden),
                e.sliderNext.classList.add(selectors$B.classIsHidden))
            }
            ;
            this.flkty = new Flickity(this.slideshow,{
                autoPlay: !1,
                prevNextButtons: !1,
                contain: !0,
                pageDots: !1,
                adaptiveHeight: !0,
                wrapAround: !0,
                percentPosition: !0,
                cellAlign: "left",
                draggable: !1,
                on: {
                    ready: function() {
                        t()
                    }
                }
            }),
            window.addEventListener("resize", debounce((function() {
                e.flkty.resize(),
                t()
            }
            ), 100)),
            this.sliderPrev.addEventListener("click", (function(t) {
                t.preventDefault(),
                e.flkty.previous(!0)
            }
            )),
            this.sliderNext.addEventListener("click", (function(t) {
                t.preventDefault(),
                e.flkty.next(!0)
            }
            ))
        }
        onBlockSelect(e) {
            const t = this.slideshow.querySelector(`${selectors$B.testimonialSlide}--${e.detail.blockId}`)
              , s = parseInt(t.getAttribute(selectors$B.dataSlideIndex));
            this.flkty.select(s),
            this.flkty.stopPlayer()
        }
    }
    const TestimonialsSection = {
        onLoad() {
            sections$g[this.id] = new Testimonials(this)
        },
        onUnload(e) {
            sections$g[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            sections$g[this.id].onBlockSelect(e)
        }
    };
    register("testimonials", TestimonialsSection);
    const sections$h = {}
      , selectors$C = {
        shopifySection: ".shopify-section",
        headerContent: ".header__content",
        heroContent: ".hero__content",
        heroContentWrapper: ".hero__content__wrapper",
        videoPlay: ".js-video__play",
        dataHtml: "data-html"
    };
    class FeaturedVideo {
        constructor(e) {
            this.container = e.container,
            this.parentContainer = this.container.closest(selectors$C.shopifySection),
            this.parentContainerIdx = Array.from(this.parentContainer.parentElement.children).indexOf(this.parentContainer),
            this.heroContent = this.container.querySelector(selectors$C.heroContent),
            this.heroContentWrapper = this.container.querySelector(selectors$C.heroContentWrapper),
            this.videoPlay = this.container.querySelector(selectors$C.videoPlay);
            this.setMinHeight(),
            window.addEventListener("resize", debounce(this.setMinHeight(), 100)),
            this.videoPlay.addEventListener("click", (function(e) {
                if (this.hasAttribute(selectors$C.dataHtml) && "" !== this.getAttribute(selectors$C.dataHtml).trim()) {
                    e.preventDefault();
                    const t = [{
                        html: this.getAttribute(selectors$C.dataHtml)
                    }];
                    openPhotoSwipe(t)
                }
            }
            ))
        }
        setMinHeight() {
            const e = 0 == this.parentContainerIdx
              , t = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
              , s = document.querySelector(selectors$C.headerContent);
            let i = 0;
            s && (i = parseFloat(getComputedStyle(s, null).height.replace("px", "")));
            let o = t >= 750 ? i : 0;
            e || (o = 0);
            const r = o + this.heroContent.offsetHeight;
            this.container.style.minHeight = `${r}px`,
            this.heroContentWrapper.style.paddingTop = `${o}px`
        }
        onReorder() {
            this.setMinHeight()
        }
    }
    const FeaturedVideoSection = {
        onLoad() {
            sections$h[this.id] = new FeaturedVideo(this)
        },
        onUnload(e) {
            sections$h[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            sections$h[this.id].onBlockSelect(e)
        }
    };
    register("featured-video", FeaturedVideoSection);
    const throttle = (e,t)=>{
        let s, i;
        return function o(...r) {
            const n = Date.now();
            i = clearTimeout(i),
            !s || n - s >= t ? (e.apply(null, r),
            s = n) : i = setTimeout(o.bind(null, ...r), t - (n - s))
        }
    }
      , sections$i = {}
      , selectors$D = {
        shopifySection: ".shopify-section",
        headerContent: ".header__content",
        heroContent: ".hero__content",
        heroContentWrapper: ".hero__content__wrapper",
        checkTrueString: "true",
        dataSectionId: "data-section-id",
        dataEnableSound: "data-enable-sound",
        dataVideoId: "data-video-id",
        dataVideoType: "data-video-type",
        attrId: "id",
        loaded: "loaded",
        videoIframe: ".video__iframe",
        videoWrapper: ".video-wrapper",
        youtubeWrapper: "[data-youtube-wrapper]"
    }
      , players$1 = [];
    let isYoutubeAPIReady = !1;
    const defaultYoutubeOptions = {
        height: "720",
        width: "1280",
        playerVars: {
            cc_load_policy: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            autohide: 0,
            controls: 0,
            branding: 0,
            showinfo: 0,
            rel: 0,
            fs: 0,
            wmode: "opaque"
        },
        events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerStateChange
        }
    };
    function onPlayerReady(e) {
        const t = e.target.getIframe()
          , s = t.getAttribute(selectors$D.attrId)
          , i = document.querySelector(`#${s}`).getAttribute(selectors$D.dataEnableSound) === selectors$D.checkTrueString;
        t.setAttribute("tabindex", "-1"),
        i ? e.target.unMute() : e.target.mute(),
        e.target.playVideo(),
        checkPlayerVisibility(s),
        window.addEventListener("scroll", throttle((()=>{
            checkPlayerVisibility(s)
        }
        ), 150))
    }
    function onPlayerStateChange(e) {
        0 == e.data && e.target.playVideo(),
        1 == e.data && e.target.getIframe().parentElement.classList.add(selectors$D.loaded)
    }
    function checkPlayerVisibility(e) {
        let t;
        if ("string" == typeof e)
            t = e;
        else {
            if (null == e.data)
                return !1;
            t = e.data.id
        }
        const s = document.getElementById(t + "-container")
          , i = players$1[t]
          , o = s.getBoundingClientRect();
        let r = visibilityHelper.isElementPartiallyVisible(s) || visibilityHelper.isElementTotallyVisible(s);
        o.top < 0 && s.clientHeight + o.top >= 0 && (r = !0),
        r && i && "function" == typeof i.playVideo ? i.playVideo() : !r && i && "function" == typeof i.pauseVideo && i.pauseVideo()
    }
    class FeaturedBackgroundVideo {
        constructor(e) {
            this.container = e.container,
            this.parentContainer = this.container.closest(selectors$D.shopifySection),
            this.parentContainerIdx = Array.from(this.parentContainer.parentElement.children).indexOf(this.parentContainer);
            const t = this.player = this.container.querySelector(selectors$D.videoIframe);
            this.setMinHeight(),
            window.addEventListener("resize", debounce(this.setMinHeight(), 250)),
            t && (this.playerID = t.querySelector(selectors$D.youtubeWrapper).getAttribute(selectors$D.attrId),
            this.videoID = t.getAttribute(selectors$D.dataVideoId),
            this.videoType = t.getAttribute(selectors$D.dataVideoType),
            this.init()),
            document.addEventListener("touchstart", (function(e) {
                if (e.target.matches(selectors$D.videoWrapper) || e.target.closest(selectors$D.videoWrapper)) {
                    const t = e.target.querySelector(selectors$D.videoIframe).getAttribute(selectors$D.attrId);
                    players$1[t].playVideo()
                }
            }
            ))
        }
        init() {
            if ("youtube" == this.videoType)
                isYoutubeAPIReady ? this.loadYoutubePlayer() : (window.loadYoutubeAPI(),
                document.body.addEventListener("youtubeAPIReady", this.loadYoutubePlayer.bind(this)));
            else if ("vimeo" == this.videoType) {
                const e = "https://vimeo.com/api/oembed.json"
                  , t = "https://vimeo.com/" + this.videoID;
                let s = "";
                const i = this
                  , o = {
                    url: t,
                    background: !0,
                    muted: !0,
                    autoplay: !0
                };
                for (let e in o)
                    s += encodeURIComponent(e) + "=" + encodeURIComponent(o[e]) + "&";
                fetch(`${e}?${s}`).then((e=>e.json())).then((function(e) {
                    i.player.innerHTML = e.html,
                    setTimeout((function() {
                        i.player.parentElement.classList.add(selectors$D.loaded)
                    }
                    ), 1e3)
                }
                )).catch((function() {
                    console.log("error")
                }
                ))
            }
        }
        setMinHeight() {
            const e = 0 == this.parentContainerIdx
              , t = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
              , s = document.querySelector(selectors$D.headerContent);
            let i = 0;
            s && (i = parseFloat(getComputedStyle(s, null).height.replace("px", "")));
            let o = t >= 750 ? i : 0;
            e || (o = 0);
            const r = o + this.container.querySelector(selectors$D.heroContent).offsetHeight;
            this.container.style.minHeight = `${r}px`,
            this.container.querySelector(selectors$D.heroContentWrapper).style.paddingTop = `${o}px`
        }
        loadYoutubePlayer() {
            const e = Object.assign({}, defaultYoutubeOptions);
            e.videoId = this.videoID,
            this.videoID.length && (players$1[this.playerID] = new YT.Player(this.playerID,e)),
            isYoutubeAPIReady = !0
        }
        onReorder() {
            this.setMinHeight()
        }
        onUnload(e) {
            const t = "youtube-" + this.container.getAttribute(selectors$D.dataSectionId);
            players$1[t].destroy()
        }
    }
    const FeaturedBackgroundVideoSection = {
        onLoad() {
            sections$i[this.id] = new FeaturedBackgroundVideo(this)
        },
        onUnload(e) {
            sections$i[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            sections$i[this.id].onBlockSelect(e)
        }
    };
    register("featured-background-video", FeaturedBackgroundVideoSection);
    const sections$j = {}
      , selectors$E = {
        shopifySection: ".shopify-section",
        slideshow: "#slideshow-",
        slideshowSlide: ".slideshow__slide",
        slideshowSlideImg: ".slide-image-img",
        headerContent: ".header__content",
        heroContent: ".hero__content",
        heroContentWrapper: ".hero__content__wrapper",
        heroContentTransparent: "hero__content--transparent",
        slideshowPrev: ".slideshow__arrow--prev",
        slideshowNext: ".slideshow__arrow--next",
        sliderDots: ".flickity-page-dots",
        dataAspectRatio: "data-aspectratio",
        dataDots: "data-dots",
        dataAutoplay: "data-autoplay",
        dataAutoplaySpeed: "data-speed",
        dataColor: "data-color",
        dataSlideIndex: "data-slide-index",
        textDark: "text-dark",
        textLight: "text-light",
        classIsSelected: "is-selected",
        checkTrueString: "true",
        transparentWrapper: "transparent__wrapper",
        flickityEnabled: "flickity-enabled"
    };
    class Slideshow {
        constructor(e) {
            this.container = e.container,
            this.sectionId = e.id,
            this.slideshow = this.container.querySelector(selectors$E.slideshow + this.sectionId),
            this.parentContainer = this.container.closest(selectors$E.shopifySection),
            this.parentContainerIdx = Array.from(this.parentContainer.parentElement.children).indexOf(this.parentContainer),
            this.heroContentWrapper = this.slideshow.querySelector(selectors$E.heroContentWrapper),
            this.slideshowPrev = this.container.querySelector(selectors$E.slideshowPrev),
            this.slideshowNext = this.container.querySelector(selectors$E.slideshowNext),
            this.flkty = null,
            this.init()
        }
        init() {
            const e = this
              , t = this.slideshow.getAttribute(selectors$E.dataAutoplay) === selectors$E.checkTrueString;
            let s = !1;
            const i = this.slideshow.getAttribute(selectors$E.dataDots) === selectors$E.checkTrueString;
            t && (s = parseInt(this.slideshow.getAttribute(selectors$E.dataAutoplaySpeed))),
            this.setMinHeight(),
            this.flkty = new Flickity(this.slideshow,{
                autoPlay: s,
                prevNextButtons: !1,
                contain: !0,
                pageDots: i,
                adaptiveHeight: !0,
                wrapAround: !0,
                on: {
                    ready: function() {
                        e.slideActions(this.slider, this.element)
                    }
                }
            }),
            this.slideshowPrev.addEventListener("click", (function(t) {
                t.preventDefault(),
                e.flkty.previous(!0)
            }
            )),
            this.slideshowNext.addEventListener("click", (function(t) {
                t.preventDefault(),
                e.flkty.next(!0)
            }
            )),
            this.flkty.on("change", (function(t) {
                e.slideActions(this.slider, this.element)
            }
            )),
            window.addEventListener("resize", debounce(e.setMinHeight.bind(e), 250))
        }
        slideActions(e, t) {
            const s = e.querySelector(`.${selectors$E.classIsSelected}`)
              , i = s.getAttribute(selectors$E.dataColor);
            this.slideshowPrev.classList.remove(selectors$E.textLight, selectors$E.textDark),
            this.slideshowNext.classList.remove(selectors$E.textLight, selectors$E.textDark),
            this.slideshowPrev.classList.add(i),
            this.slideshowNext.classList.add(i),
            this.setDotsColor(t, i),
            this.container.classList.remove(selectors$E.transparentWrapper),
            s.querySelector(selectors$E.heroContentWrapper).classList.contains(selectors$E.heroContentTransparent) && this.container.classList.add(selectors$E.transparentWrapper),
            this.setMinHeight()
        }
        setDotsColor(e, t) {
            const s = e.querySelector(selectors$E.sliderDots);
            s && (s.classList.remove(selectors$E.textLight, selectors$E.textDark),
            s.classList.add(t))
        }
        setMinHeight() {
            const e = this.slideshow
              , t = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
              , s = 0 == this.parentContainerIdx
              , i = document.querySelector(selectors$E.headerContent);
            let o = 0
              , r = 0;
            if (i && (r = parseFloat(getComputedStyle(i, null).height.replace("px", ""))),
            s) {
                const s = e.querySelector(`.${selectors$E.classIsSelected} ${selectors$E.heroContent}`);
                let i = 0;
                const n = t >= 750 ? r : 0;
                s && (i = s.offsetHeight);
                o = n + i + (t >= 750 ? 120 : 40),
                this.heroContentWrapper.style.paddingTop = `${n}px`,
                this.heroContentWrapper.style.marginTop = "0px"
            }
            e.querySelectorAll(selectors$E.slideshowSlide).forEach((t=>{
                const i = t.querySelector(selectors$E.slideshowSlideImg);
                let r = "";
                i && i.hasAttribute(selectors$E.dataAspectRatio) && (r = i.getAttribute(selectors$E.dataAspectRatio));
                let n = 0;
                const a = t.querySelector(selectors$E.heroContent);
                a && (n = a.offsetHeight);
                const l = parseInt(getComputedStyle(t, null).width.replace("px", ""));
                let c = parseInt(l / r) || 0;
                const d = t.classList.contains(selectors$E.classIsSelected);
                s && c < o && (c = o),
                n > c && (c = n),
                t.style.minHeight = `${c}px`,
                t.querySelector(selectors$E.heroContentWrapper).style.minHeight = `${c}px`,
                d && (e.parentElement.style.minHeight = `${c}px`)
            }
            ))
        }
        onUnload() {
            this.flkty.destroy()
        }
        onBlockSelect(e) {
            const t = this.slideshow.querySelector(`${selectors$E.slideshowSlide}--${e.detail.blockId}`)
              , s = parseInt(t.getAttribute(selectors$E.dataSlideIndex));
            this.slideshow.classList.add(selectors$E.classIsSelected),
            this.flkty.select(s),
            this.flkty.stopPlayer()
        }
        onBlockDeselect(e) {
            this.slideshow.classList.remove(selectors$E.classIsSelected),
            this.flkty.playPlayer()
        }
    }
    const SlideshowSection = {
        onLoad() {
            sections$j[this.id] = new Slideshow(this)
        },
        onUnload(e) {
            sections$j[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            sections$j[this.id].onBlockSelect(e)
        },
        onBlockDeselect(e) {
            sections$j[this.id].onBlockDeselect(e)
        }
    };
    register("slideshow", SlideshowSection);
    const sections$k = {}
      , selectors$F = {
        videoPlay: ".image__video__play",
        dataHtml: "data-html"
    };
    class ImageWithText {
        constructor(e) {
            this.container = e.container,
            this.id = e.id,
            this.videoPlay = this.container.querySelector(selectors$F.videoPlay),
            this.videoPlay && this.videoPlay.addEventListener("click", (function(e) {
                if (this.hasAttribute(selectors$F.dataHtml) && "" !== this.getAttribute(selectors$F.dataHtml).trim()) {
                    e.preventDefault();
                    const t = [{
                        html: this.getAttribute(selectors$F.dataHtml)
                    }];
                    openPhotoSwipe(t)
                }
            }
            ))
        }
    }
    const ImageWithTextSection = {
        onLoad() {
            sections$k[this.id] = new ImageWithText(this)
        },
        onUnload(e) {
            sections$k[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            sections$k[this.id].onBlockSelect(e)
        }
    };
    register("image-with-text", ImageWithTextSection);
    const selectors$G = {
        showCalculator: ".show-calculator",
        shippingCalculator: "#ShippingCalculator",
        showNote: ".show-note",
        note: "#NoteForSeller",
        additionalInsert: "[data-additional-insert]",
        cartAdditional: "[data-cart-additional]",
        cartButton: "#CartButton .cart-count-js",
        cartSubtotal: ".cart__subtotal",
        qtyWrapper: ".js-qty",
        qtyAdjust: ".js-qty__adjust",
        dataNewQty: "data-new-quantity",
        dataLineKey: "data-line-key",
        dataCartFormWrapper: "data-cart-form-wrapper",
        dataVariantId: "data-variant-id",
        formErrors: "[data-form-errors]"
    }
      , classes$a = {
        open: "open",
        pulseCartIcon: "pulse-cart-icon",
        qtyDisabled: "qty--disabled",
        qtyNum: "js-qty__num",
        qtyPlus: "js-qty__adjust--plus",
        qtyMinus: "js-qty__adjust--minus"
    }
      , sections$l = {};
    class Cart {
        constructor(e) {
            this.init();
            const t = document.querySelector(selectors$G.cartAdditional);
            document.querySelector(selectors$G.additionalInsert).append(t),
            slideDown(t)
        }
        init() {
            this.initQuantity(),
            document.querySelector(selectors$G.showCalculator).addEventListener("click", (function() {
                slideToggle(document.querySelector(selectors$G.shippingCalculator)),
                this.classList.toggle(classes$a.open)
            }
            )),
            document.querySelector(selectors$G.showNote).addEventListener("click", (function() {
                slideToggle(document.querySelector(selectors$G.note)),
                this.classList.toggle(classes$a.open)
            }
            )),
            Shopify.Cart.ShippingCalculator.show({
                submitButton: theme.strings.shippingCalcSubmitButton,
                submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
                customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
                moneyFormat: theme.strings.shippingCalcMoneyFormat
            })
        }
        updateHeader() {
            try {
                window.fetch("/cart.js").then((function(e) {
                    return e.json()
                }
                )).then((function(e) {
                    const t = e.item_count
                      , s = document.querySelector(selectors$G.cartButton);
                    s && (s.textContent = t,
                    showElement(s),
                    s.classList.add(classes$a.pulseCartIcon),
                    setTimeout((function() {
                        document.querySelector(selectors$G.cartButton).classList.remove(classes$a.pulseCartIcon)
                    }
                    ), 800))
                }
                ))
            } catch (e) {
                console.warn(e)
            }
        }
        initQuantity() {
            const e = this
              , t = document.querySelectorAll(selectors$G.qtyAdjust);
            t && t.forEach((t=>{
                t.addEventListener("click", (function() {
                    const t = this
                      , s = t.closest(selectors$G.qtyWrapper);
                    s.classList.add(classes$a.qtyDisabled);
                    const i = s.children;
                    for (const e of i)
                        e.disabled = !0;
                    const o = parseInt(t.getAttribute(selectors$G.dataNewQty))
                      , r = t.getAttribute(selectors$G.dataLineKey);
                    e.changeQuantity("/cart/change.js", o, r)
                }
                ))
            }
            ))
        }
        changeQuantity(e, t, s) {
            const i = this
              , o = {
                quantity: t,
                id: s
            };
            fetch(e, {
                method: "POST",
                headers: {
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(o)
            }).then((e=>e.json())).then((e=>{
                const t = document.querySelectorAll(`[${selectors$G.dataCartFormWrapper}] [${selectors$G.dataVariantId}]`)
                  , s = document.querySelector(selectors$G.cartSubtotal);
                if (s && (s.textContent = themeCurrency.formatMoney(e.total_price, theme.moneyFormat)),
                e.items.length !== t.length) {
                    let s = !1;
                    for (const i of t) {
                        const t = parseInt(i.getAttribute(selectors$G.dataVariantId));
                        for (const [o,r] of e.items.entries()) {
                            const n = r.id;
                            if (t === n)
                                break;
                            if (t !== n && o === e.items.length - 1) {
                                i.parentNode.removeChild(i),
                                s = !0;
                                break
                            }
                        }
                        if (s)
                            break
                    }
                } else
                    for (const t of e.items) {
                        const e = t.id
                          , s = t.quantity
                          , i = document.querySelector(`[${selectors$G.dataCartFormWrapper}] [${selectors$G.dataVariantId}="${e}"]`).querySelector(selectors$G.qtyWrapper);
                        i.classList.remove(classes$a.qtyDisabled);
                        const o = i.children;
                        for (const e of o)
                            e.disabled = !1,
                            e.classList.contains(classes$a.qtyNum) ? e.value = s : e.classList.contains(classes$a.qtyPlus) ? e.setAttribute(selectors$G.dataNewQty, s + 1) : e.classList.contains(classes$a.qtyMinus) && e.setAttribute(selectors$G.dataNewQty, s - 1)
                    }
                i.init(),
                i.updateHeader()
            }
            )).catch((e=>{
                const t = document.querySelector(selectors$G.formErrors);
                for (; t.firstChild; )
                    t.removeChild(t.firstChild);
                slideUp(t, 100),
                t.innerHTML = e,
                setTimeout((function() {
                    slideDown(t)
                }
                ), 100)
            }
            ))
        }
    }
    const CartSection = {
        onLoad() {
            sections$l[this.id] = new Cart(this)
        },
        onUnload(e) {
            sections$l[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            sections$l[this.id].onBlockSelect(e)
        }
    };
    register("cart", CartSection);
    var styles = {};
    function mapStyle(e) {
        return styles[e]
    }
    styles.basic = [],
    styles.light = [{
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            lightness: "64"
        }, {
            hue: "#ff0000"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#bdbdbd"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f0f0f0"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "labels",
        stylers: [{
            lightness: "100"
        }]
    }, {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{
            visibility: "on"
        }]
    }, {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{
            saturation: "-41"
        }, {
            color: "#e8ede7"
        }]
    }, {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: "-100"
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            lightness: "25"
        }, {
            gamma: "1.06"
        }, {
            saturation: "-100"
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            gamma: "10.00"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            gamma: "10.00"
        }, {
            lightness: "100"
        }, {
            weight: "0.4"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            weight: "0.01"
        }, {
            lightness: "39"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.50"
        }, {
            gamma: "10.00"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#cfe5ee"
        }, {
            visibility: "on"
        }]
    }],
    styles.white_label = [{
        featureType: "all",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            gamma: "3.86"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#cccccc"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f2f2f2"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: -100
        }, {
            lightness: 45
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#e4e4e4"
        }, {
            visibility: "on"
        }]
    }],
    styles.dark_label = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{
            saturation: 36
        }, {
            color: "#000000"
        }, {
            lightness: 40
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [{
            visibility: "on"
        }, {
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: 1.2
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            lightness: "-82"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{
            invert_lightness: !0
        }, {
            weight: "7.15"
        }]
    }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 21
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 29
        }, {
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 18
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 19
        }]
    }, {
        featureType: "water",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }]
    }],
    window.theme.allMaps = window.theme.allMaps || {};
    let allMaps = window.theme.allMaps;
    window.theme.mapAPI = window.theme.mapAPI || null;
    class Map {
        constructor(e) {
            this.container = e.container,
            this.mapContainer = this.container.querySelector("[data-map-container]"),
            this.key = this.container.getAttribute("data-api-key"),
            this.styleString = this.container.getAttribute("data-style") || "",
            this.zoomString = this.container.getAttribute("data-zoom") || 14,
            this.address = this.container.getAttribute("data-address"),
            this.enableCorrection = this.container.getAttribute("data-latlong-correction"),
            this.lat = this.container.getAttribute("data-lat"),
            this.long = this.container.getAttribute("data-long"),
            this.key && this.initMaps()
        }
        initMaps() {
            loadAPI(this.key).then((()=>"true" === this.enableCorrection && "" !== this.lat && "" !== this.long ? new google.maps.LatLng(this.lat,this.long) : geocodeAddressPromise(this.address))).then((e=>{
                const t = {
                    zoom: parseInt(this.zoomString, 10),
                    styles: mapStyle(this.styleString),
                    center: e,
                    draggable: !0,
                    clickableIcons: !1,
                    scrollwheel: !1,
                    zoomControl: !1,
                    disableDefaultUI: !0
                };
                return createMap(this.mapContainer, t)
            }
            )).then((e=>{
                this.map = e,
                allMaps[this.id] = e
            }
            )).catch((e=>{
                console.log("Failed to load Google Map"),
                console.log(e)
            }
            ))
        }
        unload() {
            void 0 !== window.google && google.maps.event.clearListeners(this.map, "resize")
        }
    }
    const mapSection = {
        onLoad() {
            allMaps[this.id] = new Map(this)
        },
        onUnload() {
            "function" == typeof allMaps[this.id].unload && allMaps[this.id].unload()
        }
    };
    function loadAPI(e) {
        if (null === window.theme.mapAPI) {
            const t = `https://maps.googleapis.com/maps/api/js?key=${e}`;
            window.theme.mapAPI = loadScript({
                url: t
            })
        }
        return window.theme.mapAPI
    }
    function createMap(e, t) {
        var s = new google.maps.Map(e,t)
          , i = s.getCenter();
        new google.maps.Marker({
            map: s,
            position: i
        });
        return google.maps.event.addDomListener(window, "resize", (function() {
            google.maps.event.trigger(s, "resize"),
            s.setCenter(i)
        }
        )),
        s
    }
    function geocodeAddressPromise(e) {
        return new Promise(((t,s)=>{
            (new google.maps.Geocoder).geocode({
                address: e
            }, (function(e, i) {
                if ("OK" == i) {
                    var o = {
                        lat: e[0].geometry.location.lat(),
                        lng: e[0].geometry.location.lng()
                    };
                    t(o)
                } else
                    s(i)
            }
            ))
        }
        ))
    }
    register("map", mapSection),
    register("search", [quickviewSection]);
    const selectors$H = {
        loginToggle: "#AdminLoginToggle",
        newsletterToggle: "#NewsletterToggle",
        login: "#AdminLogin",
        signup: "#CustomerSignup",
        errors: ".errors",
        contactErrors: "#contact_form .errors",
        loginErrors: "#login_form .errors"
    };
    class Password {
        constructor(e) {
            this.container = e.container,
            this.loginToggle = this.container.querySelector(selectors$H.loginToggle),
            this.newsletterToggle = this.container.querySelector(selectors$H.newsletterToggle),
            this.login = this.container.querySelector(selectors$H.login),
            this.signup = this.container.querySelector(selectors$H.signup),
            this.errors = this.container.querySelector(selectors$H.errors),
            this.contactErrors = this.container.querySelector(selectors$H.contactErrors),
            this.loginErrors = this.container.querySelector(selectors$H.loginErrors),
            this.init()
        }
        init() {
            const e = this.login
              , t = this.signup
              , s = this.errors
              , i = this.contactErrors
              , o = this.loginErrors;
            this.loginToggle.addEventListener("click", (function(i) {
                i.preventDefault(),
                slideDown(e),
                hideElement(t),
                s && hideElement(s)
            }
            )),
            this.newsletterToggle.addEventListener("click", (function(i) {
                i.preventDefault(),
                hideElement(e),
                slideDown(t),
                s && hideElement(s)
            }
            )),
            i && (hideElement(e),
            slideDown(t)),
            o && (slideDown(e),
            hideElement(t))
        }
    }
    const passwordSection = {
        onLoad() {
            new Password(this)
        }
    };
    register("password-template", passwordSection);
    const wrap = (e,t="",s)=>((s = s || document.createElement("div")).classList.add(t),
    e.parentNode.insertBefore(s, e),
    s.appendChild(e))
      , selectors$I = {
        promoModal: "#PromoModal",
        close: ".close",
        dataDevMode: "data-dev-mode",
        cookieName: "promo",
        modalWrapper: ".modal__wrapper"
    };
    function showPromo() {
        let e = !1;
        document.querySelector(selectors$I.promoModal) && document.querySelector(selectors$I.promoModal).getAttribute(selectors$I.dataDevMode) && (e = document.querySelector(selectors$I.promoModal).getAttribute(selectors$I.dataDevMode),
        e = "true" === e);
        let t = {};
        t.cookie = {
            configuration: {
                expires: null,
                path: "/",
                domain: window.location.hostname
            },
            name: selectors$I.cookieName,
            write: function(e) {
                (-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((e=>e.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) && (document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`)
            },
            read: function() {
                if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((e=>e.startsWith(this.name)))) {
                    return document.cookie.split("; ").find((e=>e.startsWith(this.name))).split("=")[1]
                }
            },
            destroy: function() {
                if (document.cookie.split("; ").find((e=>e.startsWith(this.name)))) {
                    const e = null;
                    document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`
                }
            }
        };
        if (!(!e && t.cookie.read())) {
            e || t.cookie.write(selectors$I.cookieName);
            const s = document.querySelector(selectors$I.promoModal)
              , i = s.querySelector(selectors$I.close);
            fadeIn(s),
            i.addEventListener("click", (function(e) {
                e.preventDefault(),
                fadeOut(s)
            }
            )),
            s.addEventListener("click", (function(e) {
                e.target === s.querySelector(selectors$I.modalWrapper) && fadeOut(s)
            }
            ))
        }
    }
    document.addEventListener("DOMContentLoaded", (function() {
        load("*");
        "true" === document.body.getAttribute("data-animations") && (AOS.init({
            once: !0
        }),
        document.body.classList.add("aos-initialized")),
        document.addEventListener("lazyloaded", (function(e) {
            const t = e.target.parentNode;
            t.classList.contains("lazy-image") && (t.style.backgroundImage = "none")
        }
        ));
        document.querySelectorAll(".rte table").forEach((e=>{
            wrap(e, "rte__table-wrapper")
        }
        ));
        document.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe').forEach((e=>{
            wrap(e, "rte__video-wrapper")
        }
        )),
        window.self !== window.top && document.querySelector("html").classList.add("iframe");
        "true" === document.body.getAttribute("data-promo") && showPromo(),
        "scrollBehavior"in document.documentElement.style || loadScript({
            url: window.theme.assets.smoothscroll
        })
    }
    )),
    window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies"))
}
)(themeVendor.themeCurrency, themeVendor.themeImages, themeVendor.themeAddresses, themeVendor.Sqrl, themeVendor.Flickity, themeVendor.Rellax, themeVendor.FlickityFade, themeVendor.AOS);
//# sourceMappingURL=theme.js.map

